webpackJsonp([40422678336099],{

/***/ 578:
/***/ (function(module, exports) {

	module.exports = {"sessions":[{"id":"16969","title":"Kotlinアンチパターン","description":"　KotlinはJavaよりもシンプルで安全なコードを書くことができます。また、同じ処理を書く場合も、いくつかのやり方があります。文法に関する説明は、公式ドキュメントを見れば分かりますが、使いどころ、特にAndroidアプリ開発における使いどころについては、まだそれぞれ模索している段階といってよいのではないでしょうか。\r\n　このセッションでは、私がフルKotlinのアプリをチームで開発した経験の中で分かった、Kotlinの各種文法の適切な使いどころや、バグを生みやすいコードのパターンなどを紹介してみたいと思います。\r\n　例えば、lateinitとnull初期化の使い分け、interfaceのデフォルト実装とabstractクラスの使い分け、引数なしの関数とcustom getterの使い分け、定数とlazyとcustom getterの使い分けなどがあります。また、property delegationの使いどころ、スコープ関数の使いどころ、レシーバー付き関数型の使いどころなど、Kotlinの基本文法を紹介しつつ、Androidアプリ開発をした経験からActivityライフサイクルやFragmentライフサイクルに合わせた使いどころ・注意点などについて解説してみたいと思います。","startsAt":"2018-02-08T10:20:00","endsAt":"2018-02-08T10:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["3fe8f4be-5700-44f5-ba97-1a4b4f831ec8"],"categoryItems":[3480,3483,3488,3541],"questionAnswers":[],"roomId":513,"videoUrl":"https://www.youtube.com/watch?v=TmG2YabAyFk","slideUrl":"https://www.slideshare.net/RecruitLifestyle/kotlin-87339759"},{"id":"15575","title":"Android アプリの中を覗いてみよう","description":"Android アプリを使っていて「この機能どうやって作っているんだろう？」と思ったことはありませんか？また、数十MBのアプリに「いったい何が入っているんだろう？」と疑問に思ったことはありませんか？\r\n\r\nAndroid アプリの中身はわりと簡単に覗き見することができます。\r\nこのセッションではAndroid アプリのAPK の中身を覗き見する方法を紹介し、実際に中身を見てみます。面白い発見があるかもしれませんよ？","startsAt":"2018-02-08T11:20:00","endsAt":"2018-02-08T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["2f50ba75-0356-4d2e-8b2b-7343fd3e4377"],"categoryItems":[3480,3483,3500,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=0g2awN1CNuU","slideUrl":"https://speakerdeck.com/toastkidjp/droidkaigi-2018"},{"id":"15904","title":"How to improve your MVP architecture and tests","description":"■対象者\r\n・流行りにのってMVPっぽい設計にしたがあまりメリットが感じられていない人\r\n・MVPやCleanArchitectureを採用したがテストが書けていない人\r\n・設計やテストについて他社の事例や知見が知りたいと思っている人\r\n\r\n■概要\r\nCleanArchitectureを採用し、なんとなくPresenterを作ってみたけれど、Activityとの役割が曖昧で、コードが二箇所に分散しただけでかえってメンテしにくくなってしまった...。そんなプロジェクトに心当たりのある方も多いのではないでしょうか？\r\nこのセッションでは話者が数年間試行錯誤した経験を元に、Model-View-Presenterアーキテクチャを採用したアプリをどのように改善し、よりよい設計にしていくかについての知見を紹介します。\r\nまた、Presenterに対してMockitoなどを使ったテストを有効に書くための手法やTipsなども紹介したいと思います。\r\n\r\n■アジェンダ(仮)\r\n・MVPアンチパターンと改善例\r\n・MVPでテストを書く\r\n　・Presenterのテストの書き方\r\n　・テストライブラリを活用する\r\n　・テストのリファクタリング\r\n　・テストのガイドラインを定める\r\n・Presenterを整理する\r\n　・ドメインモデルを厚くする\r\n　・テンプレートクラスを自動生成する","startsAt":"2018-02-08T11:20:00","endsAt":"2018-02-08T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["1de1a2e2-e88d-4aa1-8d85-58c5466da05d"],"categoryItems":[3480,3483,3488,3541],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=_2LLn42lm74","slideUrl":"https://speakerdeck.com/kirimin/how-to-improve-your-mvp-architecture-and-tests"},{"id":"16633","title":"Inside Android Architecture Components","description":"#概要\r\nAndroid Architecture Componentsは、Android特有のUIコンポーネントの複雑さに対処するために産まれたライブラリです。\r\nGoogle I/O 2017で発表されたとたん、話題の的となったArchitecture Componentsですが、\r\nいったいどのようにして、ライフサイクルイベントを拾い、各コンポーネントはどのように反応しているのでしょうか。\r\nLifecycle, LiveData, ViewModel, Roomの内を覗いて、それらがどう動いているのか、探ってみましょう。\r\n\r\n#対象者\r\n- Android Architecture Componentsを使っている人\r\n- ライブラリの中を覗くのが好きな人\r\n\r\n#話す内容\r\n- Android Architecture Componentsの中身\r\n- Android Architecture Componentsを使うときの注意点など","startsAt":"2018-02-08T11:20:00","endsAt":"2018-02-08T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["299d3761-e25a-4df7-bea1-fe6e391938bd"],"categoryItems":[3480,3483,3488,3540],"questionAnswers":[],"roomId":513,"videoUrl":"https://www.youtube.com/watch?v=7v4pJXy5dhk","slideUrl":"https://speakerdeck.com/kobitokaba/inside-architecture-components"},{"id":"16997","title":"Deep dive into LayoutManager for RecyclerView","description":"RecyclerView is now a de facto standard for representing a large data set into a limited window as a scrollable view.\r\n\r\nOne of the advantages of using it compared to ListView is that RecyclerView can change how the data set is presented in addition to a simple linear list (such as Grid, StaggeredGrid) by changing the LayoutManager attached to it.\r\n\r\nBut it's not well known that you can provide your own LayoutManager to achieve even more flexibility in addition to the three (Linear, Grid, StaggeredGrid) default LayoutManagers provided by the library.\r\n\r\nIn this talk I'm going to explain how you can create your own LayoutManager in details based on the experience that the presenter created a Flexbox implementation as a LayoutManager.","startsAt":"2018-02-08T11:20:00","endsAt":"2018-02-08T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["e3267cf5-b1a7-4ce7-a4b3-223925f21316"],"categoryItems":[3480,3482,3487,3542],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=LzNlC8XVjFs","slideUrl":"https://www.slideshare.net/hagikuratakeshi/deep-diveintolayoutmanager"},{"id":"15897","title":"How to Kontribute","description":"Do you want to send patches to Kotlin? Do you want to know what the best practise of Kotlin development? Do you want JetBrains to list your name in Kotlin blog? This is the talk for you!\r\n\r\nThis talk will explain how to send patches to Kotlin (mainly Kotlin plugin) repository as an external contributor.\r\n\r\nThe expected audience should know the followings:\r\n\r\n* Git/GitHub\r\n* Kotlin syntax\r\n\r\nThe expected outlines are followings:\r\n\r\n* Setup development environment\r\n* Communicating with other developers\r\n* Developing one of Kotlin plugin features\r\n* Implementing unit tests\r\n* Sending a pull request\r\n\r\nAfter this talk, you will be ready to send pull requests to one of the best computer languages in the world!","startsAt":"2018-02-08T12:50:00","endsAt":"2018-02-08T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["892d6f3c-816b-4a97-a135-c315e1ed6471"],"categoryItems":[3481,3482,3496,3541],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=2bmqd5HLKf0","slideUrl":"https://photos.google.com/share/AF1QipMEiTz252QbjFxfzqpFnKOkw42KULxttUyK7Xr-jqGplYEH-OCicnR6NRBuoxwNcw?key=LWdZNFRhd0x4RjRJcWpYb2szNUh5Vm5UaURVdFJn"},{"id":"15984","title":"今から始めるAndroidアプリ開発","description":"このセッションでは、今からAndroidアプリ開発を始めるに当たり、2018年において必要となる基礎的な知識や学習のコツを網羅的に紹介します。\r\n\r\n対象者はまだAndroidアプリ開発をした事がない初学者や、久しぶりにAndroidやってみようかなという人です。\r\n\r\n簡単なサンプルアプリを題材にして、以下のようなトピックに触れます\r\n\r\n* Android アプリの基礎知識 & 用語解説\r\n* レイアウト\r\n* 非同期処理\r\n* ネットワーク通信\r\n* 通知\r\n* 主要なアーキテクチャ\r\n* テストとその自動化\r\n* デバッグ方法\r\n* 最低限必要となる各種便利ライブラリ\r\n* トレンドのキャッチアップ\r\n* etc...\r\n\r\nこのセッションを通じて、スラスラとAndroidアプリが実装できるようなるわけではありませんが、Androidアプリ開発の学習を開始するに当たって必要となる最新の基礎知識を獲得することができます。","startsAt":"2018-02-08T12:50:00","endsAt":"2018-02-08T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["a7714db6-05d1-4976-af00-160e59ca0e17","33bb4b3b-898e-43e5-99d0-be8e0f02865e"],"categoryItems":[3481,3483,3495,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=nTZZRTY0K7I","slideUrl":"https://speakerdeck.com/punchdrunker/how-to-get-started-in-developing-android-app","message":{"ja":"このセッションはRoom7よりRoom2へ変更になりました。","en":"The room of this session was changed from Room7 to Room2."}},{"id":"16498","title":"Android における Model-View-Intent アーキテクチャ","description":"Android上の開発は非同期の扱いを避ける事はできないです。ネットワーク、フレームワーク、ユーザの操作などから非同期処理が発生してます。油断してしまうとアプリが複雑化してメンテナンスが難しくなります。皆様はネットワークからレスポンスを待っている途中、ユーザが画面をローテーションしても問題ないですか？並行してユーザがいろんな操作しても大丈夫でしょうか？\r\n\r\nModel-View-Intent アーキテクチャは非同期処理が発生する前提で考えられたため、すべてがストリームとして扱ってデータの流れを一方通行にするかつ不変オブジェクトを使うのが MVI アーキテクチャの方針です。マルチスレッディングやAndroidのライフサイクルの対応から生じる問題がアーキテクチャによって解決されるおかげでアプリのロジックに集中できるようになり、コードが書きやすく、今後の保守も楽になります！\r\n\r\n皆様が MVI アーキテクチャの強みを理解し自分で実現できるようにする目標で Kotlin と RxJava を使って並行処理、画面ローテーション、スナックバーを含んだ画面をどうやって作っていくかを語るつもりです！","startsAt":"2018-02-08T12:50:00","endsAt":"2018-02-08T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["449b4215-55cc-444f-8ff4-b0c434a96019"],"categoryItems":[3481,3483,3488,3541],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=MIV7Mi9zko8","slideUrl":"https://speakerdeck.com/oldergod/android-niokeru-model-view-intent-akitekutiya"},{"id":"16888","title":"Androidで動画コンテンツを扱うTips","description":"▶対象\r\n・Androidで動画を扱うアプリに携わっている人\r\n・Androidの動画周りに興味がある人\r\n\r\n▶概要\r\n画像やテキストが主流だった時代から動画の時代へと移り変わってきました。そこで、今回はAndroidで動画を扱うために必要なTipsなどをお話できればと思います。\r\n動画Player周りでは、Androidで主流になっているExoPlayerを使って説明していく予定です。\r\n最後にインスタのライブ配信やFacebookライブの様なライブ配信をAndroidでどう実現するかや実際にそのデモを行います。\r\n\r\n▶内容\r\n・動画の配信Protocolと概要 (MPEG-DASH, HLS)\r\n・Androidでの動画再生 with ExoPlayer\r\n・ExoPlayerでできることとその内部実装\r\n・Androidで動画配信\r\n・Androidでライブ配信 (デモ) ","startsAt":"2018-02-08T12:50:00","endsAt":"2018-02-08T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["fbb08aa9-7aa1-4b70-b676-32905f5fd8d9"],"categoryItems":[3481,3483,3500,3541],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=jHonnvdmNuE","slideUrl":"https://speakerdeck.com/takusemba/droidkaigi-1"},{"id":"16935","title":"Android Back to the Future","description":"2008年にリリースされて以来、Androidは猛烈なスピードで進化し、多くの開発者に愛されて発展してきました。\r\n\r\n本セッションではこの9年間の（そしてAndroidが生まれる前にどのような設計思想を持って作られたかという点も踏まえて）アーキテクチャの進歩を振り返り、アプリケーション設計のトレンドを予測します。\r\n\r\n通常のセッションではなく、聴講者と発表者が対話し、ディスカッションしていく（TEDのような）スタイルにて講演を実施します。これまでやったことがないチャレンジングな手法です。\r\n\r\n講演を通じて、Androidの根底を支えるライフサイクル、ActivityやView、XMLによるUIの分離という設計思想からMV-Whateverなどのアプリケーションのデザインパターンに至るまで、そして今後どのような未来に向かっていくか、Architecture Componentsなどが登場した経緯を紹介します。\r\n\r\nディスカッションしながらすすめることで、これらのライブラリ、デザインパターンが解決したかった問題に触れられます。参加者がAndroidの歴史を追体験でき、単純に学ぶよりも楽しく学べ、初学者から中級者の理解を助けます。\r\n\r\n\"2017年の東京、新宿に住むエンジニア、マーティ・マクフライはAndroid歴史学者であるドロイド博士（通称ドク）を手伝って、タイムマシンの実験を行う。タイムマシンに改造されたデロリアンDMC-12が到着した先にはガラケーしか存在しない時代だった。デロリアンに乗った2人は現代のAndroidまで帰ってこれるのか？！\"\r\n","startsAt":"2018-02-08T12:50:00","endsAt":"2018-02-08T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["b884cf72-b5c9-471b-a874-7f0ba379561d"],"categoryItems":[3481,3483,3488,3540],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=O-VNWRrPxyc","slideUrl":"https://www.slideshare.net/mhidaka/droidkaigi-2018-android-back-to-the-future"},{"id":"16141","title":"How to love developers like your customers","description":"In this talk I'll show how you can increase developer productivity of your Android Teams by adding simple debug features to your app, hacking gradle and Android Studio to turn your Devs into Super Heroes who ship much better products faster than ever.\r\n\r\nEverybody talks about Design, Architectures, Libraries and what not, but, what we often forget is that most of the times quick wins for us as developers can be much more beneficial than tackling large refactors to use the latest technologies available so if we apply the 80-20 rule to our development workflow we can achieve so much more. \r\nPeople with any level of android experience can see this talk.","startsAt":"2018-02-08T14:00:00","endsAt":"2018-02-08T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["03c63012-49c4-44eb-af96-0f5360b0d187"],"categoryItems":[3480,3482,3498,3540],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=-flI_-NvvTI","slideUrl":"https://docs.google.com/presentation/d/12hjzZplD6eDQn1CuwUWZaR-0aZu6TppImZAqePAm7h0/edit#slide=id.p"},{"id":"16381","title":"Kioskアプリと端末の作り方","description":"特定用途に特化した専用端末は、Kiosk端末と呼ばれています。\r\n例：ATM、切符販売機、店舗の予約受け付け端末など\r\n\r\n本セッションではAndroid 5.0から追加されたDeviceOwnerを活用し、\r\n下記の要件を満たすAndroidのKiosk端末化についてご紹介します。\r\n\r\n* 通常操作では、専用アプリ（Kioskアプリ）以外の画面には遷移できない\r\n* 端末を再起動しても、強制的にKioskアプリが立ち上がる\r\n* 特定の手順を踏むと、Kioskアプリ以外の画面に遷移できる\r\n\r\nまた、Kioskアプリ固有の問題とその対処についてもお話しする予定です。","startsAt":"2018-02-08T14:00:00","endsAt":"2018-02-08T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["22eebb4b-dad2-4d32-a2db-989ac14e559c"],"categoryItems":[3480,3483,3500,3542],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=ofUJaIiaVlw","slideUrl":"https://docs.google.com/presentation/d/1K9-Tn13yRAyOmN480DhchDTchVANaUDMn5y4gvRpoLc/edit"},{"id":"16511","title":"DataBindingのコードを読む","description":"AOSPにて公開されてるDataBindingのコードを読み、実際にどのような仕組みになっているか、デバッグ方法等を簡単に紹介します。\r\nまた、実際にパッチを投げた話も紹介したいと思います。\r\n\r\n# 対象者\r\nDataBindingに興味のある人\r\n\r\n# 予定内容\r\n* DataBindingの仕組み\r\n* DataBindingのデバッグ方法\r\n* AOSPへパッチの送り方\r\n* バグ修正した話","startsAt":"2018-02-08T14:00:00","endsAt":"2018-02-08T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["f4445e26-7dff-4294-9ae9-321e26e9c183"],"categoryItems":[3480,3483,3495,3540],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=E_auvSAm9t8","slideUrl":"https://speakerdeck.com/star_zero/databindingfalsekodowodu-mu-droidkaigi-2018"},{"id":"16539","title":"ピュアJavaだと思った？残念Androidでした ～いつからAndroidをJavaだと錯覚していた？～","description":"■概要:\r\nAndroidのJavaとOracleのJavaは微妙に異なると言われていますが、普段その違いを意識することはあまりありません。\r\n実際、「だいたいJava6ぐらいかなー」って思っていればうまくいくことが多いと思います。\r\nそこで今回は「全く同じJavaコードを書いてもOracleのJVMとAndroid Runtimeで異なる動作をすることがある」っていうのを紹介したいと思います。\r\n題材にするのはよく使われるArrayListです。\r\n\r\n■対象者:\r\nJavaでArrayListを使ったことがある。\r\nif文やfor文、拡張for文、Iteratorなど、Javaの基本的構文を書いた or 読んだことがある。\r\n世界にはJavaコードから生成されたプログラムを動かす実行環境がたくさんあるらしい(OracleのJVM、Dalvik仮想マシン、Android Runtime)\r\nことを知ってる。(これを読んだあなたはもう知っているので対象者です)\r\n\r\n\r\n■目次\r\n・普通に書けば、普通に同じ動作をする\r\n・ArrayListを拡張for文で回す←ここまでは同じ\r\n・for文中にあることをすると・・・おおっと\r\n・大丈夫なこともある？\r\n・なぜ大丈夫なこともあるのか？\r\n・Javaは不思議だなぁ。AndroidもJavaだもんね、同じことが・・・\r\n・ピュアJavaだと思った？残念Androidでした\r\n・AndroidはJavaとAPIが同じなだけ ～いつからAndroidをJavaだと錯覚していた？～\r\n・ネタばらし\r\n・もちろん逆パターンもあるぞ\r\n・その他の事例もあるぞ(先駆者紹介)\r\n\r\n注意：このセッションは好奇心を満たすだけで、明日使えるテクニックは何もありません","startsAt":"2018-02-08T14:00:00","endsAt":"2018-02-08T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["47118070-f7b6-43e1-b57b-527e75e21a4f"],"categoryItems":[3480,3483,3500,3542],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=5OY4U8TeouM","slideUrl":"https://www.slideshare.net/JSUXDesign/javaandroidandroidjava"},{"id":"16942","title":"はじめてのUnit Test","description":"ここでははじめてAndroidでUnit Testを書く人、これからUnit Testを増やしていきたい人を対象としたハンズオンを行います。\r\n\r\n・基本的なアサーション\r\n・Mockitoを使ったモックやスパイ\r\n・SQLiteを使った部分のUnit Test\r\n・Robolectricを使ってAndroidフレームワークのコードを利用した部分のUnit Test\r\n・非同期処理のテスト\r\n\r\n等をカバーします。\r\n対象とするコードはDroidKaigi公式アプリ等の実践的なものとし、より現場に近い状況でどのようにUnit Testを書いていくかにフォーカスしたいと思います。","startsAt":"2018-02-08T14:00:00","endsAt":"2018-02-08T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["78606c3b-8fc6-4960-9ed2-6005feaa439c"],"categoryItems":[3481,3483,3497,3540],"questionAnswers":[],"roomId":517,"videoUrl":"","slideUrl":"https://github.com/srym/DroidKaigi2018UnitTestHandOn"},{"id":"16949","title":"Widget開発再訪","description":"■対象\r\n・Widgetに関心がある方\r\n・Widgetをこれからつくりたい方\r\n・Widgetをつくられたことのある方\r\n\r\n■概要\r\n　Widgetはメインのアプリにバンドルして提供されるミニアプリです。Widgetにより、アプリの機能やコンテンツに、ホーム画面からスムーズにアクセスできるようになります。アプリを開かずとも、ユーザーが必要な情報に触れることができるため、コンテンツへのエンゲージメントを高めることができます。\r\n　今までWidgetは、アプリインストール後にホーム画面から別途追加する必要があり、登録フローがユーザーに分かりにくい状態でした。しかし、Android O からWidget機能が強化され、アプリの中からWidgetの追加を行えるAPIが提供されるようになりました。\r\n　本セッションでは、この新APIを踏まえて、Widgetの実装についてお話致します。Widget特有の実装方法や重要な内部APIの挙動、開発における注意点などについてもご紹介するつもりです。","startsAt":"2018-02-08T14:00:00","endsAt":"2018-02-08T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["00f8c0a3-55cc-4c3a-af45-730fe03ea6b8"],"categoryItems":[3480,3483,3495,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=RQbPIW0q-_w","slideUrl":"https://speakerdeck.com/ymnder/widgetkai-fa-zai-fang"},{"id":"17012","title":"gomobile でゲームを作る","description":"Go言語を用いて Android 向けゲームを作る手法について紹介します。Go言語で Android 向けゲームを作る方法はいくつかありますが、ここでは特に gomobile という Go言語公式のツールを使った手法について取り上げます。gomobile を使うことで、Go言語のみを用いて Android アプリを作ることができます。ゲームでない通常のアプリを作ることも出来ますが、gomobile は非常に限られた機能しか提供しないため、gomobile で何が出来て何が出来ないのか、あらかじめ考慮が必要です。gomobile で出来ること、ないし使用上の留意点、ハマリどころ等を、実際に使い込んだユーザーの観点から解説します。","startsAt":"2018-02-08T14:00:00","endsAt":"2018-02-08T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["85edff9d-f1b2-4f38-a196-c77679f0de3b"],"categoryItems":[3480,3483,3500,3542],"questionAnswers":[],"roomId":520,"videoUrl":"https://www.youtube.com/watch?v=sTDbhZgt6Io","slideUrl":"http://pankona.github.io/slides/droidkaigi_2018.html"},{"id":"15567","title":"Say bye to Fragments with Conductor & Kotlin","description":"Have you ever got a crash because you did something wrong with a Fragment? I did, many times! Fragments are not easy to use, and many experts even recommend to avoid them. But what is the alternative? We tried Conductor, we liked it and I am going to show you what can you do with it.\r\n\r\nIn this talk you will learn:\r\nThe basics of Conductor: Routers and Controllers.\r\nConductor and the new Architecture Components from Google.\r\nNavigation from Controller to Controller.\r\nHandling configuration changes with Controllers.\r\nRetaining views vs. recreating them.\r\nRunning espresso tests on a single Controller.\r\n...and of course everything in Kotlin!\r\n\r\nBy the end of the talk you will want to start using Conductor on your next project!","startsAt":"2018-02-08T14:50:00","endsAt":"2018-02-08T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["c3260fa6-446b-40ba-94c0-78d946312a64"],"categoryItems":[3480,3482,3488,3541],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=rsmvQBGJYcM","slideUrl":"https://speakerdeck.com/miquelbeltran/say-bye-to-fragments-with-conductor-and-kotlin"},{"id":"16589","title":"AndroidとCPU","description":"# 概要\r\nAndroid端末に使われている CPU は多種多様にある。ARMアーキテクチャーとは？から、それぞれのメーカーが作った Snapdragon, Exynos, kirin, MediaTek などのCPUの性能の違いや歴史を話したいと思います。またスマートフォン端末ではあまり話に上がらないGPUについても話せれたなと思います。\r\n\r\n# 話す内容（予定）\r\n- AndroidとCPUの歴史\r\n- ARMアーキテクチャーとは\r\n- CPUの種類と性能差\r\n- 最新スマートフォンの性能\r\n- スマートフォンとGPU","startsAt":"2018-02-08T14:50:00","endsAt":"2018-02-08T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["bfcf3bb1-58b9-4200-be9a-9cb077589bfe"],"categoryItems":[3480,3483,3500,3540],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=KvnnG-OL0-k","slideUrl":"https://speakerdeck.com/eggpogg/androidtocpu"},{"id":"16679","title":"タッチイベントを捕まえよう","description":"タッチ操作で意図通りにぐりぐり動くUIを作りましょう。\r\n\r\nAndroidでは多くのコンポーネントが提供されており、標準的な操作への対応であれば、タッチイベントのハンドリングをアプリで独自実装しなければならないシーンは少ないと思います。\r\nしかし、少し凝った操作系を作ろうとすると、独自にタッチイベントを捕まえ動きを実装する必要があります。\r\nこのタッチイベントのハンドリングは奥が深く、ドラッグとタップ両方できるようにする、複数本の指でピンチもできるしフリックもできるなどを実現しようとするとタッチイベントに対する深い理解が不可欠です。\r\n\r\nAndroidのタッチイベント伝搬の仕組みや、MotionEventが保持する情報といった基本的な説明、マルチタッチへの対応、陥りがちなポイント、有用なユーティリティの説明などを交えつつ、ぐりぐりと意図通りに動くUIの作り方を説明します。","startsAt":"2018-02-08T14:50:00","endsAt":"2018-02-08T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["c27d048c-8c02-4de5-84fb-606de1cc2447"],"categoryItems":[3480,3483,3487,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=3WxQ5GsCOdw","slideUrl":"https://onedrive.live.com/view.aspx?resid=65E110C1933A7330!1906&ithint=file%2cpptx&app=PowerPoint&authkey=!AJEmSN_E2n8X7RY"},{"id":"16680","title":"MediaCodecで動画編集をしてみよう","description":"動画の時代が来ると、数年前から言われており、動画を扱う案件が増えていると思います。\r\nしかし、MediaCodecを使用した動画編集に関する情報はネット上にもとても少ないです。\r\nそこでMediaCodecを使った動画編集を、サンプルと共に情報公開をしたいと思います。\r\n\r\n目次案（検討中）\r\n\r\n* MediaCodecの概要\r\n* OpenGLESの概要\r\n* MediaCodecとOpenGLESで動画にフィルターをつける。\r\n* MediaCodecとOpenGLESで動画にウォーターマークをつける\r\n* まとめと個人的な所感","startsAt":"2018-02-08T14:50:00","endsAt":"2018-02-08T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["5ccaa6ed-b606-4a8c-a499-73a00c6c8170"],"categoryItems":[3480,3483,3492,3542],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=7jALfaXOhJU","slideUrl":"https://speakerdeck.com/masayukisuda/mediacodecdedong-hua-bian-ji-wositemiyou"},{"id":"16922","title":"AndroidTV Oreo Dip","description":"AndroidTVデバイス向けのOreo対応進んでいますか？\r\nAndroidOから新たに追加されるRecommendations Channelsの話を中心とした、AbemaTVでの開発のTipsを紹介します。\r\nまたテレビデバイス向けのUI改善についての小話も紹介します。","startsAt":"2018-02-08T14:50:00","endsAt":"2018-02-08T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["e52982d7-5a75-4c91-ab2d-7882c06fa5b2"],"categoryItems":[3480,3483,3494,3542],"questionAnswers":[],"roomId":520,"videoUrl":"https://www.youtube.com/watch?v=q7b4chco450","slideUrl":"https://speakerdeck.com/kaelaela/androidtv-oreo-dip"},{"id":"16970","title":"まだAPI定義管理で消耗してるの？〜Swaggerを用いた大規模アプリ時代のAPI定義管理とコードジェネレート〜","description":"昨今のアプリ開発は大規模になってきており、モバイルアプリのエンジニアとサーバサイドのエンジニアが分担し開発することも多いと思います。\r\n\r\nその際、仕様を含めたAPI定義のすり合わせ、変更についての情報共有などの円滑なコミュニケーションが必要になります。\r\n\r\nまた、API定義の変更に関してはモバイルアプリは漏れがないように迅速に追従していく必要があります。\r\n\r\n本セッションでは、API定義を管理するSwaggerに焦点を当てます。\r\n\r\nまた、Swaggerを用いてAPI定義からJSONのマッピングオブジェクトを自動生成することにより工数削減と品質向上を図り、生産性を高める方法を紹介します。\r\n\r\n- Swaggerとは\r\n- Swaggerを用いたAPI定義\r\n- AndroidにおけるSwagger Code Generatorを用いたコード自動生成\r\n- （時間があれば）mustache記法について","startsAt":"2018-02-08T14:50:00","endsAt":"2018-02-08T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["45452775-8fad-454b-9e38-770059319f95"],"categoryItems":[3480,3483,3489,3540],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=jtfqgsU4SMo","slideUrl":"https://speakerdeck.com/magiepooh/madaapiding-yi-guan-li-dexiao-hao-siterufalse-swaggerwoyong-itada-gui-mo-apurishi-dai-falseapiding-yi-guan-li-tokodozienereto"},{"id":"15559","title":"Embeddinator-4000でAndroid Studioから.NETのコードを利用する","description":"XamarinのMonoチームが開発しているプロジェクトのひとつに、Android StudioやXcodeから.NETやXamarinのライブラリを利用できるEmbeddinator-4000というものがあります。Xamarin.AndroidやXamarin.iOSを使わなくてもC#のコードが再利用できる仕組みです。\r\n\r\n本セッションでは、このEmbeddinator-4000を使って、Android StudioからC#のコードを再利用する方法を説明し、またその技術的背景を解説します。\r\n\r\n技術的背景の説明はある程度の技術知が必要かもしれません（monoやXamarinに関する前提知識はあまり求めません）。Android開発者が関心をもちそうなトピックは、Javaと他言語（今回の場合はMono/.NET）の相互運用の部分です。Xamarinの低レベルの仕組みもある程度解説することになると思います。\r\n\r\nセッションの構成（予定）\r\n- Embeddinator-4000とは（Xamarin.Androidとの違いなど）\r\n- Embeddinator-4000の使い方\r\n- 技術的背景の解説\r\n  - 組み込みmono\r\n  - Androidとの相互運用","startsAt":"2018-02-08T15:40:00","endsAt":"2018-02-08T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["3262db6c-d659-4109-a410-2b8dac1bf737"],"categoryItems":[3481,3483,3498,3541],"questionAnswers":[],"roomId":520,"videoUrl":"https://www.youtube.com/watch?v=9Ef2yDNnyJc","slideUrl":"https://speakerdeck.com/atsushieno/embeddinator-4000-using-net-libraries-in-android-studio"},{"id":"16079","title":"Authentic Developers","description":"Shame is the most powerful, master emotion. It’s the fear that we’re not good enough. \r\n\r\nVulnerability is about showing up and being seen. It’s tough to do that when we’re terrified about what people might see or think. \r\nBrené Brown\r\n\r\nWe live in a society that's motivated by comparison, in a culture in which everything you do is never enough, one in which you are constantly engaging with people using shame, either to shame or to be shamed, and in which making yourself vulnerable – exposing your fears and uncertainties, taking emotional risks - is considered a form of weakness, and something most of us want to run away from.\r\n\r\nBut as an Android developer you cannot run away from being vulnerable. No matter your level, you will be constantly exposed, you are constantly vulnerable. With pull requests, stack overflow (questions or answers), blog posts, talks.. You are being vulnerable. Unfortunately that means you are also more exposed to being shamed, to being told off on how wrong you are, or how little knowledge you have. This kind of behavior can be toxic and can lead to people feeling insecure about themselves (hello impostor syndrome). \r\n\r\nIt's not only you. This is something that affects all of us the moment we decide to be developers. And it has an impact in our growth, our jobs and the way we interact back with the community. \r\n\r\nI want to explore what shame and vulnerability really are, how we perceive it and how it affect us in the core of our interactions and our job. What makes Android developers vulnerable. Learn the tools we are already using to fight against shaming behaviour, and what we can do in our day to day job to make it even better. \r\n\r\nWith this talk I want everyone to leave the talk knowing they are good enough, they are brave enough, and they can put a stop to toxic behavior we don't realize we do.","startsAt":"2018-02-08T15:40:00","endsAt":"2018-02-08T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["af079576-c7db-497a-990d-919fc2472e45"],"categoryItems":[3481,3482,3490,3542],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=RL3nE78WdLI","slideUrl":"https://speakerdeck.com/anastasialopez/authentic-developer"},{"id":"16710","title":"素晴らしいNDKの世界 / Building High Performance Android Apps with NDK","description":"NDKを使って高パフォーマンスなアプリケーションを作成する手法、チップス、APIなどを紹介します。\r\n本セッションは日本語、英語混合セッションとなります。\r\n・C++を使ったAndroidプログラミング\r\n・Android電話向けパフォーマンスチューニング手法\r\n　・systrace, simpleperf等紹介\r\n・CPU governor挙動について\r\n・Android NDK packaged the necessary API and tools to create  low latency audio apps , high end graphics games, stunning video/camera apps, and accelerated Machine Learning applications; plus tools and Android Studio IDE to make creating Android high performance applications an pleasant experience. Goes through Audio, Graphics, Camera, Tools and Studio IDE to help developers to create compelling high performance Android applications.","startsAt":"2018-02-08T15:40:00","endsAt":"2018-02-08T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["7b71b1fd-bf15-4721-883f-32b90d7a4a91","bdb86449-b985-4e60-bc03-19f5bcf2f4d4"],"categoryItems":[3481,5379,3498,3542],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=_d5HIJnG7vg","slideUrl":""},{"id":"16928","title":"Espressoテストコードの同期処理を究める","description":"■対象者\r\n・Espressoで自動テストを書いてみたものの、不安定なテストが多くて困っている方\r\n・Espressoでテストを自動化する範囲をより広げて行きたい方\r\n\r\n■概要\r\nAndroidのUIテストツールであるEspressoの特徴の1つに、\r\n「UI操作に関する同期(待ち合わせ)処理を自動的にやってくれる」\r\nというものがあります。\r\n公式ドキュメントによると、この自動同期機能の恩恵により、\r\nテストコードで明示的にwait/sleep/pollingを書く必要がなくなる、とも書かれています。\r\n\r\nところが、RxJavaなどの非同期処理を主体としたフレームワークが広く採用されるようになってから、Espressoの自動同期機能がうまくいかず、UIが更新される前に次の操作が実行されてしまい、テストが失敗するケースに直面することが多くなってきました。\r\n\r\n皆さんの中にも、UI更新の待ち合わせがうまく行かず、その場しのぎにsleepを挿入した経験の有る方がいらっしゃるのではないでしょうか？\r\n\r\nこのセッションでは、Espressoの自動同期処理が何をしてくれるものなのか？\r\nEspressoの自動同期処理でうまく行かないときにどうすれば良いのか？\r\nという疑問を解決すべく、最新のEspresso 3.xの実装にもとづいて、以下の内容について解説します。\r\n\r\n・Espressoが提供する自動同期機能が保証してくれること・くれないこと\r\n・Espressoの同期処理をカスタマイズするIdlingResource APIの概要\r\n・Espressoが提供しているIdlingResource実装の紹介と、その使い道\r\n  (一例として、RxJavaの非同期処理を待ち合わせる方法も紹介します)\r\n・最後の手段: IdlingResourceを使わずに、簡単に同期を取る方法\r\n\r\nこのセッションを聴いた方が、\r\nタイミングによって失敗してしまうような、\r\n不安定なEspressoテストを自力で修正できるようになることを目指したいと思います。","startsAt":"2018-02-08T15:40:00","endsAt":"2018-02-08T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["b64b9957-1570-41b7-99b5-b727676ef23c"],"categoryItems":[3481,3483,3493,3541],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=68dLpoK__uM","slideUrl":"https://speakerdeck.com/sumio/synchronization-capabilities-of-espresso"},{"id":"16978","title":"MVVMベストプラクティス","description":"●概要\r\n　AndroidアプリのアーキテクチャパターンとしてMVVMが採用されることが多くなりました。Androidではデータバインディングがサポートされており、効率的にMVVMで実装を行うことができます。しかし、実際にMVVMで開発をしようとすると様々な問題に遭遇します。そのような問題に対応するためのポイントを紹介します。\r\n（プログラミング言語はKotlinを想定します）\r\n\r\n●アジェンダ（予定）\r\n・MVVM開発で直面する問題\r\n・関心の分離\r\n　・関心の分離を意識してViewModelの肥大化を防ぐ\r\n　・画面遷移・ダイアログ\r\n　・Contextの扱い\r\n・RecyclerView\r\n・データフロー\r\n　・データフローを単純化して複雑化を防ぐ","startsAt":"2018-02-08T15:40:00","endsAt":"2018-02-08T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["2a91cf02-04ac-4d01-8643-71fc48c3f1fa"],"categoryItems":[3481,3483,3488,3541],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=PVZSG_2RGqI","slideUrl":"https://speakerdeck.com/cheesesand101/mvvmbesutopurakuteisu","message":{"ja":"このセッションの概要は変更されました。","en":"The description of this session was updated."}},{"id":"17013","title":"実例で理解するMaterial Design Animation","description":"Material designで実装するアプリケーションにはSharedElementTransitionを始めとする、脳に優しい、美しいアニメーションが必要不可欠です。ですが、いざ実装を開始すると、様々な細かな仕様で躓くことも少なくありません。\r\n\r\nこのセッションでは、そんなアニメーションの実装を実例とともにコードベースで解説をしていきたいと思っています。\r\nサンプル的な意味合いの強いプロジェクトではなく、実際にリリースされているアプリのコードをもとに解説していきます。\r\n\r\nまた実装する際には、アニメーションを実際に考えるデザイナーの人とどのようにコミュニケーションを取る必要があります。その際のこつや、どのようにコミュニケーションを取っているか、についても同時に紹介したいと思っています。\r\n\r\n- アニメーションの紹介\r\n- 実装手法の説明\r\n- どんなトリックが存在するのか\r\n- 効率的なアニメーションデバッグの方法\r\n- デザイナーとのアニメーションに関するコミュニケーション方法\r\n- どこまで頑張るかの線引き\r\n\r\nなどについてお話しします。\r\n\r\n対象者：Animation実装に苦手意識のある人/初級者","startsAt":"2018-02-08T15:40:00","endsAt":"2018-02-08T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["2454ad67-5017-49fa-b57a-433f02f4a7ab"],"categoryItems":[3481,3483,3487,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=qLqm9FScQxk","slideUrl":"https://speakerdeck.com/wakwak3125/shi-li-deli-jie-suru-material-design-animation"},{"id":"15880","title":"USB接続するアプリを開発した時に試行錯誤した事","description":"USB接続するアプリを開発した経験がある方はいらっしゃいますでしょうか？ほぼいらっしゃらないですよね。このセッションでは今後みなさんに役立つかどうかはわかりませんが、USB接続してデータのやりとりをするアプリを開発した時の事をお話します。\r\n\r\nUSB接続するための基礎的な部分をまず説明したのちに、実際にどのように開発・デバッグを進めていったか。ハマりどころについてお話していきます。\r\n詳細な内容としては以下の通りです。\r\n\r\n# USB接続を扱う時の基礎知識\r\n## Accessory modeと Host mode\r\n- 今回はAccessory modeでUSB接続するアプリを作りました\r\n## 基本的な使い方の説明\r\n## USB接続周りの権限は特殊\r\n\r\n# USB接続するアプリの開発\r\n## どんなUSB接続するアプリを作ったか？\r\n## ハードウェアがまだ出来ていない時にどうやって開発していたか？\r\n## USB接続しているのでデバッグが大変\r\n## ハマりどころ\r\n- ActivityでしかUSB接続を検知出来ない\r\n- 特定の機種でとある条件でUSB接続のイベントが飛んでこない\r\n- close処理を忘れるとUSBを抜き差ししないと二度接続が出来ない\r\n- 物理的にはささっているけど、USBのDETACHEDとATTACHEDが連続して呼ばれてしまう","startsAt":"2018-02-08T16:50:00","endsAt":"2018-02-08T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["eeb62c90-d5d3-46c7-a672-40770d4cfa54"],"categoryItems":[3480,3483,3492,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=Mgq-a6wrUHY","slideUrl":"https://www.slideshare.net/masatakakono1/usb-87470849"},{"id":"15899","title":"マルチモジュールのすヽめ","description":"自分の関わるAndroidのアプリ開発ではマルチモジュールな作り方を実践しています。\r\nその中で得られた知見を共有します。\r\n\r\n下記がagenda(仮)です。\r\n\r\n- マルチモジュールに分けた動機\r\n- メリット\r\n- デメリット\r\n- 技術的な実現方法\r\n- ハマりポイント & 気をつける場所\r\n- 途中からマルチモジュール化する\r\n- etc","startsAt":"2018-02-08T16:50:00","endsAt":"2018-02-08T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["e57f43fb-f258-4743-b6bf-cb843bc9185a"],"categoryItems":[3480,3483,3488,3541],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=s1nd_GrA56s","slideUrl":"https://speakerdeck.com/kgmyshin/multi-module-no-susume"},{"id":"16844","title":"Kotlin版CleanArchitectureのテンプレート作ったら爆速開発になった話＋α","description":"CleanArchitectureは各レイヤーごとに役割が明確に決まっており、大規模開発などに非常に向いている。\r\nしかし一方、大きなデメリットとして\r\n・DI周りの実装がそもそも解りづらい(特にDagger)\r\n・クラス数が多くなる→単純に作業量、コード量が増える＆ケアレスミスですぐ動かなくなる\r\n・CleanArchitectureの構造を理解していないとオレオレ実装が蔓延る\r\nといったものがあるのではないだろうか。\r\n\r\nそこで注目したのがKotlinとTemplateの存在。共通のテンプレートを作成し、それを使うことで、\r\n・DIの実装が解りづらい？→Templateがやってあげるよ\r\n・作業量が増える？→Templateがやってあげるよ\r\n・コード量が増える？→KotlinだからJavaより減るよ＆読みやすいよ\r\n・ケアレスミス？→Templateがミスしやすそうなところは全部やるよ\r\n・オレオレ実装？→みんな同じTemplate使えば差異がぐっと減るよ\r\nという状況を作り出した。\r\n\r\n本発表では、上記のCleanArchitectureのデメリットを減らし、最大限活用したら開発が爆速になったお話に加え、CleanArchitectureを採用したことで得られたメリットについてお話しようと思います。","startsAt":"2018-02-08T16:50:00","endsAt":"2018-02-08T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["71ab9dce-6536-49e5-8a23-e60a2e703ba0"],"categoryItems":[3480,3483,3488,3541],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=tGBvYlQ6MJ8","slideUrl":"https://speakerdeck.com/kiuchikeisuke/kotlinban-cleanarchitecturefalsetenhuretozuo-tutarabao-su-kai-fa-ninatutahua-a"},{"id":"16857","title":"Faster Builds with Android Plugin for Gradle 3.0.0+","description":"Builds can always be faster. Whether you are a lone developer or a large team, a 10% build speed improvement adds up over the course of a project. And your time is important.\r\n\r\nIf you're an Android Developer using Android Studio, you are already familiar with the Gradle build system and the Android plugin. The great news is that Android Plugin 3.0.0 and higher include major changes that bring significant performance improvements to large multi-module projects—in some cases, we've experienced builds that are 3-5X faster! Some of the improvements include:\r\n\r\n* Better parallelism for multi-module projects through a fine grained task graph.\r\n\r\n* Variant-aware dependency management. (When building a certain variant of a module, the plugin now automatically matches variants of local library module dependencies to the variant of the module you are building.)\r\n\r\n* Compilation avoidance via new dependency configurations.\r\n\r\n* Faster incremental build speed due to per-class dexing. Each class is now compiled into separate DEX files, and only the classes that are modified are re-compiled.\r\n\r\n* Faster resource packaging with AAPT2 enabled by default.\r\n\r\nIn order to bring about these improvements, there are some breaking changes in the plugin behavior, Domain Specific Language (DSL), and APIs.\r\n\r\nIn this talk, a member of the Android Studio team shows you how to easily migrate your project to the new plugin, resolve build errors, optimize your build configuration, and prepare your project to take advantage of future improvements to the plugin.","startsAt":"2018-02-08T16:50:00","endsAt":"2018-02-08T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["532dc16d-b69d-4f68-aa49-fe9878b0b52f"],"categoryItems":[3480,3482,3498,3541],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=onz5t29oBcU","slideUrl":""},{"id":"16865","title":"Annotation Processingを駆使したコード生成でボイラープレートコードを駆逐しよう！","description":"# 概要\r\nJava6から登場しているPluggable Annotation Processing API。  \r\nDagger2やButterKnifeなどメジャーなライブラリで使われてるのは見たことあるけど自分で触ったことはないという人が多いのではないでしょうか？  \r\n普通にアプリを作っているだけだと中々触れる機会がないけど奥が深いこの機能、Android開発にどう活かすことができるのかを解説します。  \r\n\r\n# 対象者\r\n- 毎回似たようなお決まりのコードを書くことが多い方\r\n- Annotation Processingって聞いたことあるけどいまいち何してるのかよくわかってない方\r\n- コード生成という単語にビビッと来たそこのあなた\r\n\r\n# 目次(予定)\r\n- そもそもどんなことができるのか\r\n- アノテーションとコード生成\r\n- JavaPoetとKotlinPoet\r\n- Android開発の現場においてどのように活用できるのか\r\n- Kotlinから使う場合の注意点\r\n\r\nなどを私自身が作成、公開しているライブラリのコードを交えて紹介します","startsAt":"2018-02-08T16:50:00","endsAt":"2018-02-08T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["3a59fd95-4771-4e9f-b61e-fd2b3ab288b4"],"categoryItems":[3480,3483,3500,3540],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=3dHFKeTFwvI","slideUrl":"https://speakerdeck.com/kazakago/annotation-processingwo-qu-shi-sitakodosheng-cheng-de-boirapuretokodowoqu-zhu-siyou"},{"id":"16948","title":"アプリの鍵が消える時","description":"[内容]\r\n大切なデータを守るために、暗号化は有効な手段ですが、同時に鍵を安全に扱う方法を考える必要があります。\r\nAndroidでは、バージョン4.3以降で「Android Keystore プロバイダ」が提供され、アプリだけが使える鍵を管理出来るようになりました。\r\nただし、この鍵はユーザーの操作によって消えることがある仕様になっています。\r\n本セッションでは、「Android Keystore プロバイダ」の基本的な使い方と鍵が消える条件を解説すると共に、鍵が消えることを想定した使い方について考察します。\r\n\r\n[セッション構成]\r\n-Android Keystore Providerとは\r\n-アプリの鍵が消える時\r\n -消える条件について\r\n -バージョンによる違い\r\n-消えることを見越して\r\n","startsAt":"2018-02-08T16:50:00","endsAt":"2018-02-08T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["650f26f7-5a6e-43a0-958d-62ab2cc0ae84","e37b5a6b-6076-4869-a3f4-2e83df298c98"],"categoryItems":[3480,3483,3500,3540],"questionAnswers":[],"roomId":520,"videoUrl":"https://www.youtube.com/watch?v=dne-ts8dQOQ","slideUrl":"https://www.slideshare.net/ak_shio_555/droid-kaigi2018"},{"id":"15911","title":"Moving Forward with JUnit 5","description":"JUnit 5 constitutes the next major evolution of the most popular unit testing framework for programming languages on the JVM. JUnit has been embraced by developers for decades now, and continues to amaze with a revised architecture built from the ground up in version 5.\r\n\r\nThis talk aims to give an introduction to the motivations, architecture and intricacies behind evolving beyond the well-known JUnit 4, and gives an overview of the new features provided by its successor. Attendees will come to embrace the versatility of aspects like dynamic test generation, new APIs for expressive test case declaration, as well as the elaborate backwards compatibility agenda enforced by JUnit 5, which allows for consistent and gradual migration for existing test suites.\r\n\r\nFinally, the advantages of early adoption for Android developers specifically are presented by introducing the audience to a third-party Gradle plugin, which enables any Android project to profit from what will eventually become the future de-facto standard for unit testing.","startsAt":"2018-02-09T10:30:00","endsAt":"2018-02-09T11:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["b1392ac1-29dc-46d9-8e67-75f026f6c239"],"categoryItems":[3480,3482,3493,3541],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=dEw0vJmRONk","slideUrl":"https://speakerdeck.com/mannodermaus/moving-forward-with-junit-5"},{"id":"16011","title":"Android Studio30分集中超絶技巧100選","description":"リファクタリング、ナビゲーション、ファイルの移動、ビルド・・・、マウスを使って操作していませんか？\r\nマウス、トラックパッドは窓から投げ捨ててしまいましょう。\r\n\r\nAndroid Studioの知ってトクするショートカット、便利技100選を紹介します。\r\n明日から開発速度が100倍くらいになる！かもしれません。\r\n\r\nなおマウス、トラックパッドを処分する際は自治体の定める方法でお願いいたします。","startsAt":"2018-02-09T10:30:00","endsAt":"2018-02-09T11:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["a289149a-b757-499f-9e4b-319cd18da365"],"categoryItems":[3480,3483,3498,3540],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=qoWmJ8tPY_I","slideUrl":"https://gist.github.com/yusuke/e30257656a78ca007627e0762a5a7fbc"},{"id":"16512","title":"詳解 ViewGroupのレイアウト内部実装","description":"Androidの画面構築に欠かせないViewGroup。使い方は当然ご存じだと思いますが、レイアウトアルゴリズムがどのように実装されているかまでご存じでしょうか？\r\nこのセッションではViewGroupのレイアウトの基本的な流れのおさらいと、いくつかの有名なViewGroupのレイアウトアルゴリズムについて解説します。ViewGroupの基本的な話は程ほどにし、内部実装について掘り下げた話をします。\r\n注意：このセッションを聞いてもConstraintLayoutなどの使い方は学べません。\r\n\r\n■目次(案)\r\n・Viewってどうやってレイアウトされているの?\r\n　・View#onMeasure\r\n　　・知ればシンプルなMeasureSpec\r\n　・View#onLayout\r\n　　・使おうgetMeasureWidth、getMeasureHeight\r\n・FrameLayoutのonMeasure、onLayout内部実装解説\r\n・LinearLayoutのonMeasure、onLayout内部実装解説\r\n　・weightの実現方法\r\n・ConstraintLayoutのonMeasure、onLayout内部実装解説\r\n　・特徴的な各機能の実現方法\r\n\r\n■対象者\r\n・独自ViewGroupを作るのが好きな方\r\n　・特にonMeasureやonLayoutをついつい自分で書いてしまう方\r\n・各ViewGroupのレイアウトを「特に」知りたい方\r\n・Viewのレイアウトを本気でチューニングしたい方","startsAt":"2018-02-09T10:30:00","endsAt":"2018-02-09T11:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["1d7b4d9b-7755-48c3-857f-7eba0b3284e2"],"categoryItems":[3480,3483,3495,3541],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=K-fhwdb0x4c","slideUrl":"https://speakerdeck.com/seto_hi/xiang-jie-viewgroupfalsereiautonei-bu-shi-zhuang"},{"id":"16535","title":"Host Card Emulationに触ってみる","description":"■概要\r\nAndroid4.4から導入されていたHCE(Host Card Emulation)ですが、イマイチ流行りませんね！\r\n面白そうだけどとっつきづらそう。ICカードのお作法とか色々と面倒くさそう。そういったイメージも障壁になっているのではと思います。\r\nですので今回は細かいことは置いておいて「ケータイでピッとするやつ」ぐらいの認識でもサクッと作れちゃう！という気持ちにさせるようなセッションを目指します。\r\nサクッと作れる人が増えれば面白い使い方を思いつく人も増えるのではという思いを込めて…\r\n\r\n■アジェンダ（仮）\r\nHCEとは\r\nNFCってなんだっけ\r\nAndroidアプリ with HCE\r\n*APDU等、ICカード周りの話題にはあまり触れない予定です\r\n\r\n■対象者\r\nAndroidアプリ開発経験の有る方\r\nHCEに興味はあるけど触ったことが無い方\r\nケータイでピッとするやつを自分で作ってみたい方 ","startsAt":"2018-02-09T10:30:00","endsAt":"2018-02-09T11:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["0d5788fd-e1bc-4e1b-a340-2db0765f26cb"],"categoryItems":[3480,3483,3492,3542],"questionAnswers":[],"roomId":520,"videoUrl":"https://www.youtube.com/watch?v=FL1FwgCZZ4o","slideUrl":"https://www.slideshare.net/HirokiTaoka1/hostbased-card-emulation-in-touch-87567918"},{"id":"16760","title":"Anko試食会","description":"AndroidのViewレイアウトを定義するために、XMLで消耗していませんか？\r\n私はViewの生成をAnkoのみで実装したアプリをリリースしました。\r\nそこで得られた知見などを共有したいと思います。\r\n\r\n* Kotlin\r\nAnkoを使う上で必要なKotlinの機能やシンタックスについて簡単に触れます。\r\n\r\n* Ankoの内部実装\r\nAnkoの内部実装を紐解きます。\r\n一見、黒魔術的に思えるAnkoのView生成の仕組みを解説します。\r\n\r\n* Ankoなら出来ること\r\nAnkoはKotlinのコードベースであるため、動的なレイアウトが可能であったり、再利用性が高いことが特徴です。\r\nXMLでは出来ない、Ankoならではのテクニックを共有します。\r\n\r\n* Ankoでは出来ないこと\r\nAnkoでは実現不可能なことも存在します。そのいくつかを紹介します。\r\n\r\n* Ankoのハマりどころ\r\n私がAnkoのみで開発する上でハマったポイント、その回避策を紹介します。\r\n\r\n* ViewだけじゃないAnko\r\nAnkoではIntentの発行やダイアログ、トーストの操作もサポートしています。Viewレイアウトの定義だけでない、Ankoのその他の機能を紹介します。\r\n\r\n* Anko DSL Preview\r\nCfP時点では安定していないAnkoのPreview機能。\r\nセッション時点ではどうか？最新情報をお届けしたいと思います。\r\n","startsAt":"2018-02-09T10:30:00","endsAt":"2018-02-09T11:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["247f2500-93e8-45bd-a39e-51c3a6289e57"],"categoryItems":[3480,3483,3487,3542],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=RmKgjgkjwK4","slideUrl":"https://speakerdeck.com/susan335/ankoshi-shi-hui"},{"id":"16869","title":"Kotlin Backstage","description":"Kotlin offers a modern language design in contrast to Java, while at the same time maintaining fully interoperably: Data classes, properties, delegation, inline functions, string interpolation and much more. But, if Java can't offer these features how can Kotlin, what does Kotlin do to make it possible to use this Syntactic sugar? \r\n\r\nIn this talk, we will go backstage and dig into the Bytecode that Kotlin generates to make all the features we love work on a runtime that technically does not support them. We will look at the impact kotlin code generations has on method count. Get a deeper understanding of how Object and companion object work and see the implications of the use of either under different circumstances. Finally look at common patterns that can help reduce the size of both the bytecode and method count.","startsAt":"2018-02-09T10:30:00","endsAt":"2018-02-09T11:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["6293f360-031c-4923-b422-9e396c7cacec"],"categoryItems":[3480,3482,3489,3541],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=CNZFPLbr9oY","slideUrl":"https://www.slideshare.net/vonGraham/kotlin-backstage"},{"id":"16886","title":"はじめてのKotlinハンズオン","description":"Androidの公式言語として仲間入りしたKotlinの初学者向けハンズオンです。\r\nKotlinの概要と誕生の背景から始め、\r\nKotlinの基本文法、クラスやオブジェクト、拡張関数を学び、体験します。\r\n実際に手を動かす課題としては、FizzBuzzなどの簡単なものから、\r\nクラスの定義とその機能追加などちょっとだけ本格的な内容も含みます。\r\nKotlinの言語そのものにフォーカスしているため、\r\n本セッションで得られる知識は、Androidに限らず他の分野でも応用できるでしょう。","startsAt":"2018-02-09T10:30:00","endsAt":"2018-02-09T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["d91dbd08-0968-4f39-b7ab-841349dc71f1"],"categoryItems":[3481,3483,3497,3540],"questionAnswers":[],"roomId":517,"videoUrl":"","slideUrl":"https://speakerdeck.com/ntaro/hazimetefalsekotlinhanzuon-number-droidkaigi"},{"id":"15558","title":"Home Automation with Android Things and the Google Assistant","description":"So you've got a Google Home device, some really cheap LED light bulbs, and wonder how you can integrate those seamlessly in your home, so you can simply talk to the Google Assistant to change the light color in your living room...\r\n\r\nThat's what we will see today, first doing some slight retro-engineering with an Arduino to understand how those light bulbs work, and then creating an Android Things and an Actions on Google project to control those.","startsAt":"2018-02-09T11:20:00","endsAt":"2018-02-09T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["ac30f54a-d80a-453e-adab-5a8623e3dcd1"],"categoryItems":[3480,3482,3492,3540],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=YHG76P4yc3E","slideUrl":"https://www.slideshare.net/secret/GnSDGyJ6tHkAq9"},{"id":"15584","title":"Elastic Team Building","description":"※Elastic = 伸縮自在な・弾力性のある\r\n\r\n[内容]\r\nAndroidアプリ開発において生じる問題を解決するために行ったチームビルディングについて話します。\r\n\r\n[対象者]\r\n・Globalメンバー(英語ベース)を含めた多様性のあるチーム作りに興味がある方\r\n・中・大規模の組織で開発プロセス上におけるステークホルダーが多く困っている方\r\n・会社のiOSファーストの意思決定に困っている方\r\n・Androidエンジニアの採用に苦労している方\r\n\r\n問題例) \r\n・外国人メンバーとのコミュニケーション\r\n・無名スタートアップにおける採用の難しさ\r\n・iOSファースト\r\n・ビジネスの成長 VS 技術負債解消","startsAt":"2018-02-09T11:20:00","endsAt":"2018-02-09T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["0d9656e6-4361-40ef-8383-6c9d237f49db"],"categoryItems":[3480,3483,3490,3541],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=OWcApmjE_Eg","slideUrl":"https://speakerdeck.com/neonankiti/elastic-team-building","message":{"ja":"このセッションはRoom7よりRoom1へ変更になりました。","en":"The room of this session was changed from Room7 to Room1."}},{"id":"16172","title":"Flux: Utilize unidirectional data flow to think less and scale faster","description":"Managing states within the Android application is never easy; when you mutate something in one place, and/or another place, and somehow you want to share the mutated value in multiple places, then you find yourself lost and your value never becomes as you expected.\r\n\r\nIn this talk, I'll talk about flux architecture as one of the solid solutions for managing states within Android application; by achieving unidirectional data flow, we aim to think less, focus more on feature development, and scale faster.\r\n\r\nI'll also show some example implementations with Flux architecture and try to explain pros and cons of  choosing flux architecture for Android application development.","startsAt":"2018-02-09T11:20:00","endsAt":"2018-02-09T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["ae0ff7e6-1e72-4113-8e28-c6c865917330"],"categoryItems":[3480,3482,3488,3541],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=oLr5xL4jj8w","slideUrl":"https://speakerdeck.com/shaunkawano/flux-for-android"},{"id":"16933","title":"Surviving a discontinuous world","description":"Androidアプリ開発における難しさの1つは、不連続性です。たとえば、通信中に画面回転をした場合、その結果を受け取るにはどうしたらよいでしょうか。あるいは、商品詳細画面で商品をお気に入りに追加したあとに商品一覧に戻ったときに、一覧画面でもお気に入りマークを正しく表示するにはどうしたらよいでしょうか。\r\n\r\nこのトークでは、画面回転や画面遷移における代表的な不連続性を取り上げ、それぞれにどのような対応が選択肢としてあるかを紹介します。\r\n\r\n前半では典型的なユースケースを例にどのような不連続性があるか紹介します。たとえば、画面回転ではアクティビティが再生成される一方で、setRetainInstance(true)にしたFragmentやLoaderは生き残ります。それを利用することで画面回転をまたがったデータの保持が可能です。しかし、画面遷移においてアクティビティが破棄されていた場合は、onSaveInstanceStateでデータを保存してやる必要があります。さらに、Low Memory Killerでアプリのプロセスが殺された場合は、Applicationクラスで保持していた情報も失われてしまいます。\r\n\r\nこのように、Androidアプリにおける不連続性の種類と特徴を理解することが、適切な対応への第一歩となります。\r\n\r\n後半では、不連続性を克服するための手段として、つぎのような手段を紹介します。それぞれについてメリット・デメリット、向いている用途について解説することで、トークを聞いた開発者が、それぞれの不連続性に対して適切な対応を取れるようになることを目指します。\r\n\r\n1. AsyncTask\r\n2. Loader\r\n3. Architecture Component\r\n4. RxJava\r\n5. Kotlin Coroutine","startsAt":"2018-02-09T11:20:00","endsAt":"2018-02-09T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["69924067-07aa-43e7-90ba-c17ff70d2638"],"categoryItems":[3480,3483,3488,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=CJll1hhkQ_A","slideUrl":"https://speakerdeck.com/hkurokawa/surviving-a-discontinuous-world"},{"id":"16941","title":"既存アプリへのInstant Apps導入","description":"■対象者\r\n\r\nInstant Appsの概要を知りたい方\r\n既存アプリをInstant Apps対応しようと考えている方\r\nこれから作るアプリのInstant Apps対応を見据えた設計にしたい方\r\n \r\n■概要\r\n \r\nGoogle I/O 2016にて発表された1年後、Google I/O 2017でようやく一般開発者も可能になりました。Instant Appsは、アプリをインストールすること無く、直ぐにネイティブアプリと同等の動作をすることが出来るため、ユーザ体験が著しく向上します。\r\n既にアプリの数が溢れているこれからの時代、対応は必須なのではないでしょうか？\r\nしかしながら、Instant Appsはapkのサイズが4MBという制限が設けられていて、既存アプリをInstant Apps対応するには一手間加える必要があります。\r\nこのセッションでは、Instant Apps対応の基礎知識と共にモジュール設計から、DIを含む既存アプリの移行にフォーカスを当てて解説していきます。","startsAt":"2018-02-09T11:20:00","endsAt":"2018-02-09T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["5752b1a2-717b-44c8-a247-64be0b7dcf2b"],"categoryItems":[3480,3483,3488,3540],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=trOCwskF_hM","slideUrl":"https://speakerdeck.com/aakira/introduceinstantapps-droidkaigi2018"},{"id":"17018","title":"Androidで始めるOpenGL ES","description":"■ 概要\r\n「OpenGL ES」と聞いてよくわからないけど難しそうと感じていませんか?\r\n難しいと感じる原因は2つあります。一つはOpenGL ESが何をやっているのかわからないということ、もう一つはOpenGL ESを使って実現したい機能の高度さです。\r\n前者は、Androidエンジニアが「iOSやSwiftよくわからない」と言うのと同じようなものです。理解さえしてしまえばどんな高度な機能の開発にも応用できます。\r\n\r\n本セッションでは、OpenGL ESが何をやっているのかを理解するために、基礎となるGPUの仕組みから、OpenGL ESを使って描画するまでを紹介します。\r\nまた、AndroidでOpenGL ESプログラミングをする際にハマりやすいポイントについても紹介します。\r\n\r\n■ 発表内容(予定)\r\n- GPUの仕組み\r\n  - GPUとCPUの違い\r\n  - GPUとOpenGL ESの関係\r\n- OpenGL ESプログラミングの基礎\r\n  - 画面を描画するまで\r\n  - シェーダープログラミング\r\n- Android OpenGL ESプログラミング\r\n  - GLThreadの話\r\n  - UIコンポーネントとの連携\r\n  - デバッグ方法","startsAt":"2018-02-09T11:20:00","endsAt":"2018-02-09T11:50:00","isServiceSession":false,"isPlenumSession":false,"speakers":["6fdbdbd1-011d-4703-bc1d-edaea33ea791"],"categoryItems":[3480,3483,3500,3542],"questionAnswers":[],"roomId":520,"message":{"ja":"大変申し訳ありません。このセッションはキャンセルされました。","en":"We are very sorry. This session was canceled."}},{"id":"15888","title":"詳解 Android Auto - 使い方からそれを支える技術まで","description":"Android Auto は、Lollipop の登場とともに発表されたスマートフォンと自動車をつなぐ比較的新しい仕組みです。現在着々と市販車のカーナビシステムに組み込まれてきており、かつスマートフォン単体でも Android Auto が動作するようにもなっています。今後アプリが自動車内にいるユーザとのエンゲージメントを得るためには、Android Auto について知っておくことは大きなアドバンテージになるはずです。\r\n本セッションでは、Android Auto そのものの概要やそのフレームワークがもつ API の紹介から、Android Auto が生まれる経緯を踏まえつつフレームワークがどのように構築されているか、Android Auto を支えている技術を深掘りして見ていきます。その上で、フレームワークを使うときの注意点やノウハウ、また注意点・ノウハウの Android Auto 以外での一般的な応用を考察します。","startsAt":"2018-02-09T12:50:00","endsAt":"2018-02-09T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["33ff8262-ff9a-4d77-be1f-e288d62ba93f"],"categoryItems":[3481,3483,3495,3542],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=0ffNY26f-q4","slideUrl":"https://speakerdeck.com/keithyokoma/xiang-jie-android-auto-shi-ifang-karasorewozhi-eruji-shu-made"},{"id":"16228","title":"Android Things codelab / Android Things であそぼう","description":"Hands on codelab to learn more about  Android Things\r\n\r\n-----\r\n\r\n※ This session is made up of a 1 hour hands-on repeated 5 times. The schedule is as follows.\r\n12:50-13:50 Codelab\r\n13:50-14:00 Break\r\n14:00-15:00 Codelab\r\n15:00-15:10 Break\r\n15:10-16:10 Codelab\r\n16:10-16:20 Break\r\n16:20-17:20 Codelab\r\n17:20-17:30 Break\r\n17:30-18:30 Codelab","startsAt":"2018-02-09T12:50:00","endsAt":"2018-02-09T18:10:00","isServiceSession":false,"isPlenumSession":false,"speakers":["ae00a99a-5a4f-45f4-bc8f-6460579522d6"],"categoryItems":[3481,3482,3492,3540],"questionAnswers":[],"roomId":517,"videoUrl":"","slideUrl":"https://codelabs.developers.google.com/codelabs/androidthings-playground-jp","message":{"ja":"このセッションは1時間のハンズオン5回で構成します。詳細を確認してください。","en":"This session is made up of a 1 hour hands-on repeated 5 times. See details."}},{"id":"16534","title":"How Android Rendering Works to Provide Pixels on the Screen Faster than You Can Read this Sentence","description":"There's a lot going on under the hood in Android to turn application code into pixels on the screen. UI widgets, OpenGL, Vulkan, windows, surfaces, buffers, and GPUs all get involved in the action. Come to this talk to see how it all works together to create performant graphics for Android applications.","startsAt":"2018-02-09T12:50:00","endsAt":"2018-02-09T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["152f613f-841b-407d-9a65-3703ec2dfae2","bbf9c2ed-21be-4388-a6b4-138561d76376"],"categoryItems":[3481,3482,3500,3541],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=QRxgtejwPlQ","slideUrl":"https://sites.google.com/site/androidcontentfromchet/downloads/AndroidRendering.pdf","message":{"ja":"このセッションは更新されました。","en":"This session was updated."}},{"id":"16837","title":"アプリを成長させるためのログ取りとログ解析に必要なこと","description":"アプリは作ってリリースすれば勝手にユーザーが増えてビジネスとして成長していくわけではありません。せっかくインストールしてもらっても、操作しにくかったり使い方が理解されなかったりすると結局起動されなくなり、いずれアンインストールされます。使い続けてもらうためにはユーザーに寄り添って何度も何度も何度も継続的に改善を繰り返していかなければなりません。しかし一口に改善といっても、何を持って改善されたといえるのでしょうか？改善されたというためにはそれを裏付ける指標が必要です。その指標を得るにはログを取り、解析をしなければなりません。\r\n\r\nではログ自体はどうやって取れば良いのでしょうか？「ログなんか取っておけば良いでしょ？」、そんなふうに考えていた時期が私にもありました。しかしアプリを改善させるためにログ解析をしていると、ログの抜けや重複、衝突などがあり、正しく解析できないことが何度もありました。ログを取るためのトラッカーはアプリ開発者が設計して実装しなければ、そういった役割を果たせるものではないのです。\r\n\r\nまた指標はGoogle AnalyticsやFirebase Analyticsでパッと見れるものならば良いですが、アプリの個々の機能の指標を作ろうとするとHadoopやBigQueryのようなログ解析のインフラと、ExcelやGoogle Data Studioのような可視化のためのツールも必要になります。それらをうまく活用するためには、元のログを解析しやすいようにしておく必要があり、それもトラッカーを埋めるアプリ開発者が行わなければなりません。\r\n\r\n本発表ではアプリ作るだけだった私がログ取りやログ解析を行い、実際にデータに基づいたアプリの改善を行うようになるまで、何を学び、何に気をつけて開発を行っているかをお話します。\r\n","startsAt":"2018-02-09T12:50:00","endsAt":"2018-02-09T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["406c85a2-c8f7-42de-aca2-1074983c6699"],"categoryItems":[3481,3483,3489,3541],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=ibts1McHeFk","slideUrl":"https://www.slideshare.net/TakaoSumitomo/ss-87583483"},{"id":"16991","title":"React Native Androidはなぜ動くのか","description":"React Nativeが出てきてしばらく経ちましたが、処理系が特殊なこともあり、黒魔術的なイメージを持っている人も多いように思います。\r\nしかし、実際には素直な読みやすいJavaで実装されている部分も多く、Androidエンジニアが読めば充分読めてしまうレベルです。\r\n本セッションでは、React NativeのAndroid向け実装を様々な面から紹介することで、React Nativeへの心理的障壁を下げてもらうことを目的とします。\r\n\r\n次のようなトピックを想定しています。\r\n\r\n* JavaScriptCoreはどこで・いつ動くのか\r\n* ネイティブブリッジの仕組みから見る「Androidらしさ」\r\n* ビルドの仕組みから見る「Androidらしさ」","startsAt":"2018-02-09T12:50:00","endsAt":"2018-02-09T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["025947ec-fb6b-4319-bae4-b049c8cdaf98"],"categoryItems":[3481,3483,3499,3542],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=DKr5ckadMjc","slideUrl":"https://www.slideshare.net/Nkzn/react-native-android-87622684"},{"id":"17046","title":"Graywater: A Framework for Fast Scroll Performance","description":"Recently, Tumblr released Graywater, a RecyclerView library for decomposing large list items to improve scroll performance. This talk walks through how to build an advanced, flexible list implementation backed by Graywater and utilizing Dagger 2 multibinding to configure Graywater for different screens. Although Graywater has greatly reduced OutOfMemory errors at Tumblr, the library is not for all apps. The talk cover the benefits and limitations of Graywater in comparison to other recently-released RecyclerView frameworks, such as Litho and Epoxy, as well as implementation decisions and details.","startsAt":"2018-02-09T12:50:00","endsAt":"2018-02-09T13:40:00","isServiceSession":false,"isPlenumSession":false,"speakers":["de26fcbb-7b43-4c56-b1dc-d808674f1114"],"categoryItems":[3481,3482,3488,3541],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=ungg-XLtqMs","slideUrl":"http://ericleong.me/talks/graywater-droidkaigi/"},{"id":"16709","title":"Dagger2を活用してAndroid SDKの依存関係をクリーンにする","description":"MVP、MVVM、クリーンアーキテクチャ等、Androidアプリケーションの設計を整理するパターンは様々存在しますが、\r\n実際にこれらのパターンを開発で適用しようとすると、どうしてもネックになりやすいのがAndroid SDKに依存する機能の呼び出し部分です。\r\n\r\n例えば\r\n\r\n+ Contextに依存する処理\r\n+ 画面遷移\r\n+ FragmentManagerの操作\r\n+ DialogFragmentの表示、\r\n+ Lifecycleイベントのハンドリング\r\n\r\nなどがあげられます。\r\n\r\nFat Activity/Fragmentを避けようとMVP、MVVM、クリーンアーキテクチャ等のパターンを適用したはずなのに、どうしてもActivity/Fragmentにロジック部分が残ってしまいがちで結局設計を逸脱した例外的な処理の記述の仕方を行った経験などがある方もいらっしゃるのではないでしょうか。\r\n\r\n本発表ではDagger2のScope、Subcomponentの機能を活用し、Android SDK由来の各種機能を疎結合に整理する方法、その利用例をご紹介します。\r\n\r\nなお、本発表のサンプルコードはAndroid Data Bindingを利用したMVVMパターンを適用したアプリケーションを例として使用します。\r\n\r\n## 目次（予定）\r\n\r\n+ Scopeは二つに分ける（Singletonスコープ、Lifecycleスコープ）\r\n+ Context依存を切り離す\r\n    + 二つの方法、メリット/デメリット\r\n+ 画面遷移を整理する\r\n    + Delegationパターンを使ってActivity/Fragment/DialogFragmentに対応する\r\n+ FragmentManager(DialogFragment)依存を切り離す\r\n+ Lifecycleイベントのハンドリングを整理する\r\n\t+ Android Architecture Componentsを利用するパターン\r\n\t+ 自前でコールバックを定義するパターン\r\n\r\n## 対象者\r\n\r\n+ Fat Activity/Fragmentをスリムにしたい人\r\n+ Dagger2の基本的な使い方は理解しているが、実践的にAndroid実装に適用する際のベター/ベストプラクティスを知りたい人\r\n","startsAt":"2018-02-09T14:00:00","endsAt":"2018-02-09T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["621adbb8-8b2f-4a04-b2c0-778188ddb135"],"categoryItems":[3480,3483,3488,3541],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=H5bLVsMjuZA","slideUrl":"https://speakerdeck.com/kr9ly/dagger2wohuo-yong-siteandroid-sdkfalseyi-cun-guan-xi-wokurinnisuru"},{"id":"16740","title":"TensorFlow for Mobile Heroes","description":"There is a lot of Hype with ML and AI lately, and TensorFlow is the framework of choice from Google. But as a Mobile Developer you might have asked yourself, how can I benefit from it? In this talk, you will learn your first steps into the fascinating ML world for mobile.\r\n\r\nThe session will show examples in:\r\n\r\n- Classifying example\r\n- Detection example\r\n- Analyzing example\r\n\r\nAlso, we will have a state of the art report, which hole is TensorFlow covering, explanation of some real use cases, theory of Neural Networks, showcasing how models are training, what is the motivation of using ML on Mobile instead of on a server, etc.\r\n\r\nI will show as well some live demos on Android of how TensorFlow works, showcasing iOS and explaining how we can adapt our own models to Google samples.","startsAt":"2018-02-09T14:00:00","endsAt":"2018-02-09T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["2f606e32-997a-4b74-8420-76a47e7d66a3"],"categoryItems":[3480,3482,3500,3541],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=TlnV9x1U7fQ","slideUrl":"https://speakerdeck.com/kikoso/tensorflow-for-mobile-developers-2"},{"id":"16822","title":"なんとなく動いているProGuardから脱出するために","description":"Android開発では、出来る限りdexファイルのサイズを削減しなければいけません。ProGuardを使うことで、無駄なコードを削除し、dexファイルサイズを削減することが出来ます。コード量を削減することで、アプリの高速化も期待できます。またInstant Appsでは4MB制限があるため、ProGuardの重要性がより増しました。しかし、ProGuardの設定は複雑なため、なんとなくのコピペですませがちです。\r\n\r\n本セッションではなんとなく動いているProGuardから脱出するために、\r\n\r\n- Proguardはそもそも何をしているのか?\r\n- OkHttpなどのライブラリでなぜこのProGuardの設定の追加が必要なのか?\r\n- Proguardを導入することでどれくらいの削減/高速化が期待できるのか?\r\n- Android StudioのAPK AnalyzerでProGuardの結果を見る\r\n- (時間が余りそうならfacebook/redexについて)\r\n\r\nについて説明し、なんとなく動いているProGuardから脱出することを目指します。\r\n\r\n","startsAt":"2018-02-09T14:00:00","endsAt":"2018-02-09T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["d36b8c88-3cca-4895-b7d0-80f1fbdcc307"],"categoryItems":[3480,3483,3500,3540],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=9tEhSocVIlU","slideUrl":"https://docs.google.com/presentation/d/1r53A3Qr4j7GetCaq7LbvVSFKlPdKdCvn4M08AWM16N8/edit#slide=id.p"},{"id":"16892","title":"Support LibraryのDownloadable FontsやEmojiCompatに対応したアプリを作ろう","description":"■背景\r\n\r\nDownloadable FontsやEmojiCompatなどの便利な機能が存在します。\r\n\r\nしかしこれを活用する知見がまだ少ないのではないでしょうか？\r\n\r\n\r\n\r\n■内容\r\n\r\nどういう仕組みで動いているのか。\r\n\r\nDownloadable Fontsの日本語フォントの対応状況について。\r\n\r\n実際にCalligraphyをDownloadable FontsなどのFont Resourcesに置き換える方法。\r\n\r\nEmojiCompatのAPI level 19にどう対応するか。\r\n\r\nどうやってテストするか。\r\n\r\nなど実践的なところを紹介していきます。","startsAt":"2018-02-09T14:00:00","endsAt":"2018-02-09T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["e1eb194c-e7fa-4561-b023-82a61c5eead9"],"categoryItems":[3480,3483,3495,3542],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=ZkGKFwdfvZE","slideUrl":"https://speakerdeck.com/takahirom/support-libraryfalsedownloadable-fontsyaemojicompatnidui-ying-sitaapuriwozuo-rou"},{"id":"16947","title":"Androidで利用できるデバイスファームのメリット・デメリットの紹介","description":"モバイルアプリに開発において、端末（デバイス）の管理は重要です。そこで、デバイスファームを利用することでデバイス管理のコストを抑えることができます。\r\n\r\n今日ではデバイスファームも様々なOSSやサービスが展開されています。\r\n\r\nこのセッションでは、デバイスファームの紹介とメリット・デメリットについて紹介します。","startsAt":"2018-02-09T14:00:00","endsAt":"2018-02-09T14:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["dad922a2-c3b2-4318-be54-277c9bc34029"],"categoryItems":[3480,3483,3491,3540],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=NjlV0Otb82M","slideUrl":"https://www.slideshare.net/ShunsukeMaeda/droidkaigidevicefarm"},{"id":"15883","title":"Dialogflow(API.AI) for Android ~ Dialogflow(API.AI)アプリ開発入門~","description":"Dialogflow(旧:API.AI)は自然言語処理を提供するプラットフォームです。基本的なDialogflowの使い方と、Android アプリにチャットボットを構築する方法をご紹介します。\r\n\r\n対象者\r\n- 自然言語処理をAndroidアプリに導入したい方\r\n- 既存のAndroidアプリにチャットボットを導入したい方\r\n- 自然言語処理が全くわからないけど使ってみたい方\r\n\r\n内容\r\n- 基本的なDialogflowの使い方\r\n- Androidアプリに導入する方法","startsAt":"2018-02-09T14:50:00","endsAt":"2018-02-09T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["85a1bdae-723f-4a7a-8700-2101f6e4a48d"],"categoryItems":[3480,3483,3500,3540],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=njqK1N8Bz90","slideUrl":"https://www.slideshare.net/tsudakyohei/droidkaigi-2018-dialogflow-for-android"},{"id":"16864","title":"Implementing Dropbox Offline Folders","description":"In this talk I'll go through the process Dropbox followed to go from supporting Offline Files to supporting Offline Folders. I'll focus on the things paint points of implementing it in Android, like Doze and the way Android manages storage.","startsAt":"2018-02-09T14:50:00","endsAt":"2018-02-09T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["41711e09-fb90-448c-a74d-886c133562ea"],"categoryItems":[3480,3482,3488,3540],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=UqV8WpJyd9o","slideUrl":"https://speakerdeck.com/rodgavila/implementation-of-mobile-offline-folders"},{"id":"16883","title":"Android案件の見積もりに現れる要素、あるいは丁寧に埋設された地雷たち","description":"Androidアプリにかぎらず、アプリ開発は大きな裁量のある自社案件だけでなく、様々な制約のある受託案件も多く存在します。\r\n受託をするからには「どのくらいの期間で」「何人の人員で」「おいくら万円になるのか」等を見積もり出さなくてはなりません。\r\n\r\n「この機能ならこれくらいだな」と直感で出してしまうと、あらゆるところに待ち受ける地雷であっという間に爆発四散してしまうでしょう。\r\n\r\nAndroidアプリ固有の問題、機種固有の問題のみならず、開発フローの問題、社内政治的問題、期間の問題、そして開発者のエゴの問題などなど。\r\nこのセッションでは、アプリ開発時に感情に含めなければならないあらゆる要素について、技術的観点以外についても解説していきます。\r\n\r\n※講演者及び周辺人物の経験則に基づく要素が大きいということを予めご了承ください\r\n\r\n発表内容（予定）\r\n・Androidアプリ開発固有の問題\r\n・機種固有の問題\r\n・開発周辺環境の問題\r\n・関わる人間の問題\r\n・社内政治の問題\r\n","startsAt":"2018-02-09T14:50:00","endsAt":"2018-02-09T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["a4b446f7-e1f6-47cc-b7e1-ae9cdc4bb2f5"],"categoryItems":[3480,3483,3500,3542],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=KHAg4bVtjaQ","slideUrl":"https://www.slideshare.net/eaglesakura/android-87578327"},{"id":"17019","title":"Androidアプリ開発における技術顧問としての役割","description":"2017年7月にピックアップ株式会社の技術顧問に就任し、現在では新規Androidアプリの開発を進めています。\r\nその中でもスピード感を持ちつつ、同じサービスのiOS、Androidアプリを作るにあたって苦労した点や、工夫した点など、\r\n他のアプリ開発でも十分に役立てるような内容をお話できればと思います。\r\n\r\n【アジェンダ（予定）】\r\n・技術顧問とは\r\n・普段の仕事\r\n・プロジェクトの概要\r\n・現在のチーム体制\r\n・iOS、AndroidエンジニアがAPIを書く\r\n・コードレビューの観点や仕組み\r\n・CIやツール周り\r\n・ライブラリやアーキテクチャの選定\r\n・社内全体でスキルをあげていく仕組み","startsAt":"2018-02-09T14:50:00","endsAt":"2018-02-09T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["ab6eb21a-b8f5-4e26-b68f-5e07383ea9ab"],"categoryItems":[3480,3483,3489,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=eTy_4diybLQ","slideUrl":"https://speakerdeck.com/cutmail/androidapurikai-fa-niokeruji-shu-gu-wen-tositefalseyi-ge-number-droidkaigi-2018"},{"id":"17030","title":"すばらしきGraphQLのSEKAIへようこそ","description":"GraphQLはFacebookが開発したWeb API用のクエリ言語の仕様で、RESTful APIを置きかえるAPIアーキテクチャと考えられています。GitHubのWe API v4がGraphQLで提供されたことにより注目が集まっており、発表者（`@__gfx__`)  も仕事でGraphQL APIの開発を行っています。いまやサーバーサイドエンジニアにとって、RESTful APIを置きかえるものとして検討に値する技術といえるでしょう。\r\n\r\nさて、Web APIがGraphQLで提供されるようになるのであれば、Androidエンジニアにとっても無縁ではありません。GraphQLとは何なのか、RESTful APIと比べてどういう利点・欠点があるのか。Java/Kotlinから使うにはどのようにするのか。\r\n\r\n本セッションでは、これらの疑問に対して回答を試みます。GraphQLは一見とっつきにくい技術ですが、本セッション後は魅力的な技術に見えていることでしょう。オフィスに帰ったらAPI設計者にこう提案してみてください: 「DroidKaigiでGraphQLを知ったんですが、サーバーサイドもクライアントサイドも楽に開発できるようになると聞きました。うちもGraphQLにしましょう！」\r\n\r\n## ToC（予定）\r\n\r\n* GraphQLとは何か\r\n    * GraphQLとは何か\r\n    * なぜGraphQLを学ばねばならないか\r\n    * GraphiQL: The GraphQL IDE の使い方\r\n* GraphQLとの付き合い方はいくつか\r\n    * 単にRESTful APIの置き換えとして\r\n    * GraphQLからWeb API clientを生成する\r\n        * e.g. https://github.com/apollographql/apollo-android\r\n    * Viewに必要なデータをまるっと取ってくるための自動化されたWeb APIとして\r\n        * The Relay Framework\r\n        * Relay on React Native\r\n        * Relay on Android Java/Kotlin のPoC\r\n* GraphQLに関するFAQ","startsAt":"2018-02-09T14:50:00","endsAt":"2018-02-09T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["85b6291b-4870-4a9a-82b1-be5979623fc0"],"categoryItems":[3480,3483,3488,3540],"questionAnswers":[],"roomId":514,"videoUrl":"","slideUrl":"https://speakerdeck.com/gfx/subarasikigraphqlfalsesekaiheyoukoso"},{"id":"17032","title":"マーケティングオートメーションツールとアプリエンジニア ~プッシュ通知・お知らせダイアローグの運用自動化のためのお仕事~","description":"DroidKaigiに出席するAndroid開発者の皆様には馴染みがないかもしれませんが、\r\n近年ディレクターやデザイナーが主体となってお知らせダイアローグやプッシュ通知その他のマーケティング施策を実行できるようにするマーケティングオートメーションツール(以下MAツール)というものが開発されています。\r\n\r\n自分はMAツール界隈ではアプリ内メッセージと呼ばれているお知らせダイアローグを見た時、\r\nこれはなんだか面白そうだと開発に参加してそろそろ一年経ち、それなりに色々面白かったので\r\nその様子をご紹介したいと思います。\r\n\r\nこんな世界があるのかーと物珍しく眺めていただければ幸いです。\r\n\r\n以下は内容一部変わる可能性がありますがお品書きです。\r\n\r\n■ MAツールとは\r\n\r\n- プッシュ通知やお知らせダイアローグの表示、各種ユーザー行動のトラッキング、その結果の再利用までをWeb上でディレクターだけでできるようにしていくもの\r\n- ディレクターやデザイナーはより自律してユーザとの接点を作る施策を行うことができる\r\n- エンジニアはその分、各画面のUIのアニメーションや性能改善、アプリならではの機能の開発に専念できる\r\n\r\n■ 技術的に携わっている要素について\r\n\r\n- プッシュ通知\r\n  - 複数バージョンのGMSとFCSへの対応\r\n  - iOS/Android両方で使えるようにするための機能の取捨選択\r\n  - 他の同様のツールとの共存について\r\n- お知らせダイアローグ\r\n  - 途中でバックグラウンドを挟んだ場合やViweGroupのAPI Levelによる挙動の違いへの対応\r\n  - ChromeBookなど特殊な画面サイズの端末への対応\r\n  - AndroidとiOSで標準的なUIが違うため、AndroidのカスタムViewを書いたり\r\n- クロスプラットフォーム対応\r\n  - 各種ビルドツールをつなぐために環境変数や動的・静的ライブラリのリンクといったコンピュータ要素に詳しくなっていく話\r\n  - 代表的なクロスプラットフォームに対するライブラリ提供方法の例\r\n- テスト自動化\r\n  - 検証項目が加速度的に増えていくので自動化がマストになっていく\r\n  - AppiumやXCUITest, Espressoを検討した時の話","startsAt":"2018-02-09T14:50:00","endsAt":"2018-02-09T15:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["4c578eb8-2d3e-42af-9c97-e8bf60909f42"],"categoryItems":[3480,3483,3489,3542],"questionAnswers":[],"roomId":520,"videoUrl":"https://www.youtube.com/watch?v=PnK4ipdVSaY","slideUrl":"https://speakerdeck.com/woshidan/maketeinguotomesiyonturutoapurienzinia-putusiyutong-zhi-ozhi-rasedaiarogufalseyun-yong-zi-dong-hua-falsetamefalseoshi-shi"},{"id":"16870","title":"Production Level Test Driven Development and What's new","description":"7/10 developers don’t really know how to test their apps and write testable code. From practically writing code to test genuine production level scenarios with different approaches to incredibly optimising your tests cases, we will also see what’s new in Android Test Support Library 1.0.\r\n      \r\n                                 ---Outline---\r\n\r\n-> Important Testing GuideLines\r\n\r\n-> Espresso and Robolectric (In and Out ,Crisp and To the point)\r\n\r\n-> Making Code highly Testable using MVVM , Repository Pattern and Data binding\r\n\r\n->Pure production level Scenarios Testing Demo:-\r\n\r\n-> Will be showing the order lifecycle of an e-comm site and show how different orders states can be Unit Tested( A very genuine and typical use case applicable to almost every startup or company)\r\n\r\n-> Will be showing This with the following three approaches using Dagger 2 \r\na.) Using Robolectric (JVM based without needing a device or emulator)\r\nb.) Using Espresso (Unit Instrumentation Tests)\r\nc.) Testing the ViewModel (Purely JVM based)\r\n\r\n-> Optimise them further (reducing test suite running time from 16s to 180ms)\r\n\r\n-> Espresso Unit Instrumentation Testing Vs Robolectric Unit Testing Vs Unit Testing MVVM architectured app (Detailed analysis including performance)\r\n\r\n-> Integration Testing Using Espresso\r\n\r\n-> Demonstrating the New Features of Android Test Support Library 1.0\r\n-> Android Test Orchestrator\r\n-> New Features Of AndroidJUnitRunner\r\n-> Espresso 3.0 New Features\r\n-> New Test Rules\r\n\r\n->If time allows\r\n-> UI Automator in Action\r\n-> Testing on Multiple Devices Fire Base Test Labs\r\n-> Continuous Integration Using Circle CI\r\n-> What’s More In AWS Device Farm\r\n     ","startsAt":"2018-02-09T15:40:00","endsAt":"2018-02-09T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["addf6286-cec0-4b0b-848c-02d9c8edb957"],"categoryItems":[3481,3482,3493,3541],"questionAnswers":[],"roomId":520,"message":{"ja":"大変申し訳ありません。このセッションはキャンセルされました。","en":"We are very sorry. This session was canceled."}},{"id":"16894","title":"All you need is isolating the domain (How to apply DDD to Android Application Development 2)","description":"Droid Kaigi 2017 で How to apply DDD to Android Application Development という講演を行いました。本セッションはその続きです。\r\n前回ドメイン駆動設計とは何か、何をするのか、を解説し、戦略的設計について話しました。今回は戦術的設計について踏み込みます。\r\n様々な手法があるなかで、ドメインを隔離することをテーマに、Androidアプリ開発で取り入れやすいエッセンスを紹介します。\r\n前回同様ドメイン駆動設計の内容については「エリック・エヴァンスのドメイン駆動設計」及び「実践ドメイン駆動設計」に準拠します。\r\n\r\n本セッションはドメイン駆動設計の前提知識がない方にもわかるようお話ししますが、前回の動画 https://academy.realm.io/jp/posts/droidkaigi17-how-to-apply-ddd-to-android-application-development/ を見ていただくか、内容をまとめたブログ http://y-anz-m.blogspot.jp/2017/03/droidkaigi-2017_9.html を読んでいただくことをおすすめします。","startsAt":"2018-02-09T15:40:00","endsAt":"2018-02-09T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["580fb501-aece-4bf4-b755-32fda033b3bd"],"categoryItems":[3481,3483,3500,3541],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=glasB4fF15Q","slideUrl":"http://y-anz-m.blogspot.jp/2018/02/android.html"},{"id":"16908","title":"gRPCとProtocol Buffersで作る、一味違う通信周り","description":"# 概要\r\n（50分としていますが、30分も多分可能です）\r\nAndroidアプリに限らず、昨今のウェブサービス・アプリの通信周りでは専らRESTとJSONが使われていることと思います。\r\nそんな中、現在私達が開発しているアプリではREST + JSONではなくgRPC + Protocol Buffersを使うという選択肢を取りました。\r\ngRPC, Protocol Buffers共にGoogleが開発した新しい通信フレームワークおよびシリアライズフォーマットです。様々な魅力的な特徴がある一方で、まだまだ採用例が少なく情報も充実していないのが実情です。\r\nそんなgRPC + Protocol BuffersをどのようにAndroidアプリ開発で用いるのか、メリットやデメリットは何なのか、開発の上で工夫した点などをお話できればと思います。\r\n\r\n# 内容（予定）\r\n- gRPCとは何か\r\n- Protocol Buffersとは何か\r\n- Androidアプリにおけるメリット・デメリット\r\n- gRPC + Protocol BuffersをAndroidアプリ開発に導入する\r\n- 実際の開発の際の工夫、苦労する点、etc\r\n\r\n# 主な対象者\r\n- REST + JSON以外の選択肢を検討したことがなかった人\r\n- アプリ開発でRPCを使いたい人\r\n- サーバ・アプリエンジニア間でJSONレスポンスの仕様共有に苦労している人\r\n- 新しい技術に積極的に挑戦してみたい人\r\n","startsAt":"2018-02-09T15:40:00","endsAt":"2018-02-09T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["59582b52-78ac-4c2e-bff6-a5dd70f45c3f"],"categoryItems":[3481,3483,3500,3542],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=RP05DanmvU0","slideUrl":"https://speakerdeck.com/kmats/protobuf"},{"id":"16937","title":"認証と認可と君と / The Triple-A: Authentication, Authorization, and Android","description":"# 概要\r\nサービス提供者間のデータ連携が活発になるにあたり、認証・認可の重要性が一層増しています。そのような背景に応じてか、Google Identity Platform上のAndroidの機能が続々と登場しています。また、OAuth2.0などの技術標準がより一般的になってきました。これらを上手く利用し、ユーザー体験の利便性を損なわない、セキュアなAndroidアプリを作る方法についてお話します。\r\n\r\n# 扱う技術(予定)\r\n- Firebase Authentication\r\n- SMS Retriever\r\n- Smart Lock\r\n- OpenID Connect(+ OAuth2.0)\r\n- FIDO\r\n\r\n# 詳細\r\n\"スマートフォン（スマホ）を使った金融サービスを生みやすくする。（中略) 同じサービスに同じ規制をかけ、銀行とフィンテック業者が連携しやすくする\" と金融庁は宣言しました。Fintechに限らずサービスプロバイダは、ユーザーのデータをAPIなどを介して提供・利用し、新しい体験を創造していく流れが加速するでしょう。\r\n\r\nその際に鍵となる概念が、\"認証\"と\"認可\"です。サービス提供者は、別のサービスのAPIを叩いてデータを提供してもらうには、ユーザーに**認可**をもらう必要があります。そして、認可の操作の前に、正しいユーザーを**認証**しなければなりません。\r\n\r\nこの認証と認可には、一般的にOAuth2.0、それを取り込んだOpenID Connect, FIDOといった技術仕様があります。また、Googleが提供しているFirebase AuthenticationやSMS Retriever APIなどもあります。\r\n\r\nでは、そのような技術・標準・APIをAndroidでどのように適用すればいいのでしょうか？　本セッションでは、上述した技術や標準をAndroidアプリで使う場合の実装方法・気にすべきポイントといった部分についてお話させて頂きます。","startsAt":"2018-02-09T15:40:00","endsAt":"2018-02-09T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["931cab5b-0627-4843-80a6-59f0ca930bb9"],"categoryItems":[3481,3483,3500,3542],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=XJhflxykV8g","slideUrl":"https://speakerdeck.com/ken5scal/ren-zheng-toren-ke-tojun-to-the-triple-a-authentication-authorization-and-android"},{"id":"16945","title":"体育会系女エンジニアの孤独なアプリ開発教室","description":"■対象\r\n・脳みそが筋肉でできているAndroidエンジニアからある種の勇気をもらいたい方\r\n・個人でAndroidアプリを完成させて記念すべき1作目をリリースしてみたい方\r\n・個人Androidアプリで10万ダウンロードいってみたい方\r\n・Androidアプリエンジニアだけど微妙に職に困ってる・今の待遇に不満がある方\r\n\r\n■お話する内容\r\n個人アプリ開発において\r\n「そこそこダウンロードしてもらえるアプリ」を\r\n「作る・完成させる・リリースする」ために\r\n実践してること、してないこと\r\n\r\n■お話しないこと\r\nAndroidStudioの使い方とか\r\nプログラミングのこととか\r\n\r\n■本邦初公開\r\n・どっきどき！スクレイピング怒られ事情\r\n・どっきどき！GooglePlay(AppStore)怒られ事情\r\n・一生内緒にするつもりだった！書き込みゼロのアプリ内掲示板をアクティブにした裏技","startsAt":"2018-02-09T15:40:00","endsAt":"2018-02-09T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["3758e06c-baa7-414b-a736-1ba696dea164"],"categoryItems":[3481,3483,3500,3540],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=aJjQX1OXrhU","slideUrl":"https://www.slideshare.net/YurikoNagao/droidkaigi2018-87644086/YurikoNagao/droidkaigi2018-87644086"},{"id":"16988","title":"ConstraintLayout, now and future","description":"ConstraintLayout 1.0 made building flexible UI easy, with a deep integration in the Android Studio layout editor. The recently introduced 1.1 version is bringing even more flexibility, with new capabilities like barriers or groups. This talk will take a deeper look at the current state of the library, why you should use it and when: architecture, performance behavior, examples of complex UI, animation capabilities, extending the library in your project via subclassing, and discussing some upcoming features.\r\n","startsAt":"2018-02-09T15:40:00","endsAt":"2018-02-09T16:30:00","isServiceSession":false,"isPlenumSession":false,"speakers":["e3267cf5-b1a7-4ce7-a4b3-223925f21316","2552a9af-0f8c-44a1-af1f-f8756353ba83","a7d0fcec-49dd-4e65-bcb7-ad3d1901928c"],"categoryItems":[3481,3482,3487,3541],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=dE7T_ssiOvE","slideUrl":"https://www.slideshare.net/hagikuratakeshi/constraintlayout-now-and-future"},{"id":"16746","title":"ウィンドウサイズの変更に強い堅牢な画面の構築","description":"Androidアプリの開発では多様な画面サイズや画面回転への対応など、柔軟性を意識してUI・レイアウトの構築を行う必要があります。また、Android 7.0でのマルチウィンドウのサポートもあり、画面構成の変更時の状態保持に対する理解の重要性も高まっています。\r\n\r\nこのセッションでは、ウィンドウサイズの変更に強い画面の構築を通して得た知見、Tipsを共有していきたいと思っています。\r\n\r\n■ 対象者\r\n\r\n・マルチウィンドウや横画面でも表示の崩れないレイアウトの構築に興味のある方\r\n・構成の変更時（ウィンドウのリサイズ、画面回転等）の画面状態の保持に対して苦手意識を持っている方\r\n\r\n■ 内容（予定）\r\n\r\n① ウィンドウサイズの変更に強いUI・レイアウトの構築について\r\n・様々な画面サイズ、OSバージョンで表示の崩れないレイアウトを構築する上でヒントとなる知見やTips\r\n・fitsSystemWindows / WindowInsetsを活用してシステムUI（ステータスバー等）のサイズに影響されないレイアウトを組む方法\r\n\r\n② 構成の変更時の画面の状態保持について\r\n・savedInstanceState、setRetainInstance、それぞれの状態保持の手法の利点と使い分け\r\n・Android 7.0で強化されたonSaveInstanceStateで保存するペイロードへのサイズ制限とその対策\r\n・構成の変更とActivityの再生成を理解した上で、画面の状態保持に対して取りうる戦略を考える\r\n※特定のアーキテクチャとの組み合わせでのより効果的な解決方法など、発展的な内容にまでは踏み込みません。","startsAt":"2018-02-09T16:50:00","endsAt":"2018-02-09T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["18265cec-5176-4fd7-b93f-077e8db95958"],"categoryItems":[3480,3483,3495,3541],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=nQ4kVMBsvZ4","slideUrl":"https://speakerdeck.com/nakamuuu/droidkaigi-2018"},{"id":"16836","title":"🏴‍☠️ ARrrrg! The Google AR Android Demo Application deciphered. 🏴‍☠️","description":"🏴‍☠️ ARrrrg! 🏴‍☠️\r\n\r\nThis was my first reaction reading through the code of the sample provided by Google for it's new ARCore. After the first shock, I took a close look on how the app works, and what ARCore could do for my use case: Having my virtual collection of toy figures always with me ❤️. 🤖🤴\r\n\r\nIn this talk, I will talk about Augmented Reality, walk through the current demo app for ARCore on Android and purpose a better way of writing the app, extending it to be able to read different models at different times ...\r\n\r\nExpect a bit of Computer Graphics terminology, source code watching, Pirates, and more lame jokes.\r\n","startsAt":"2018-02-09T16:50:00","endsAt":"2018-02-09T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["fc80cf34-563e-4cd4-a04d-23d1191a7812"],"categoryItems":[3480,3482,3500,3540],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=kCaczKU5a6o","slideUrl":"http://bit.ly/pirate-ar-japan"},{"id":"16934","title":"HTTPS通信の基本からNetwork Security Configurationまで","description":"iOSエンジニアは必要に迫られてATS対応というものを実施しているようですが、Androidエンジニアは何もしなくていいのでしょうか？\r\n本セッションでは、HTTPS通信の役割と仕組み、Android MのusesCleartextTrafficの設定、Android NからのNetwork Security Configurationの設定について解説したいと思います。\r\nまた、HTTP Public Key Pinningについても触れます。\r\n\r\n本セッションを通して、ユーザーがより安全にアプリを利用できるようにするために、Androidエンジニアとして何ができるかを考えるきっかけにできると幸いです。","startsAt":"2018-02-09T16:50:00","endsAt":"2018-02-09T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["9b163902-7cf0-4cb7-bfd6-edae47c221f3"],"categoryItems":[3480,3483,3500,3540],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=S_kmkGHTjU4","slideUrl":"https://speakerdeck.com/a2kaido/httpsfalseji-ben-kara-networksecurityconfigmade"},{"id":"16985","title":"アプリをエミュレートするアプリの登場とその危険性","description":"ここ数年でいくつかの、他のAndroidアプリをエミュレートするAndroidアプリが登場しています。その多くがLINEやゲームを2アカウント同時使用できることを謳っており、多くのユーザーに使われていると思われます。\r\n本セッションではこれらのアプリがどのようにして他のアプリをエミュレートしているのか調査した結果と、これらのアプリを使用することによる危険性の分析について発表を行います。","startsAt":"2018-02-09T16:50:00","endsAt":"2018-02-09T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["29167627-84bc-4a74-a3bf-3a17b837a468"],"categoryItems":[3480,3483,3500,3542],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=fZEln44l23s","slideUrl":"https://www.slideshare.net/TakakiHoshikawa/how-multiaccount-app-works"},{"id":"17025","title":"Accessibility Service でできてしまうこと","description":"一般的なアプリを開発している際には、ほぼお目にかかることはなく、日本語での情報も少ない Android の機能「Accessibility Service」。\r\n許可にはユーザーに設定画面から許可をしてもらう事が必要になっており、デバイス全体を握ることも可能な権限をも付加させることができます。\r\n通常であれば視覚障がい者の方などへの読み上げサービスとして使用するなどが正しい使い方ですが、一方でその権限の高さを悪用したウイルスアプリなども存在しています。\r\n\r\nこのセッションでは、正しく Accessibility Serviceを使用するとこんな機能が作れるというのを紹介しながら、逆に Accessibility Service を使用するとここまでできてしまうという紹介をしていきたいと考えています。\r\n\r\nセッション予定\r\n- Accessibility Service 概要\r\n- Accessibility Service を使用したデモ/実装紹介 ①\r\n- Accessibility Service を使用したデモ/実装紹介 ②\r\n- Accessibility Service を使用したデモ/実装紹介 ③","startsAt":"2018-02-09T16:50:00","endsAt":"2018-02-09T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["ac65e990-2298-41b5-ab5a-49b366a23928"],"categoryItems":[3480,3483,3495,3542],"questionAnswers":[],"roomId":520,"videoUrl":"https://www.youtube.com/watch?v=H1WciBIngkc","slideUrl":"https://www.slideshare.net/r-ralph/accessibilityservice/"},{"id":"17047","title":"Androidではじめるデザインスプリント","description":"デザインスプリントは短期間でプロトタイピングと検証を繰り返しアイデアを洗練させるGoogleの提唱するスタートアップ向けプログラムです。\r\n本トークではデザインスプリントの紹介からワークショップの体験記、現場への導入まで、デザインスプリントをやってみてよかったこと難しかったことなどをお話します。\r\nプログラミングに入る前からがアプリ開発です。\r\nアプリ開発のための選択肢をより広げるために、デザインスプリントという手法のご紹介をできればと思います。\r\n\r\n","startsAt":"2018-02-09T16:50:00","endsAt":"2018-02-09T17:20:00","isServiceSession":false,"isPlenumSession":false,"speakers":["f31f7c75-b609-405e-8c24-320933bdc6ad"],"categoryItems":[3480,3483,3490,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=GcABJl4ntfU","slideUrl":"https://speakerdeck.com/mochico/start-the-design-sprint-with-android"},{"id":"15572","title":"複数センサーシミュレーションによる行動認識(ActivityRecognition)解剖、そして実用化","description":"近年のAndroidデバイスには多くのセンサーが組み込まれるようになった。Googleはこれらのセンサーを活用してActivityRecognitionというユーザーの行動認識APIをAndroidフレームワークで提供した。\r\nユーザーの行動を認識することによって、アプリケーションプロバイダは適切なタイミングで適切な内容のコンテンツを提示することができるようになる。\r\n例えば車を運転中であれば、車やドライブに関する情報である。\r\n\r\nこのActivityRecognitionを実用的に活用するためには、その認識精度が非常に重要になる。誤認識が発生するとユーザー離反の原因となり得る。また、ActivityRecognitionのエンジン自体はブラックボックスとなっているため、改善が難しい。\r\n\r\nこのセッションではActivityRecognitionの基本的な利用方法を説明し、現状の認識精度を調べた結果を報告する。さらに、複数のセンサーデータをシミュレーションし、精度向上のヒントとなる情報を探る。最後に実用的なActivityRecognitionの利用方法を説明する。","startsAt":"2018-02-09T17:40:00","endsAt":"2018-02-09T18:10:00","isServiceSession":false,"isPlenumSession":false,"speakers":["6cfaa375-15c0-438b-9f34-d5b2feaf590b"],"categoryItems":[3480,3483,3492,3541],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=07vb5IGhwL8","slideUrl":"https://speakerdeck.com/kakka/20180209-droidkaigi2018-activityrecognition-simulation"},{"id":"15917","title":"Android WearのWatch Faceを作ろう 〜時計の盤面に小さな情報を添えて〜","description":"■概要\r\nAndroid Wearでは、時計の盤面を変更することができます。その時計の盤面というのがWatch Faceと呼ばれるものです。\r\nWatch Faceは、Android Wearを利用する上でユーザーの目に最も触れる機能です。\r\nAndroid WearのWatch Faceは単純に日時を表示するだけではなく、歩数や天気などの小さな情報も表示できます。\r\nこのセッションでは、Android WearのWatch Faceに関連するAPIや、それを利用したWatch Faceの実装方法、そしてWatch FaceをPlayストアに公開する方法などについてお話します。\r\n\r\n■対象者\r\n- Android Wearアプリ開発に興味がある人\r\n- Android WearアプリのWatch Faceに興味がある人\r\n- Androidアプリ開発をある程度やったことのある人\r\n\r\n■目次案\r\n- Watch Faceとは\r\n- Watch Faceに関連するAPIについて\r\n　- Watch Face API\r\n　- Complications API\r\n- Watch Faceを作ってみよう\r\n　- Android Wearアプリのデバッグ方法\r\n　- Watch Face APIを利用して時計を描画する\r\n　- Complications APIを利用してWatch Faceに小さな情報を表示する\r\n　- Watch Faceの設定画面を用意する\r\n- Watch Faceを公開しよう\r\n　- Android Wearアプリ単体で公開する\r\n　- Android Wearアプリを既存アプリのAPKに含める\r\n　- Android Wearアプリの審査について","startsAt":"2018-02-09T17:40:00","endsAt":"2018-02-09T18:10:00","isServiceSession":false,"isPlenumSession":false,"speakers":["9bd231a5-d846-4f6e-873a-54a2fae779d7"],"categoryItems":[3480,3483,3499,3542],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=_YW64RUusG4","slideUrl":"https://speakerdeck.com/syarihu/droidkaigi-2018-android-wearfalsewatch-facewozuo-rou-shi-ji-falsepan-mian-nixiao-sanaqing-bao-wotian-ete"},{"id":"16980","title":"AI is ready for you. Are you ready for AI?","description":"Google announced that Google shifts from mobile-first to AI-first at Google I/O 2017. What does it mean?\r\nIn this talk, I will talk about 3 things.\r\n\r\nFirst, we will see environment changes around us. You may think \"AI is not my business\" but it happens. I will talk how our life has been changed and what will happen in the future.\r\nThen, I will introduce the basics of machine learning and how to run machine learning models on Android devices. I will also refer to machine learning frameworks and JNI.\r\nFinally, I will share knowledge of continuous improvement of machine learning products. When you want to deploy your model to production, you have to think about more things such as APK size, CPU usage, memory usage, versioning, monitoring, ... We will see how to address these challenges.\r\n\r\nYou will learn what I've learnt in 30 min. This is what I wanted to know when I started machine learning.","startsAt":"2018-02-09T17:40:00","endsAt":"2018-02-09T18:10:00","isServiceSession":false,"isPlenumSession":false,"speakers":["234b5acc-7f5f-4be7-a7f1-4f26fd466d82"],"categoryItems":[3480,3482,3500,3541],"questionAnswers":[],"roomId":519,"videoUrl":"https://www.youtube.com/watch?v=qy-rO7TrzqQ","slideUrl":"https://speakerdeck.com/rejasupotaro/ml-on-mobile-droidkaigi-2018"},{"id":"17028","title":"コードで見るFlutterアプリの実装","description":"FlutterはAndroid、iOS両方のアプリをDartで書けるフレームワークです。Firebaseとの連携やMaterialデザインに沿ったUIコンポーネントが標準で用意されています。\r\n\r\n公式ドキュメントやcodelabを見れば一通りの実装はできるのですが、国際化やキャッシュ、CIといった細かい部分の実装をどうすればいいのかはまだ実例が少ない印象です。\r\n\r\n本セッションでは、少し複雑なサンプルアプリを例に、Flutterのここどうすればいいの？という部分を説明していきます。","startsAt":"2018-02-09T17:40:00","endsAt":"2018-02-09T18:10:00","isServiceSession":false,"isPlenumSession":false,"speakers":["903eaf98-bf70-42a1-80da-6af3c5ec6668"],"categoryItems":[3480,3483,3499,3542],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=sRV_bSdyDjw","slideUrl":"https://speakerdeck.com/konifar/kododejian-ruflutterapurifalseshi-zhuang"},{"id":"17039","title":"マルチログインの実装方法","description":"【概要】\r\n最近のSNSアプリには当たり前のようにマルチログイン機能が実装されるようになっていますが、いざ自分でこのマルチログインを実装しようとすると様々な壁にぶつかります。具体的には、シングルトンの扱いや、実行中の非同期処理のキャンセル、永続化されたデータの扱いなどです。本発表では、マルチログイン機能を開発するための手法を解説します。\r\n\r\n【対象者】\r\n・マルチログイン機能の実装に悩んでいる方\r\n・マルチログインによってコードが複雑化してしまって困っている方\r\n\r\n【目次】\r\n・マルチログインの定義\r\n・マルチログインの実装において障壁となるもの\r\n    ・シングルトン\r\n    ・実行されている非同期処理\r\n    ・永続化されたデータ\r\n・障壁を回避するための方法論\r\n    ・シングルトンで定義して良いもの、ダメなもの\r\n    ・非同期処理の管理方法\r\n    ・Daggerを使った永続化データのコンテナ化","startsAt":"2018-02-09T17:40:00","endsAt":"2018-02-09T18:10:00","isServiceSession":false,"isPlenumSession":false,"speakers":["2670ad95-16dc-4133-b2f7-4998a82b3262"],"categoryItems":[3480,3483,3500,3542],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=--pbfs918TM","slideUrl":"https://speakerdeck.com/yuyakaido/droidkaigi-2018"},{"id":"15945","title":"開発者が知っておきたい通知の歴史","description":"■対象者\r\n・Android初級者〜中級者\r\n\r\n■概要\r\nアプリのユーザーにとって、通知はとても重要な機能です。適切なタイミングで適切な内容を出すことでユーザーの利便性を向上できる一方、過度な通知や見た目の悪い通知を出せばユーザーのアプリへの信頼を損なう恐れもあります。\r\nGoogleも通知を重要な機能と捉えているため、Androidの通知APIはOSのバージョンアップのたびに頻繁に更新が入ります。アクションボタン、スタイル、ヘッドアップ通知、スタッキング、チャンネル、etc。新しい機能がバージョンアップのたびに追加されるため、開発者が後方互換性を維持したまま通知機能を開発していくのは大変な作業です。Support Libraryでも一部応されていますが、実際にはバージョンごとに分岐を書かなくてはいけないことも多いのではないでしょうか。\r\n本セッションでは、Androidの通知がどのような変遷を経てきたかを機能ごとに振り返るとともに、ICSからOreo※までをサポートするためにはどういう実装をすればいいか、どのOSの組み合わせて検証すればいいか、他にどこに気をつければいいかを解説します。\r\n\r\n※Support LibraryがICSより古いOSのサポートを切っているため、ICS以前の通知は本セッションのスコープ外とします。\r\n\r\n\r\n","startsAt":"2018-02-09T18:30:00","endsAt":"2018-02-09T19:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["6fba26d1-7b30-4877-965b-de2c4721252f"],"categoryItems":[3480,3483,3495,3540],"questionAnswers":[],"roomId":514,"videoUrl":"https://www.youtube.com/watch?v=IlFT4XQCivg","slideUrl":"https://speakerdeck.com/kobakei/kai-fa-zhe-gazhi-tuteokitaitong-zhi-falseli-shi"},{"id":"16867","title":"UIテストの実行時間を短縮させる方法","description":"「対象者」\r\n・UIテストの実行時間で悩んでいる人\r\n・UIテストに興味がある人\r\n\r\n「概要」\r\nAndroidアプリにおけるUIテストは以前と比べ、実装しやすくなってきています。\r\nそのためUIテストを実装する方が増えてきているかもしれません。\r\n\r\nしかし、UIテストの実行時間は問題になりやすいです。\r\nせっかく実装した価値のあるUIテストも、実行時間の長さによりあまり利用されないといったケースもあります。\r\n\r\nUIテストだからしょうがないと諦めてしまっては勿体ありません。\r\n\r\n本トークでは、SWETが取り組んでいるUIテストの実行時間を短くするための色々な方法について述べます。\r\ntipsレベルからSWETが開発しているサービスまで紹介する予定です。","startsAt":"2018-02-09T18:30:00","endsAt":"2018-02-09T19:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["90a962b5-9d71-4ff8-90ed-d4130477672c"],"categoryItems":[3480,3483,3493,3540],"questionAnswers":[],"roomId":515,"videoUrl":"https://www.youtube.com/watch?v=Rz00bOk-Ej4","slideUrl":"https://www.slideshare.net/tarappo/ui-87594732"},{"id":"16927","title":"Gradle\u0001プラグインを作って開発効率を改善しよう","description":"昨今のAndroid開発において、Gradleはビルドを司る重要なシステムです。その動作を司るbuild.gradleには、アプリ開発における効率を高める無限の可能性がありますが、気がついたらいつも同じスクリプトをコピー＆ペーストしていたりしませんか？その改善をプラグインとして作り、公開することができれば、自分だけではなく世界の開発を改善することができます！\r\n\r\nこのセッションでは、Androidのビルド改善に取り組もうとしている＆既に取り組まれている方を対象として、Gradleプラグインの作成を最小の構成から始め、そのデバッグ方法や、単独のプロジェクトへの切り出し、公開方法までを手順を追って紹介します。\r\n\r\nプラグインというと難しそうに感じますが、その実態はただのJavaクラスです。新しいファイルを作ることさえなしに、まずはbuild.gradleの中で定義することから始めましょう。","startsAt":"2018-02-09T18:30:00","endsAt":"2018-02-09T19:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["b1a38db0-bc4e-4747-85fd-ed268d1607ed"],"categoryItems":[3480,3483,3498,3540],"questionAnswers":[],"roomId":516,"videoUrl":"https://www.youtube.com/watch?v=Lo326kQt7L8","slideUrl":"https://speakerdeck.com/tnj/guide-to-build-gradle-plugin-for-efficient-development"},{"id":"17029","title":"Android ThingsとFirebaseで始めるホームセキュリティ","description":"◾️概要\r\nRasberryPiにAndroidThingsをインストールして簡易なホームセキュリティを構築する手順、Tips、苦労話を話します。\r\nセンサーの取り扱い方やFirebaseを使う事でサーバーを用意せずにAndrodアプリから監視する方法も紹介します。\r\n\r\n◾️アジェンダ(仮)\r\n・AndroidThingsとは\r\n・AndroidThingsでセンサーを取り扱う\r\n・Firebaseを使ってAndroid端末とやり取りを行う\r\n・AndroidThingsの辛い話\r\n\r\n◾️対象者\r\nAndroidアプリ開発の経験者\r\nAndroidThingsで何か作ってみたい人\r\n電子工作してみたい人","startsAt":"2018-02-09T18:30:00","endsAt":"2018-02-09T19:00:00","isServiceSession":false,"isPlenumSession":false,"speakers":["bf35117b-cbda-4c2a-90ee-efa9e9e8cc93"],"categoryItems":[3480,3483,3492,3540],"questionAnswers":[],"roomId":518,"videoUrl":"https://www.youtube.com/watch?v=_bo906TKxZo","slideUrl":"https://speakerdeck.com/katsuyax/android-things-home-security"}],"speakers":[{"id":"532dc16d-b69d-4f68-aa49-fe9878b0b52f","firstName":"","lastName":"","bio":"Adarsh is a Googler on the Android Studio team. He has written multiple guides for developers focused on optimizing Gradle build configurations and harnessing features of the Android plugin for Gradle—from beginner topics like creating build variants, to advanced ones like managing complex multi-module builds.","tagLine":"Google","profilePicture":"https://sessionize.com/image?f=ddcf981408c6d94b822f8d81975cb498,200,200,True,False,e7bdf209-26ed-4e56-bbc9-8fcd0b9b5eea.jpg","isTopSpeaker":false,"links":[],"sessions":[16857],"fullName":"Adarsh Fernando"},{"id":"650f26f7-5a6e-43a0-958d-62ab2cc0ae84","firstName":"","lastName":"","bio":"2008年入社\r\n2014年より社内のAndroid セキュリティに関する業務に従事","tagLine":"Nttdata","profilePicture":"https://sessionize.com/image?f=99fa70941cb9502fae23d6501a8aa324,200,200,True,False,b5993f9b-2094-4106-8424-b887a6e1be8c.jpg","isTopSpeaker":false,"links":[],"sessions":[16948],"fullName":"Akihiro Shiota"},{"id":"9b163902-7cf0-4cb7-bfd6-edae47c221f3","firstName":"","lastName":"","bio":"サーバーサイドエンジニアでしたが、二年くらい前にAndroidエンジニアになりました。好きな言葉は、SharedElementとShapeShifter。","tagLine":"Android Developer","profilePicture":"https://sessionize.com/image?f=71f7451be83defd7151a8089c384c596,200,200,True,False,02-7cf0-4cb7-bfd6-edae47c221f3.578aa4ce-e550-42d9-865e-3db44c03fd1d.jpg","isTopSpeaker":false,"links":[],"sessions":[16934],"fullName":"Amane Nikaido"},{"id":"af079576-c7db-497a-990d-919fc2472e45","firstName":"","lastName":"","bio":"Anastasia a very passionate Android developer working @ Movivo. She like cupcakes, chocolate, and all types of sweets, which is probably what led her to the Android world.","tagLine":"Android developer at Movivo","profilePicture":"https://sessionize.com/image?f=6357a98ddf562c9568cf01e8241f1c46,200,200,True,False,e006ee82-8c3f-4c15-9e44-c20424511e04.jpg","isTopSpeaker":false,"links":[],"sessions":[16079],"fullName":"Anastasia"},{"id":"5752b1a2-717b-44c8-a247-64be0b7dcf2b","firstName":"","lastName":"","bio":"日本で最初に発売されたHT-03A時代からずっとAndroid開発をしている。(7年ぐらい)\r\n学生時代にAndroid Application Award等の受賞経験等を経て、2015年サイバーエージェントに新卒で入社し、FRESH!という動画サービスの立ち上げから現在も開発を続けている。\r\nFRESH!は立ち上げ当初の2015年4月からフルKotlinで開発をしている。","tagLine":"CyberAgent, Inc.","profilePicture":"https://sessionize.com/image?f=76fb13a0c0325962a2eb1fc3c52adfd1,200,200,True,False,a2-717b-44c8-a247-64be0b7dcf2b.5dda6eb5-d319-4f31-86d0-2313df7207a7.jpeg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/_a_akira","linkType":"Twitter"},{"title":"GitHub","url":"https://github.com/AAkira","linkType":"Other"},{"title":"Company Website","url":"https://github.com/AAkira","linkType":"Company_Website"},{"title":"Qiita","url":"https://qiita.com/AAkira","linkType":"Other"}],"sessions":[16941],"fullName":"a.akira"},{"id":"3262db6c-d659-4109-a410-2b8dac1bf737","firstName":"","lastName":"","bio":"Xamarin.AndroidプラットフォームのSDKを開発しているエンジニア。Embeddinator-4000にもcontributeしている。","tagLine":"xamarin","profilePicture":"https://sessionize.com/image?f=2bd581cb950481660e3d73cdb5e6ab94,200,200,True,False,88fe37b8-3881-4202-8814-c7469d973e8f.jpg","isTopSpeaker":false,"links":[],"sessions":[15559],"fullName":"atsushieno"},{"id":"449b4215-55cc-444f-8ff4-b0c434a96019","firstName":"","lastName":"","bio":"Benoît is an Android developer at Cybozu, based in Japan. He focuses on providing the best Android experience possible, both to customers and fellow developers.","tagLine":"Android Engineer @ Cybozu","profilePicture":"https://sessionize.com/image?f=785a3f42fa4308f84d70886b2f25f56a,200,200,True,False,15-55cc-444f-8ff4-b0c434a96019.0cde7eba-d569-4f65-85b6-7a08c64ed67a.png","isTopSpeaker":false,"links":[{"title":"benoitquenaudon.com","url":"https://benoitquenaudon.com/","linkType":"Other"},{"title":"Twitter","url":"https://twitter.com/oldergod","linkType":"Twitter"}],"sessions":[16498],"fullName":"Benoit Quenaudon"},{"id":"bbf9c2ed-21be-4388-a6b4-138561d76376","firstName":"","lastName":"","bio":"Chet leads the Android UI Toolkit team at Google, where he works on graphics, animations, UI elements, and anything else that lights up pixels. Chet also gets out of the office occasionally to write and perform comedy, or to present at developer conferences like this one.","tagLine":"Software and comedy, not necessarily in that order.","profilePicture":"https://sessionize.com/image?f=55aa30f54d446448fbb909d01d1d3cc6,200,200,True,False,ea7d3a1b-86b1-4e36-a7a7-21cc107a30f2.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/chethaase","linkType":"Twitter"},{"title":"Blog","url":"https://medium.com/@chethaase/","linkType":"Blog"}],"sessions":[16534],"fullName":"Chet Haase"},{"id":"2f606e32-997a-4b74-8420-76a47e7d66a3","firstName":"","lastName":"","bio":"Enrique López Mañas is a Google Developer Expert and independent IT consultant. He has been working with mobile technologies and learning from them since 2007. He is an avid contributor to the open source community and a FLOSS (Free Libre Open Source Software) kind of guy, being among the top 10 open source Java contributors in Germany. He is a part of the Google LaunchPad accelerator, where he participates in Google global initiatives to influence hundreds of the best startups from all around the globe. He is also a big data and machine learning aficionado.\r\n\r\nIn his free time he rides his bike, take pictures, and travels until exhaustion. He also writes literature and enjoys all kinds of arts. He likes to write about himself in third person. You can follow him on Twitter (@eenriquelopez) to stay updated on his latest movements.","tagLine":"Google Developer Expert","profilePicture":"https://sessionize.com/image?f=45f06f55450db5cd0e212980513befec,200,200,True,False,34285f3a-76cf-4459-960a-a960e4ccd67a.jpg","isTopSpeaker":false,"links":[],"sessions":[16740],"fullName":"Enrique Lopez Mañas"},{"id":"de26fcbb-7b43-4c56-b1dc-d808674f1114","firstName":"","lastName":"","bio":"Eric is a Senior Android Engineer at Tumblr focused on app architecture and performance. In his free time, he enjoys photographing minimalist architecture.","tagLine":"Senior Android Engineer at Tumblr","profilePicture":"https://sessionize.com/image?f=b330d88d9ff1cdb5af262d61c0e7da03,200,200,True,False,1905d75e-6cc5-4995-b419-2e877b799863.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/ericwleong","linkType":"Twitter"},{"title":"LinkedIn","url":"https://www.linkedin.com/in/eric-leong-92347145/","linkType":"LinkedIn"},{"title":"Blog","url":"http://ericleong.me/writing","linkType":"Blog"},{"title":"Company Website","url":"https://tumblr.com","linkType":"Company_Website"},{"title":"Github","url":"https://github.com/ericleong","linkType":"Other"}],"sessions":[17046],"fullName":"Eric Leong"},{"id":"78606c3b-8fc6-4960-9ed2-6005feaa439c","firstName":"","lastName":"","bio":"Principal Android Engineer at @Nikkei\r\n\r\nhttps://github.com/srym\r\nhttps://www.linkedin.com/in/fumihiko-shiroyama-632045136/","tagLine":"Android Testing Enthusiast","profilePicture":"https://sessionize.com/image?f=6cafc6252b06097e0912d922d91d6d13,200,200,True,False,3b-8fc6-4960-9ed2-6005feaa439c.ee58a8f7-0d49-4279-8295-7cb84bc3bbf1.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/fushiroyama","linkType":"Twitter"},{"title":"LinkedIn","url":"https://www.linkedin.com/in/fumihiko-shiroyama-632045136/","linkType":"LinkedIn"},{"title":"Blog","url":"http://www.shiroyama.blog/","linkType":"Blog"},{"title":"Company Website","url":"https://www.wantedly.com/companies/nikkeiinc","linkType":"Company_Website"},{"title":"GitHub","url":"https://github.com/srym","linkType":"Other"}],"sessions":[16942],"fullName":"@fushiroyama"},{"id":"e37b5a6b-6076-4869-a3f4-2e83df298c98","firstName":"","lastName":"","bio":"2015年より日本電信電話株式会社，NTTセキュアプラットフォーム研究所所属\r\nモバイルセキュリティに関する研究開発に従事","tagLine":"NTT Secure Platform Laboratories","profilePicture":"https://sessionize.com/image?f=52e89b4fcb6bc47d9f3908ca13b82930,200,200,True,False,6b-6076-4869-a3f4-2e83df298c98.d040afe4-3ff7-404c-b8fa-eac4bba97702.png","isTopSpeaker":false,"links":[],"sessions":[16948],"fullName":"Fumihiro Kanei"},{"id":"ac30f54a-d80a-453e-adab-5a8623e3dcd1","firstName":"","lastName":"","bio":"Gautier is an Android Developer by day, and a Google Developer Expert for IoT","tagLine":"Android Craftsman","profilePicture":"https://sessionize.com/image?f=089691ccac1e330f43f58387de4380b5,200,200,True,False,4a-d80a-453e-adab-5a8623e3dcd1.366e790d-d7c2-497e-98f4-5e85550fe469.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/Nilhcem","linkType":"Twitter"},{"title":"Blog","url":"http://www.nilhcem.com","linkType":"Blog"}],"sessions":[15558],"fullName":"Nilhcem"},{"id":"bdb86449-b985-4e60-bc03-19f5bcf2f4d4","firstName":"","lastName":"","bio":"Gerry have been working at Google for 3 years, focusing on Android NDK samples and helping application developers to create great Android development experience.","tagLine":"DPE at Google","profilePicture":"https://sessionize.com/image?f=d36181dbc654c190280b5b6bb2476978,200,200,True,False,4f9c8abb-3d4d-4591-9253-1e521657b766.jpg","isTopSpeaker":false,"links":[],"sessions":[16710],"fullName":"Gerry Fan"},{"id":"85b6291b-4870-4a9a-82b1-be5979623fc0","firstName":"","lastName":"","bio":"最近はRuby on Rails, React, TypeScriptなどで開発することが多いAndroidエンジニア。Android用のORMであるAndroid Ormaの開発者。","tagLine":"Software Engineer at Bit Journey, Inc.","profilePicture":"https://sessionize.com/image?f=7d66d22862e24bc8c2b2012b226b532a,200,200,True,False,f249a58b-753a-4365-989f-26c5b660c1e4.jpg","isTopSpeaker":false,"links":[],"sessions":[17030],"fullName":"gfx"},{"id":"7b71b1fd-bf15-4721-883f-32b90d7a4a91","firstName":"","lastName":"","bio":"Google Developer Advocate for game technology.\r\n","tagLine":"Google","profilePicture":"https://sessionize.com/image?f=9430ab6d6f1bff02a8cba18e223c73af,200,200,True,False,ecb88931-1e80-48ae-a6f1-5747e9e92957.jpg","isTopSpeaker":false,"links":[],"sessions":[16710],"fullName":"hak@"},{"id":"ac65e990-2298-41b5-ab5a-49b366a23928","firstName":"","lastName":"","bio":"2011年にAndroidのアプリの開発を行い始める\r\n2015年からは 元クックパッドの事業である Holiday のAndroidアプリの製作に携わっている\r\n現在大学4年生\r\n","tagLine":"Ralph","profilePicture":"https://sessionize.com/image?f=520e7a99ee9500944658808e6cd66320,200,200,True,False,90-2298-41b5-ab5a-49b366a23928.9ef32005-09f6-4736-81bb-666a50e72790.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/r_ralph_h","linkType":"Twitter"},{"title":"Blog","url":"https://ralph.ms/","linkType":"Blog"}],"sessions":[17025],"fullName":"Tamaki Hidetsugu"},{"id":"33bb4b3b-898e-43e5-99d0-be8e0f02865e","firstName":"","lastName":"","bio":"システム開発会社を経て2010年mixi入社\r\n2012年よりAndroidアプリ開発チームにjoin\r\n2015年よりモンストクライアント開発チームを経て、2017年4月よりminimo開発チームでAndroid版の開発を担当","tagLine":"Android dev at mixi, inc","profilePicture":"https://sessionize.com/image?f=f9a35187cc002a37966997770db7fb6c,200,200,True,False,3b-898e-43e5-99d0-be8e0f02865e.cd24835f-81e3-40c4-9266-7186045afc4a.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/hidey","linkType":"Twitter"},{"title":"Company Website","url":"https://mixi.co.jp/","linkType":"Company_Website"}],"sessions":[15984],"fullName":"HideyukiKikuma"},{"id":"2f50ba75-0356-4d2e-8b2b-7343fd3e4377","firstName":"","lastName":"","bio":"Web 系企業の Android 開発者です。","tagLine":"Android app developer","profilePicture":"https://sessionize.com/image?f=aea2b5bd785eecb5f25bac810474531c,200,200,True,False,75-0356-4d2e-8b2b-7343fd3e4377.90a7142e-3384-49f9-ba39-cbde0acc88da.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/toastkidjp","linkType":"Twitter"},{"title":"Blog","url":"https://qiita.com/toastkidjp","linkType":"Blog"},{"title":"Sub Blog","url":"https://reminiscencesoftoastkid.tumblr.com/","linkType":"Other"}],"sessions":[15575],"fullName":"toastkidjp"},{"id":"0d5788fd-e1bc-4e1b-a340-2db0765f26cb","firstName":"","lastName":"","bio":"アナログ回線とSIPサーバをつなぐゲートウェイ、ICカードOS、ドライバを作るお仕事などを経て、現在は株式会社ジャストワークでiOS、Android向けのアプリを作っています。","tagLine":"JUSTWORK Co., Ltd.","profilePicture":"https://sessionize.com/image?f=64d358749f3115724b3afaab261cc61f,200,200,True,False,fd-e1bc-4e1b-a340-2db0765f26cb.2b6f2e2d-3865-4c4f-b9ce-3d789e99b51a.jpeg","isTopSpeaker":false,"links":[],"sessions":[16535],"fullName":"azukinohiroki"},{"id":"69924067-07aa-43e7-90ba-c17ff70d2638","firstName":"","lastName":"","bio":"Having been working on Android app. for three years. Co-host of dex.fm.","tagLine":"Software Engineer at Fablic, Inc.","profilePicture":"https://sessionize.com/image?f=3ac96041462978b5601d93f17a14db2e,200,200,True,False,100f7a96-c1eb-4724-b149-d608a0ee7c11.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/hydrakecat","linkType":"Twitter"}],"sessions":[16933],"fullName":"hydrakecat"},{"id":"299d3761-e25a-4df7-bea1-fe6e391938bd","firstName":"","lastName":"","bio":"Yahoo! JAPANのAndroid黒帯として、社内のAndroidアプリ開発者育成や、社外との技術連携などを行っています。","tagLine":"Yahoo! JAPAN, Android黒帯","profilePicture":"https://sessionize.com/image?f=7b6f370e0c7c3722fe3f66730b482679,200,200,True,False,9eb78b14-b9d2-4eec-832d-50155ad7d879.jpg","isTopSpeaker":false,"links":[],"sessions":[16633],"fullName":"Hiroyuki Mori"},{"id":"03c63012-49c4-44eb-af96-0f5360b0d187","firstName":"","lastName":"","bio":"Ishan is a passionate product enthusiast and self-taught developer who loves open source technologies, tech conferences, and hackathons.\r\n\r\nCurrently as an Android Engineer at Booking.com (Amsterdam, Netherlands), he is helping people enjoy their vacations across the world. \r\n\r\nHe is also PMC member at Apache Fineract Project, Android Code maintainer at Mifos Initiative and he successfully graduated as a Google Summer of Code Intern in 2014 under Mifos and in 2015 under XMPP Standards Foundation and mentored students at Google Summer of Code (2016).\r\n","tagLine":"Android Engineer @ Booking.com","profilePicture":"https://sessionize.com/image?f=6eca847faf441b5714b9b2ec855c9fc0,200,200,True,False,12-49c4-44eb-af96-0f5360b0d187.1d9dc50d-0356-4921-b48f-cdd6b0ede214.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/@droidchef","linkType":"Twitter"},{"title":"LinkedIn","url":"https://www.linkedin.com/in/ishankhanna/","linkType":"LinkedIn"}],"sessions":[16141],"fullName":"Ishan Khanna"},{"id":"ae00a99a-5a4f-45f4-bc8f-6460579522d6","firstName":"","lastName":"","bio":"Playing with #Android Things @Google","tagLine":"Developer Programs Engineer","profilePicture":"https://sessionize.com/image?f=2f5e8be633b68f13cea03cf45501b905,200,200,True,False,9a-5a4f-45f4-bc8f-6460579522d6.ede1601e-0561-497a-9642-c823a68eef63.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/proppy","linkType":"Twitter"}],"sessions":[16228],"fullName":"proppy"},{"id":"a7d0fcec-49dd-4e65-bcb7-ad3d1901928c","firstName":"","lastName":"","bio":"John is a developer on Android working on Android Studio and ConstraintLayout. He has worked on Android Studio, RenderScript, Vector Drawables, computed shadows and photo editor filters. Prior to joining Google, John was a principal engineer at GE Healthcare working on their image processing applications framework\r\n\r\nTwitter: John Hoford (@johnhoford) \r\n\r\nGoogle+ : https://plus.google.com/+JohnHoford","tagLine":"Android developer at Google","profilePicture":"https://sessionize.com/image?f=25b28bc20807db0cec876b00ce1d9981,200,200,True,False,ec-49dd-4e65-bcb7-ad3d1901928c.485a9d64-3913-4421-b715-45adb26574e1.jpg","isTopSpeaker":false,"links":[],"sessions":[16988],"fullName":"John Hoford"},{"id":"addf6286-cec0-4b0b-848c-02d9c8edb957","firstName":"","lastName":"","bio":"Kapil Bakshi is a very passionate techie with an aim to embrace technology, imbibe every bit of it, transcend all the barriers and turn ideas into reality. His experience spans across edtech, fintech and logistics sectors where he has developed things from scratch taking them to a level where they have scaled drastically and have become a brand in their respective domains.\r\n\r\nHe is currently working at BlackBuck which is redefining the logistics landscape of India, making it reliable and efficient. Kapil is playing an important role there to improve quality of all apps, doing optimisations and helping the company scale to go much beyond.\r\n\r\nApart from Android, he has worked on Backend technologies as well and many times single-handedly built complex features which have proven to be very beneficial for business.\r\n\r\nIn Android, his areas of interest include testing, architectural best practices and security.\r\n\r\nKapil has also given talks on architectural best practices and testing and has been invited at International Conferences like Droidcon Beijing 2017 .","tagLine":"Dazzling developer who love optimisation to the core","profilePicture":"https://sessionize.com/image?f=bf23029565bd047feb203639a0b3dd2d,200,200,True,False,86-cec0-4b0b-848c-02d9c8edb957.adad3e54-35be-40c6-bc93-52a00d975d45.jpg","isTopSpeaker":false,"links":[],"sessions":[16870],"fullName":"Kapil Bakshi"},{"id":"bfcf3bb1-58b9-4200-be9a-9cb077589bfe","firstName":"","lastName":"","bio":"Yahoo!JAPAN","tagLine":"Android, cpu","profilePicture":"https://sessionize.com/image?f=c753e2e13009b6bff41116c29d0b619a,200,200,True,False,b1-58b9-4200-be9a-9cb077589bfe.e61204e7-827e-4d6c-a461-aaeee44a36a2.jpg","isTopSpeaker":false,"links":[],"sessions":[16589],"fullName":"eggpogg"},{"id":"bf35117b-cbda-4c2a-90ee-efa9e9e8cc93","firstName":"","lastName":"","bio":"iOS/Androidの黎明期からアプリ開発しているエンジニア。趣味はカメラと猫を愛でること。","tagLine":"Engineer","profilePicture":"https://sessionize.com/image?f=66f46bc978d4cbfddd5049e8d140e557,200,200,True,False,7b-cbda-4c2a-90ee-efa9e9e8cc93.9668741d-89f7-47f9-b8a9-54982b39583d.png","isTopSpeaker":false,"links":[],"sessions":[17029],"fullName":"Katsuya Kato"},{"id":"33ff8262-ff9a-4d77-be1f-e288d62ba93f","firstName":"","lastName":"","bio":"Engineer, Cyclist, Gymnast","tagLine":"Drivemode, Inc.","profilePicture":"https://sessionize.com/image?f=cbb9914746892f82cba50cb6f8ea20e9,200,200,True,False,2b2ff3e1-98ae-4346-a122-9ee95ff47a78.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/keithyokoma","linkType":"Twitter"},{"title":"Blog","url":"http://keithyokoma.hatenablog.com/","linkType":"Blog"},{"title":"Company Website","url":"https://drivemode.com/","linkType":"Company_Website"},{"title":"GitHub","url":"https://github.com/keithyokoma","linkType":"Other"},{"title":"Speakerdeck","url":"https://speakerdeck.com/keithyokoma","linkType":"Other"},{"title":"LinkedIn","url":"https://www.linkedin.com/in/keishin-yokomaku-8a013036","linkType":"LinkedIn"}],"sessions":[15888],"fullName":"KeithYokoma"},{"id":"71ab9dce-6536-49e5-8a23-e60a2e703ba0","firstName":"","lastName":"","bio":"[Android/Kotlin歴]\r\n- Android：7年くらい\r\n- Kotlin：半年くらい\r\n\r\n[職歴]\r\n- 2011年~：富士通＠モバイルフォン事業部にてメーラーの開発\r\n  (ただしコードを書くとは言ってない)\r\n- 2016年~：GMOフィナンシャルHDにて既存アプリのリプレースやら新規アプリの開発\r\n  (コード書いてる)\r\n- 2017年8月~：育休中によりほとんどコードを書けず...\r\n  (そんなことより娘ｶﾜｲｲ)\r\n\r\n[座右の銘]\r\n- 明日の自分に優しいコードを\r\n- 楽をするためなら全力を尽くす\r\n\r\n[趣味]\r\nSplatoon2(ところでITエンジニアってSplatoonやってる人多く無いですか?)","tagLine":"GMOフィナンシャルHDのAndroidエンジニア(ただし育休中)","profilePicture":"https://sessionize.com/image?f=c24c7afce07a635872c11019345e5067,200,200,True,False,28cbf9cd-3271-4c2b-b9ce-107c5aea2351.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/fei_kome","linkType":"Twitter"},{"title":"Blog","url":"https://qiita.com/k_keisuke","linkType":"Blog"},{"title":"Github","url":"https://github.com/kiuchikeisuke","linkType":"Other"}],"sessions":[16844],"fullName":"Keisuke Kiuchi"},{"id":"6fba26d1-7b30-4877-965b-de2c4721252f","firstName":"","lastName":"","bio":"東京大学大学院工学系研究科修了後、ソニーにて組み込みソフトウェアの開発を担当。 グリーに転籍後、ゲームプラットフォームのSDK開発やネイティブゲームのクライアント開発を立ち上げから担当。その後スタートアップでのAndroidアプリ、バックエンドの開発を経て、Kyashに参画。","tagLine":"Kyash, Inc.","profilePicture":"https://sessionize.com/image?f=78d8e1ba68cceba64f1529b11b443cde,200,200,True,False,7ada4d2f-6e6c-469e-ab5c-e7729b2e1dff.jpg","isTopSpeaker":false,"links":[],"sessions":[15945],"fullName":"kobakei"},{"id":"18265cec-5176-4fd7-b93f-077e8db95958","firstName":"","lastName":"","bio":"株式会社Fablicでフリマアプリ「フリル」のAndroid版の開発を担当。","tagLine":"Android Application Engineer at Fablic, inc.","profilePicture":"https://sessionize.com/image?f=9c8f45ea5daf3f4bdb671361eb7808bc,200,200,True,False,ec-5176-4fd7-b93f-077e8db95958.46fc34dc-8c6a-4dc0-9a87-565938d3b27a.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/chicken_111","linkType":"Twitter"}],"sessions":[16746],"fullName":"nakamuuu"},{"id":"931cab5b-0627-4843-80a6-59f0ca930bb9","firstName":"","lastName":"","bio":"2011~2014: Security Analyst at Nomura Research Institute. \r\n2014~now: Security Engineer along with occasional Android developer.\r\n","tagLine":"Android, security, authentication, authorization","profilePicture":"https://sessionize.com/image?f=1a17a4b4ff857591a0fe65957d5e5474,200,200,True,False,275e881d-763c-4b84-9c1e-202289dfb79d.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/Ken5scal","linkType":"Twitter"},{"title":"LinkedIn","url":"https://www.linkedin.com/in/kengo-suzuki-5a880116/","linkType":"LinkedIn"},{"title":"Blog","url":"http://ken5scal.hatenablog.com/","linkType":"Blog"}],"sessions":[16937],"fullName":"ken5scal"},{"id":"f4445e26-7dff-4294-9ae9-321e26e9c183","firstName":"","lastName":"","bio":"Android App Developer","tagLine":"人間","profilePicture":"https://sessionize.com/image?f=74bf92d6fcf0a9efe73cc8724e59feee,200,200,True,False,26-7dff-4294-9ae9-321e26e9c183.5b0533db-0b3e-4562-abbc-b9a722c2904d.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/STAR_ZERO","linkType":"Twitter"},{"title":"Blog","url":"https://medium.com/@star_zero","linkType":"Blog"}],"sessions":[16511],"fullName":"Kenji Abe"},{"id":"3a59fd95-4771-4e9f-b61e-fd2b3ab288b4","firstName":"","lastName":"","bio":"株式会社IGNIS APPS所属\r\n恋愛・婚活サービス「with」のAndroid版の開発しています","tagLine":"IGNIS LTD.","profilePicture":"https://sessionize.com/image?f=1cef2c3824a893c3cc831f907fbe1b5a,200,200,True,False,95-4771-4e9f-b61e-fd2b3ab288b4.b077d936-599a-47eb-a2ba-95ba2c5a0bb7.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/KazaKago","linkType":"Twitter"},{"title":"GitHub","url":"https://github.com/KazaKago","linkType":"Other"},{"title":"Blog","url":"http://kazakago.hatenablog.jp/","linkType":"Blog"},{"title":"Qiita","url":"https://qiita.com/KazaKago","linkType":"Other"}],"sessions":[16865],"fullName":"KazaKago"},{"id":"234b5acc-7f5f-4be7-a7f1-4f26fd466d82","firstName":"","lastName":"","bio":"I've been involved in a product development which is used globally. My current technical focus is search, machine learning, and Android.","tagLine":"Software Engineer at Cookpad","profilePicture":"https://sessionize.com/image?f=23b5b2907a283bf0d9f96b540a246bab,200,200,True,False,cc-7f5f-4be7-a7f1-4f26fd466d82.7999fd15-3fb9-4963-b362-73d95a24a13e.jpeg","isTopSpeaker":false,"links":[],"sessions":[16980],"fullName":"rejasupotaro"},{"id":"47118070-f7b6-43e1-b57b-527e75e21a4f","firstName":"","lastName":"","bio":"新卒で株式会社ジャストシステムに入社後、webフロントエンジニア→webサーバーエンジニア→Androidエンジニアという経緯で、現在はスマイルゼミのAndroidアプリ開発に携わっています。","tagLine":"JustSystems","profilePicture":"https://sessionize.com/image?f=f3d0e789316e797a4322e8651e53e4d0,200,200,True,False,70-f7b6-43e1-b57b-527e75e21a4f.4038dbeb-636b-4aa4-a1a4-8101967a272e.png","isTopSpeaker":false,"links":[],"sessions":[16539],"fullName":"Kiyotaka Soranaka"},{"id":"59582b52-78ac-4c2e-bff6-a5dd70f45c3f","firstName":"","lastName":"","bio":"フィンテック企業で働くネイティブアプリエンジニア。野球の話が好きです。","tagLine":"株式会社お金のデザイン","profilePicture":"https://sessionize.com/image?f=2685c76c1dfd8e6b5c3dcb667fd1dcf3,200,200,True,False,5dc2d784-5881-46c2-8ce4-d79fde484c55.jpg","isTopSpeaker":false,"links":[],"sessions":[16908],"fullName":"kmats"},{"id":"6fdbdbd1-011d-4703-bc1d-edaea33ea791","firstName":"","lastName":"","bio":"1988年生まれ。2014年ピクシブ株式会社に入社。主にAndroidアプリの開発に携わるが、必要とあればサーバーサイドやWebフロントエンド、iOSもやる何でも屋。最近ではお絵かきコミュニケーションアプリ「pixiv Sketch」のAndroidアプリを開発している。","tagLine":"ピクシブ株式会社 エンジニア","profilePicture":"https://sessionize.com/image?f=acd76dbe4ed12f4379864e42c30323b7,200,200,True,False,d1-011d-4703-bc1d-edaea33ea791.6c0e5d35-bfdb-4af3-811d-ab6e6dce9294.png","isTopSpeaker":false,"links":[],"sessions":[17018],"fullName":"Yudemanjyu"},{"id":"85a1bdae-723f-4a7a-8700-2101f6e4a48d","firstName":"","lastName":"","bio":"SENSY株式会社　ソフトウェアエンジニア\r\nPythonやNode.jsを用いたサーバーサイドの開発をしています。\r\n\r\n個人活動ではDialogflowを活用したChatbot開発や釣りアプリ（Android, iOS）の開発をしています。","tagLine":"Sensy inc, flatfisher","profilePicture":"https://sessionize.com/image?f=a5ee71f3fb20e46222511c07d6b36ceb,200,200,True,False,aab62da0-1905-4aea-93da-cb6290c6275a.jpg","isTopSpeaker":false,"links":[],"sessions":[15883],"fullName":"fish"},{"id":"b1392ac1-29dc-46d9-8e67-75f026f6c239","firstName":"","lastName":"","bio":"Android evangelist since college, circa 2012. I authored the initial Kotlin rewrite of the popular Runtime Permissions library \"PermissionsDispatcher\" & have worked with clients in the movie ticket sales and smart meter fields in my previous jobs in Germany. At the moment however, I'm living in Japan & embrace its culture on the back of my bicycle.","tagLine":"I create software and weird music.","profilePicture":"https://sessionize.com/image?f=f19a9bbe698b90239e8131173cc6fa53,200,200,True,False,ab3a48c6-e83e-4988-a562-0177cf0773bc.jpg","isTopSpeaker":false,"links":[],"sessions":[15911],"fullName":"Marcel Schnelle"},{"id":"fc80cf34-563e-4cd4-a04d-23d1191a7812","firstName":"","lastName":"","bio":"Google Developer Group Co-Organiser in Berlin/Germany @Berlindroid\r\nAndroid and Java Ecosystem Developer @Contentful\r\nSoftware Engineer @Memorado and @HERE\r\nGraduate Software Engineer @Wooga\r\nResearch Associate @HHIFraunhofer","tagLine":"⌨️'alot","profilePicture":"https://sessionize.com/image?f=ad475a4a5839cfc83864637688f87c4d,200,200,True,False,d5d60ce0-857d-4905-ac89-22637b2d1bf7.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"http://twitter.com/mariobodemann","linkType":"Twitter"},{"title":"LinkedIn","url":"https://www.linkedin.com/in/mariobodemann/","linkType":"LinkedIn"},{"title":"Company Website","url":"https://www.contentful.com","linkType":"Company_Website"},{"title":"Blog","url":"https://www.contentful.com","linkType":"Blog"}],"sessions":[16836],"fullName":"Mario Bodemann"},{"id":"b884cf72-b5c9-471b-a874-7f0ba379561d","firstName":"","lastName":"","bio":"Androidの開発者カンファレンスDroidKaigiや技術書イベントの技術書典を主宰。技術の共有やコミュニケーションに興味があり、ブログや書籍を通じてAndroid開発情報を発信してます。","tagLine":"Software Engineer, Representative  of TechBooster","profilePicture":"https://sessionize.com/image?f=22f7c2caa824da6fb3914affb62ceecc,200,200,True,False,72-b5c9-471b-a874-7f0ba379561d.6307b7b0-4ef2-4335-9c9f-9a0122ef6b5b.png","isTopSpeaker":false,"links":[],"sessions":[16935],"fullName":"mhidaka"},{"id":"eeb62c90-d5d3-46c7-a672-40770d4cfa54","firstName":"","lastName":"","bio":"株式会社スマートドライブという会社でAndroidエンジニアとして働いています。\r\n\r\nTwitter: @mapyo\r\nGitHub: @mapyo\r\nblog: http://mapyo.hatenablog.com/","tagLine":"株式会社スマートドライブ","profilePicture":"https://sessionize.com/image?f=85a6eeac734eed90b50781d35abc7187,200,200,True,False,287558dd-3df8-46fd-acb0-bc76075eecd5.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/mapyo","linkType":"Twitter"},{"title":"Blog","url":"http://mapyo.hatenablog.com","linkType":"Blog"},{"title":"GitHub","url":"https://github.com/mapyo","linkType":"Other"}],"sessions":[15880],"fullName":"@mapyo"},{"id":"e1eb194c-e7fa-4561-b023-82a61c5eead9","firstName":"","lastName":"","bio":"ひたすらAndroid。AbemaTV作ってます。Androidの様々な機能やRxJavaやKotlinやMaterialDesignの実装などなどAndroidに近いものに幅広く触れています。\r\nqiita: http://qiita.com/takahirom\r\ngithub: http://github.com/takahirom ","tagLine":"AbemaTV / CyberAgent, Inc.","profilePicture":"https://sessionize.com/image?f=b2c100de2057d6eb31d7b528403cdeeb,200,200,True,False,4c-e7fa-4561-b023-82a61c5eead9.040bc8ae-b4a8-4c7e-a63d-ed0f6e5df23c.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/new_runnable","linkType":"Twitter"},{"title":"GitHub","url":"http://github.com/takahirom/","linkType":"Other"}],"sessions":[16892],"fullName":"takahirom"},{"id":"c3260fa6-446b-40ba-94c0-78d946312a64","firstName":"","lastName":"","bio":"Miquel Beltran is an Android developer based in Berlin, Germany. He worked as a developer for more than ten years in different sectors, and got in Android in 2012 when he started building video player SDKs for streaming apps. Currently he is leading the small Android team of Nebenan.de, a social network for neighbours in Germany. Miquel has been featured both at AndroidWeekly and KotlinWeekly, and he is also an active member of the Android community in Berlin, where he has conducted workshops and talks. Find me on @Miqubel","tagLine":"Android Lead at Nebenan.de","profilePicture":"https://sessionize.com/image?f=506fd8e03f8b84a72cadd41d922f59e3,200,200,True,False,a6-446b-40ba-94c0-78d946312a64.b232af9a-5368-425a-aec6-a7f5c17736a8.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/Miqubel","linkType":"Twitter"},{"title":"Blog","url":"http://beltran.work","linkType":"Blog"}],"sessions":[15567],"fullName":"Miquel Beltran"},{"id":"6293f360-031c-4923-b422-9e396c7cacec","firstName":"","lastName":"","bio":"Mitchell Tilbrook is a mobile developer focused on Android development at Moneytree. Mitchell has developed mobile apps for both native iOS, Android, Xamarin, and React. Mithcell community for F# Sydney and Xamarin meetups. Mitchell is also helping bring Sydney's tech scene to the world by recording and uploads amazing talks for Android, React Native, Alt.NET, SydJs and other local meetups online at youtube.com/c/anzcoders","tagLine":"Good luck and have fun.","profilePicture":"https://sessionize.com/image?f=63717ecee81093aed17c979eb4f2ac0c,200,200,True,False,486ed4f4-f411-4f45-8519-a37277415bcf.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/sir_tilbrook","linkType":"Twitter"}],"sessions":[16869],"fullName":"Mitchell Tilbrook"},{"id":"f31f7c75-b609-405e-8c24-320933bdc6ad","firstName":"","lastName":"","bio":"AndroidやったりDDD本読んだりイベントやったり本つくったり","tagLine":"Developer","profilePicture":"https://sessionize.com/image?f=76cea28d8ff7426e656a0b2c901dc5e1,200,200,True,False,75-b609-405e-8c24-320933bdc6ad.d13defa0-f6d6-4dea-82e1-33eb23d33036.jpeg","isTopSpeaker":false,"links":[],"sessions":[17047],"fullName":"mochico"},{"id":"3fe8f4be-5700-44f5-ba97-1a4b4f831ec8","firstName":"","lastName":"","bio":"Android Developer. 2017年6月よりリクルートライフスタイルにてHOT PEPPER BeautyアプリのフルKotlinリニューアルに従事","tagLine":"Android Developer, Recruit Lifestyle","profilePicture":"https://sessionize.com/image?f=6f258c127bde2ff43ae84d2164e2d4b7,200,200,True,False,db7440c9-9763-459e-bfe7-687079885ccd.jpg","isTopSpeaker":false,"links":[],"sessions":[16969],"fullName":"Naoto Nakazato"},{"id":"2552a9af-0f8c-44a1-af1f-f8756353ba83","firstName":"","lastName":"","bio":"TL #ConstraintLayout & Design Tools @androidstudio @google","tagLine":"Google","profilePicture":"https://sessionize.com/image?f=2b85043ada42728bdbc444e8bdebf517,200,200,True,False,34ca8fb6-10c4-4fb5-af38-f86685f0dd14.jpg","isTopSpeaker":false,"links":[],"sessions":[16988],"fullName":"Nicolas Roard"},{"id":"6cfaa375-15c0-438b-9f34-d5b2feaf590b","firstName":"","lastName":"","bio":"Software Engineer at Drivemode, Inc. Certified Scrum Professional. The organizer of Scrum Masters Night!","tagLine":"Drivemode, Inc. Engineer. Certified Scrum Professional. @KAKKA_Blog","profilePicture":"https://sessionize.com/image?f=91a25c76872b6ebde1a30db2b21efcd6,200,200,True,False,71282926-abb2-4f40-8bf7-3a102cc55c28.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/KAKKA_Blog","linkType":"Twitter"},{"title":"Company Website","url":"https://drivemode.com/","linkType":"Company_Website"}],"sessions":[15572],"fullName":"KAKKA"},{"id":"4c578eb8-2d3e-42af-9c97-e8bf60909f42","firstName":"","lastName":"","bio":"Repro SDKチームにてライブラリの保守やクロスプラットフォーム対応を担当。\r\n頻繁に利用されるプッシュ通知やポップアップダイアローグをディレクターやデザイナーだけで運用できるようにする様子を見て、こうしたよくあるダイアローグを何度でも誰でも使えるようにするのも技術的に面白そうだと思って入社。\r\nしたけれど、テストやビルドのため、想定以上にエディタではなくターミナルを開く頻度が高くてひえひえ言っている。","tagLine":"repro","profilePicture":"https://sessionize.com/image?f=aa1e5734d951e68aef305a8e34880a24,200,200,True,False,b8-2d3e-42af-9c97-e8bf60909f42.2dfd1778-ceb3-49ce-a062-44187634cc9a.jpg","isTopSpeaker":false,"links":[],"sessions":[17032],"fullName":"woshidan"},{"id":"41711e09-fb90-448c-a74d-886c133562ea","firstName":"","lastName":"","bio":"I worked for Microsoft for 7 years in the Office Excel Team.\r\nFor the past two years I've worked at Dropbox as an Android Engineer.\r\n\r\nMy passion is Software Architecture, how to elegantly design software systems.","tagLine":"Android Engineer at Dropbox","profilePicture":"https://sessionize.com/image?f=0bc5d47d9827440bab9b0fe64cf47a23,200,200,True,False,09cf276a-6cec-439f-9716-0b1036ccfe00.jpg","isTopSpeaker":false,"links":[{"title":"Company Website","url":"https://www.dropbox.com","linkType":"Company_Website"}],"sessions":[16864],"fullName":"Rodrigo"},{"id":"152f613f-841b-407d-9a65-3703ec2dfae2","firstName":"","lastName":"","bio":"Romain is an engineer at Google. He worked on the Android Framework team, leading the UI toolkit and UI renderer, and now works on new graphics related projects.","tagLine":"Android Graphics & Kotlin","profilePicture":"https://sessionize.com/image?f=f1becb60b0e01668a9911327f059fbc2,200,200,True,False,d068ae37-2e0e-49bd-a4be-b376a32367a8.jpg","isTopSpeaker":false,"links":[],"sessions":[16534],"fullName":"Romain Guy"},{"id":"2454ad67-5017-49fa-b57a-433f02f4a7ab","firstName":"","lastName":"","bio":"大阪生まれ大阪育ち。\r\nもともとコンピュータは好きで、小学生の頃にはWebサイトを運営していたが、なぜか大学卒業後は小売店にて家具販売業に従事する。その後、エンジニアリングの道に進み、スタートアップを1社経験した後、2017/2〜ウォンテッドリー株式会社でAndroidエンジニアとして従事している。","tagLine":"Android app developer of Wantedly, Inc. ","profilePicture":"https://sessionize.com/image?f=24aecaace219505dc8b3d367d7375c65,200,200,True,False,67-5017-49fa-b57a-433f02f4a7ab.65e1f7c4-bdf5-4ea8-8a22-68a86cdcccbb.png","isTopSpeaker":false,"links":[{"title":"Company Website","url":"https://wantedlyinc.com/","linkType":"Company_Website"},{"title":"Twitter","url":"https://twitter.com/wakwak3125","linkType":"Twitter"}],"sessions":[17013],"fullName":"wakwak3125"},{"id":"00f8c0a3-55cc-4c3a-af45-730fe03ea6b8","firstName":"","lastName":"","bio":"Android Developer (2016~)","tagLine":"Android Developer","profilePicture":"https://sessionize.com/image?f=4c77272952aa53fb2f39ca65db9963eb,200,200,True,False,a3-55cc-4c3a-af45-730fe03ea6b8.f82d39cd-2b97-4fd6-b80e-b03288f8915c.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/ymnd","linkType":"Twitter"}],"sessions":[16949],"fullName":"Ryo Yamazaki"},{"id":"c27d048c-8c02-4de5-84fb-606de1cc2447","firstName":"","lastName":"","bio":"Software engineer","tagLine":"Software engineer","profilePicture":"https://sessionize.com/image?f=b1860ca6cd9f60b7c23a22288ad57018,200,200,True,False,6aa6e1b2-fc22-42f5-beb1-800396ce04b9.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/ryo_mm2d","linkType":"Twitter"},{"title":"github","url":"https://github.com/ohmae","linkType":"Other"}],"sessions":[16679],"fullName":"Ryosuke Ohmae"},{"id":"1de1a2e2-e88d-4aa1-8d85-58c5466da05d","firstName":"","lastName":"","bio":"Kotlinがすきな女子小学生(2年生)。アプリをつくってる。I'm a 2nd grade girl loving Kotlin. 我是小学二年级的小女孩。","tagLine":"youjo","profilePicture":"https://sessionize.com/image?f=e4c36f69e3f129a87040132a065cf60c,200,200,True,False,e2-e88d-4aa1-8d85-58c5466da05d.6ac4dbfa-f972-479c-bc5a-9ba7626b7bf6.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/kirimin","linkType":"Twitter"},{"title":"Blog","url":"http://kirimin.hatenablog.com/","linkType":"Blog"},{"title":"Company Website","url":"https://corp.anypay.jp/","linkType":"Company_Website"}],"sessions":[15904],"fullName":"kirimin"},{"id":"d36b8c88-3cca-4895-b7d0-80f1fbdcc307","firstName":"","lastName":"","bio":"Androidとぷよぷよが好きなエンジニアです","tagLine":"CyberAgent, Inc.","profilePicture":"https://sessionize.com/image?f=ad555007dd2e8f1f271c0087921f36f0,200,200,True,False,e81f61eb-7d70-40de-b35d-e995ec61b132.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/stsn_jp","linkType":"Twitter"},{"title":"Blog","url":"https://satoshun.github.io/","linkType":"Blog"},{"title":"Github","url":"https://github.com/satoshun","linkType":"Other"}],"sessions":[16822],"fullName":"Sato Shun"},{"id":"e57f43fb-f258-4743-b6bf-cb843bc9185a","firstName":"","lastName":"","bio":"しがないAndroidエンジニアです","tagLine":"有象無象","profilePicture":"https://sessionize.com/image?f=a10249f037ba1ad7124a48d051f3fa75,200,200,True,False,bd0e1ea8-58a0-4f95-861f-ad9eedd2e167.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/kgmyshin","linkType":"Twitter"},{"title":"Blog","url":"http://motida-japan.hatenablog.com/","linkType":"Blog"}],"sessions":[15899],"fullName":"kgmyshin"},{"id":"ae0ff7e6-1e72-4113-8e28-c6c865917330","firstName":"","lastName":"","bio":"Android developer at Torte, Inc. (CyberAgent, Inc.)","tagLine":"Android developer at Torte, Inc. (CyberAgent, Inc.)","profilePicture":"https://sessionize.com/image?f=95d4053ed609712a3b988fd5f41dc693,200,200,True,False,e6-1e72-4113-8e28-c6c865917330.871afb0b-3a47-4c33-9d1f-751604828e8b.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/shaunkawano","linkType":"Twitter"},{"title":"LinkedIn","url":"https://www.linkedin.com/in/shaunkawano/","linkType":"LinkedIn"},{"title":"Company Website","url":"https://torte.co.jp","linkType":"Company_Website"},{"title":"Blog","url":"http://blog.shaunkawano.com","linkType":"Blog"},{"title":"GitHub","url":"https://github.com/shaunkawano","linkType":"Other"}],"sessions":[16172],"fullName":"shaunkawano"},{"id":"dad922a2-c3b2-4318-be54-277c9bc34029","firstName":"","lastName":"","bio":"大学・大学院では生物を専攻。\r\nその後 SIer で Webアプリケーション開発 を3年間経験。\r\n現在は DeNA の SWET で CI/CD環境の整備や開発者向けサービスの開発などを行っている。","tagLine":"SWET","profilePicture":"https://sessionize.com/image?f=54176fc8c36177bc06e5890a1be33a33,200,200,True,False,a2-c3b2-4318-be54-277c9bc34029.6cdb4558-26a6-4636-92f7-dfbb848df799.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/duck8823","linkType":"Twitter"},{"title":"Blog","url":"http://blog.duck8823.com","linkType":"Blog"},{"title":"Company Website","url":"http://swet.dena.com","linkType":"Company_Website"},{"title":"GitHub","url":"https://github.com/duck8823","linkType":"Other"}],"sessions":[16947],"fullName":"duck"},{"id":"b64b9957-1570-41b7-99b5-b727676ef23c","firstName":"","lastName":"","bio":"Androidアプリのテスト自動化に興味を持っているエンジニアです。\r\n仕事では、Android関連プロジェクトに対する自動テストの導入支援をはじめとする、技術支援を行っています。","tagLine":"テスト自動化が好きなAndroidエンジニア","profilePicture":"https://sessionize.com/image?f=3b2e37a219de74bf6202e4d73121b557,200,200,True,False,74b9b507-524d-41cc-9943-9f6cde3d50fe.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/sumio_tym","linkType":"Twitter"},{"title":"Blog","url":"http://sumio.hatenablog.com/","linkType":"Blog"},{"title":"GitHub","url":"https://github.com/sumio","linkType":"Other"},{"title":"Company Website","url":"http://swet.dena.com/","linkType":"Company_Website"}],"sessions":[16928],"fullName":"外山純生 (sumio_tym)"},{"id":"9bd231a5-d846-4f6e-873a-54a2fae779d7","firstName":"","lastName":"","bio":"Androidアプリエンジニアをやっているsyarihu（しゃりふ）と言います。\r\nAndroidが大好きで、仕事以外にも個人でAndroidアプリを開発、公開をしています。\r\nDroidKaigi 2017では、個人でAndroidアプリを11個公開した話と、Google Play Servicesの話をしましたが、今回はAndroid Wearのお話をします。\r\nよろしくお願いします。","tagLine":"Money Forward, inc.","profilePicture":"https://sessionize.com/image?f=e43612507b57555aa427ef73d1e297e1,200,200,True,False,b205e6b5-d943-42f0-b690-e432c1931bd3.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/syarihu","linkType":"Twitter"},{"title":"Blog","url":"http://diary.syarihu.net/","linkType":"Blog"},{"title":"Website","url":"http://www.syarihu.net/","linkType":"Other"}],"sessions":[15917],"fullName":"syarihu"},{"id":"a7714db6-05d1-4976-af00-160e59ca0e17","firstName":"","lastName":"","bio":"Web制作会社勤務を経てiOSアプリエンジニアとして、2011年ミクシィ入社。\r\n2012年よりAndroidアプリ開発チームに異動するも、翌月にマネージャー昇格。\r\n2016年6月までSNS mixiのアプリ開発マネジメントを担当。\r\n2016年7月より現在に至るまで、ふつうのエンジニアとして家族アルバム みてねの開発全般を担当しています。","tagLine":"Android dev at mixi, inc","profilePicture":"https://sessionize.com/image?f=9854a58c3026a846db62bf065a006b3e,200,200,True,False,b6-05d1-4976-af00-160e59ca0e17.10dda5e6-e19b-4bed-8352-a4c6c4a2530f.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"http://twitter.com/punchdrunker","linkType":"Twitter"},{"title":"Company Website","url":"http://mixi.co.jp","linkType":"Company_Website"},{"title":"Blog","url":"http://punchdrunker.hatenablog.jp/","linkType":"Blog"},{"title":"github","url":"https://github.com/punchdrunker","linkType":"Other"}],"sessions":[15984],"fullName":"punchdrunker"},{"id":"29167627-84bc-4a74-a3bf-3a17b837a468","firstName":"","lastName":"","bio":"エムスリー株式会社 ソフトウェアエンジニア\r\n高校時代に手に入れたIS01でAndroid派に。\r\n昨年までは大学の研究コードをKotlinで書いていた。\r\n2017年4月にエムスリーに新卒入社、現在は主にAndroid兼Webエンジニアとして働く。\r\n趣味はCTFなど。","tagLine":"@oboenikui","profilePicture":"https://sessionize.com/image?f=c9142ef9369e0d5741db548542023d43,200,200,True,False,27-84bc-4a74-a3bf-3a17b837a468.3d857c4f-0e0b-41e7-b38b-2b72d4fb978c.png","isTopSpeaker":false,"links":[],"sessions":[16985],"fullName":"oboenikui"},{"id":"406c85a2-c8f7-42de-aca2-1074983c6699","firstName":"","lastName":"","bio":"産業機器向けWindowsアプリを作ったり生産管理系Webシステムを作ったりしていたときにHT-03Aに出会い、そのままAndroidアプリ開発者となる。現在はスタートアップでアプリ開発を主業務にしつつもWeb側を触ったりログ解析したりなんでもやる。JavaでもRubyでもGoでもPythonでもC++でもSQLでもVBAでもGroovyでも雑多に触るけどJavaが一番好き。Kotlinより好き。なので最近は肩身が狭い。","tagLine":"BigQuery, Firebase Analytics グロース","profilePicture":"https://sessionize.com/image?f=9352e66bb710ce4a4ebec1874fc8c238,200,200,True,False,a2-c8f7-42de-aca2-1074983c6699.5d628ca0-6562-45f2-a818-22a8220f9f57.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/cattaka_net","linkType":"Twitter"},{"title":"LinkedIn","url":"https://www.linkedin.com/in/takao-sumitomo-475aa984/","linkType":"LinkedIn"},{"title":"Blog","url":"http://wscat.blogspot.jp/","linkType":"Blog"},{"title":"Company Website","url":"https://www.wantedly.com/","linkType":"Company_Website"},{"title":"Wantedly Profile","url":"https://www.wantedly.com/users/392473","linkType":"Other"}],"sessions":[16837],"fullName":"Takao Sumitomo"},{"id":"e3267cf5-b1a7-4ce7-a4b3-223925f21316","firstName":"","lastName":"","bio":"Takeshi is an Android engineer working for Google. He worked on various apps such as Google Authenticator, developer samples on GitHub and open source libraries such as flexbox-layout.\r\n","tagLine":"Google, Developer Programs Engineer","profilePicture":"https://sessionize.com/image?f=bd17e600b3d72338aefec16926ae33c8,200,200,True,False,42e7f8d8-a20a-4433-8023-f02a76d24429.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/thagikura","linkType":"Twitter"},{"title":"GitHub","url":"https://github.com/thagikura","linkType":"Other"}],"sessions":[16997,16988],"fullName":"thagikura"},{"id":"a4b446f7-e1f6-47cc-b7e1-ae9cdc4bb2f5","firstName":"","lastName":"","bio":"Android app developer","tagLine":"Topgate","profilePicture":"https://sessionize.com/image?f=73caee0b58f4a00c2bebeee3fb689426,200,200,True,False,878753c3-8a95-4213-a37e-d7a1050d4929.jpg","isTopSpeaker":false,"links":[],"sessions":[16883],"fullName":"eaglesakura"},{"id":"fbb08aa9-7aa1-4b70-b676-32905f5fd8d9","firstName":"","lastName":"","bio":"2012 - 2016 Kobe University\r\n2014 - 2015 University of Washington\r\n2015 - 2016 eureka\r\n2017 - abemaTV (currently working)","tagLine":"AbemaTV","profilePicture":"https://sessionize.com/image?f=d0814ea85b8671c8f6ae9206dd9abb64,200,200,True,False,6d444b65-e8d6-4396-b3a1-d6f58c56ca23.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/takusemba","linkType":"Twitter"},{"title":"Blog","url":"https://github.com/takusemba","linkType":"Blog"},{"title":"GitHub","url":"https://github.com/takusemba","linkType":"Other"}],"sessions":[16888],"fullName":"takusemba"},{"id":"45452775-8fad-454b-9e38-770059319f95","firstName":"","lastName":"","bio":"Android Developer at FOLIO Co.,Ltd.","tagLine":"FOLIO Co.,Ltd.","profilePicture":"https://sessionize.com/image?f=ae7cb85521f1138c1fca772119694c70,200,200,True,False,00365592-4fa6-40a0-9097-7d81741e6b31.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/magie_pooh","linkType":"Twitter"},{"title":"GitHub","url":"https://github.com/magiepooh","linkType":"Other"}],"sessions":[16970],"fullName":"Takuma Fujita"},{"id":"d91dbd08-0968-4f39-b7ab-841349dc71f1","firstName":"","lastName":"","bio":"普段はエムスリー株式会社でAndroidアプリやサーバサイドの開発をしています。Kotlinエバンジェリストを自称して様々な活動をしています。著書に「Kotlinスタートブック」、訳書に「Kotlinイン・アクション」などがあります。ビールとディズニーが大好き。","tagLine":"エムスリー株式会社","profilePicture":"https://sessionize.com/image?f=8f04530ac5ff1ee5c4d1c27e1b103874,200,200,True,False,08-0968-4f39-b7ab-841349dc71f1.e28a29c4-4883-49bb-bfd1-9b29c5c8fbab.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/ngsw_taro","linkType":"Twitter"},{"title":"Blog","url":"http://taro.hatenablog.jp/","linkType":"Blog"}],"sessions":[16886],"fullName":"長澤 太郎"},{"id":"ab6eb21a-b8f5-4e26-b68f-5e07383ea9ab","firstName":"","lastName":"","bio":"ピックアップ株式会社 技術顧問/Androidエンジニア","tagLine":"ピックアップ株式会社 技術顧問","profilePicture":"https://sessionize.com/image?f=1d476fe52f4c21364a40ac1c435d1e44,200,200,True,False,a75f9694-442e-43ec-987e-a56e1850214b.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/cutmail","linkType":"Twitter"},{"title":"Company Website","url":"http://picappinc.jp","linkType":"Company_Website"},{"title":"Blog","url":"http://cutmail.hatenablog.com","linkType":"Blog"}],"sessions":[17019],"fullName":"cutmail"},{"id":"22eebb4b-dad2-4d32-a2db-989ac14e559c","firstName":"","lastName":"","bio":"株式会社Sassorのエンジニア。IoTシステムの設計、組み込み/Android/iOSのソフト開発を担当。\r\n中学時代に初PCを自作しHSPでプログラミングに目覚め、高校・大学ではロボット競技参戦を通してマイコンプログラミング・金属加工・電子回路を学ぶ。\r\n2009年から車載機器の組み込み開発業務に従事。ディスプレイオーディオ・カーナビ向けプラットフォーム開発、MirrorLink・CarPlay・AndroidAutoなどスマートフォン連携機能の開発を経験。\r\n2016年からはSassorにフルタイムコミットし、AndroidのKioskアプリやシェアサイクリングシステム・BLE連携のiOSアプリなど様々な開発に携わる。","tagLine":"Software Engineer","profilePicture":"https://sessionize.com/image?f=1fc5c7b973c043f50b3d566adadab357,200,200,True,False,4b-dad2-4d32-a2db-989ac14e559c.22078a71-aa8b-4982-b991-8a1b234334cf.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/tomoya0x00","linkType":"Twitter"},{"title":"Company Website","url":"https://dena.com/","linkType":"Company_Website"},{"title":"GitHub","url":"https://github.com/tomoya0x00/","linkType":"Other"}],"sessions":[16381],"fullName":"tomoya0x00"},{"id":"90a962b5-9d71-4ff8-90ed-d4130477672c","firstName":"","lastName":"","bio":"DeNAのSWETでモバイルアプリ周りを主に担当しています。\r\n","tagLine":"SWET","profilePicture":"https://sessionize.com/image?f=50b54be95ef1cedb6ef4712c88b5a4a1,200,200,True,False,1591ef44-f530-4917-b075-98de1a14df33.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/tarappo","linkType":"Twitter"},{"title":"Company Website","url":"http://swet.dena.com/","linkType":"Company_Website"}],"sessions":[16867],"fullName":"tarappo"},{"id":"2a91cf02-04ac-4d01-8643-71fc48c3f1fa","firstName":"","lastName":"","bio":"流通業向けパッケージソフトの開発、写真アプリの開発を経て、現在カカクコムでレシピアプリのリーダーを担当。","tagLine":"Kakaku.com, Inc.","profilePicture":"https://sessionize.com/image?f=c7106c8f073374a9eb620688d10fc047,200,200,True,False,d5524ca5-f7a8-4666-947b-65ad1077a154.jpg","isTopSpeaker":false,"links":[],"sessions":[16978],"fullName":"Yasuhiko Sakamoto"},{"id":"247f2500-93e8-45bd-a39e-51c3a6289e57","firstName":"","lastName":"","bio":"クリプトン・フューチャー・メディア株式会社\r\nアプリ開発ユニットリーダー\r\n両OSやるマン","tagLine":"クリプトン・フューチャー・メディア株式会社 アプリエンジニア","profilePicture":"https://sessionize.com/image?f=3c970d230beea237daa6ac5355c6af8c,200,200,True,False,00-93e8-45bd-a39e-51c3a6289e57.d5d5067a-aaef-4cf5-9706-ff920bfdec57.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/Susan_jacko","linkType":"Twitter"}],"sessions":[16760],"fullName":"watanave"},{"id":"892d6f3c-816b-4a97-a135-c315e1ed6471","firstName":"","lastName":"","bio":"I (shiraji @ GitHub) started my career as a Java developer in 2007.","tagLine":"8000 yen Android developer + Kotlin contributor (shiraji) @ ASICS","profilePicture":"https://sessionize.com/image?f=a529cbd965a7dd1c8b23c88a04aca933,200,200,True,False,3c-816b-4a97-a135-c315e1ed6471.012fbc65-7fe8-4c8d-b972-9e223ca8c7ee.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/shiraj_i","linkType":"Twitter"},{"title":"Blog","url":"http://shiraji.github.io/","linkType":"Blog"}],"sessions":[15897],"fullName":"Yoshinori Isogai"},{"id":"85edff9d-f1b2-4f38-a196-c77679f0de3b","firstName":"","lastName":"","bio":"Software engineer at ACCESS Co., LTD.","tagLine":"embedded software engineer loving golang!","profilePicture":"https://sessionize.com/image?f=44ffbe1a1e638fe2903fe7e47b620341,200,200,True,False,a4dece67-4f48-4e1e-96a2-01c83f65b2a3.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/pankona","linkType":"Twitter"},{"title":"Blog","url":"https://pankona.github.io/","linkType":"Blog"},{"title":"GitHub","url":"https://github.com/pankona","linkType":"Other"}],"sessions":[17012],"fullName":"pankona"},{"id":"e52982d7-5a75-4c91-ab2d-7882c06fa5b2","firstName":"","lastName":"","bio":"Android developer @ AbemaTV","tagLine":"Poem coder","profilePicture":"https://sessionize.com/image?f=1493d37c7501024c3a285c901aedd2f5,200,200,True,False,32eaf38b-aa85-4d6c-9c1d-7ecd1bd0a7f8.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/kaelaela31","linkType":"Twitter"},{"title":"Blog","url":"http://blog.kaelae.la/","linkType":"Blog"},{"title":"Github","url":"https://github.com/kaelaela","linkType":"Other"},{"title":"Slide","url":"https://speakerdeck.com/kaelaela/androidtv-oreo-dip","linkType":"Other"}],"sessions":[16922],"fullName":"kaelaela"},{"id":"580fb501-aece-4bf4-b755-32fda033b3bd","firstName":"","lastName":"","bio":"あんざいゆき\r\n- twitter : https://twitter.com/yanzm\r\n- blog : http://y-anz-m.blogspot.jp/ (Y.A.Mの雑記帳）\r\n- 株式会社ウフィカ\r\n- book : Master of Fragment とか\r\n","tagLine":"株式会社ウフィカ","profilePicture":"https://sessionize.com/image?f=0a7ff8d719227f7fa6bb83496dfef0d3,200,200,True,False,01-aece-4bf4-b755-32fda033b3bd.b27ac996-bd96-4dcd-8be0-9acd46b4e835.png","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/yanzm","linkType":"Twitter"},{"title":"Blog","url":"http://y-anz-m.blogspot.jp/","linkType":"Blog"}],"sessions":[16894],"fullName":"yanzm"},{"id":"b1a38db0-bc4e-4747-85fd-ed268d1607ed","firstName":"","lastName":"","bio":"mixiのAndroidアプリ開発を立ち上げた体験から感じたチーム開発の課題を解決するためにサービス化すべくDeployGateを立ち上げた体験から感じた世界の開発チームの課題を解決するために日々戦っています","tagLine":"An Android engineer turned into DeployGate Inc. Co-founder & CEO ","profilePicture":"https://sessionize.com/image?f=960a0fc14b8942dc9f3902f71d895bab,200,200,True,False,b0-bc4e-4747-85fd-ed268d1607ed.283c6180-d5e0-4918-a5c5-614a22248f60.jpg","isTopSpeaker":false,"links":[],"sessions":[16927],"fullName":"tnj"},{"id":"0d9656e6-4361-40ef-8383-6c9d237f49db","firstName":"","lastName":"","bio":"put it later before the deadline.","tagLine":"Bison","profilePicture":"https://sessionize.com/image?f=de8f76ce8888502625644aaa637646d9,200,200,True,False,e0abdfc7-f9f0-4b85-a48e-f47a47e7a39d.jpg","isTopSpeaker":false,"links":[],"sessions":[15584],"fullName":"neonankiti"},{"id":"903eaf98-bf70-42a1-80da-6af3c5ec6668","firstName":"","lastName":"","bio":"Quipper Limited. Engineer\r\nhttps://github.com/konifar","tagLine":"konifar, doraemon","profilePicture":"https://sessionize.com/image?f=afd0e1c9743bf6de07b4a003b93ef4dc,200,200,True,False,50a020e5-f98f-41bd-b182-acc2b902a920.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/konifar","linkType":"Twitter"},{"title":"Blog","url":"http://konifar.hatenablog.com","linkType":"Blog"}],"sessions":[17028],"fullName":"konifar"},{"id":"2670ad95-16dc-4133-b2f7-4998a82b3262","firstName":"","lastName":"","bio":"eureka, Inc.","tagLine":"eureka, Inc.","profilePicture":"https://sessionize.com/image?f=4198f8961977dda8608aa2a32597a5a3,200,200,True,False,c5142399-eb60-466f-9f77-f18eae578cd6.jpg","isTopSpeaker":false,"links":[],"sessions":[17039],"fullName":"yuyakaido"},{"id":"1d7b4d9b-7755-48c3-857f-7eba0b3284e2","firstName":"","lastName":"","bio":"株式会社ノハナのAndroidエンジニア。iOS、UIデザイン、グロースハックも担当する。\r\nDroidKaigi2016では「エンジニアが武器にするMaterial Design」を発表。\r\nhttps://academy.realm.io/jp/posts/droidkaigi17-engineers-material-design/","tagLine":"Material Design警察","profilePicture":"https://sessionize.com/image?f=c1ce036cb2de991ba37c51a5518fcb62,200,200,True,False,e6789093-f79f-41ea-a2c3-a34db29d4e4d.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/seto_hi","linkType":"Twitter"},{"title":"Blog","url":"http://seto-hi.hatenablog.com/","linkType":"Blog"},{"title":"Company Website","url":"https://nohana.co.jp/","linkType":"Company_Website"}],"sessions":[16512],"fullName":"Hiroyuki Seto"},{"id":"a289149a-b757-499f-9e4b-319cd18da365","firstName":"","lastName":"","bio":"トラブルシューティングツールの侍や、Twitter4JといったOSSを開発しているJavaエンジニア。株式会社サムライズムという会社の社長で、海外のプログラマ向けツールの日本国内展開を手がけています。","tagLine":"株式会社サムライズム","profilePicture":"https://sessionize.com/image?f=f13962f0e2c3ac93efa359248057c40c,200,200,True,False,e80b46e5-cbab-4ee5-9e27-55fc60d62cbe.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/yusuke","linkType":"Twitter"},{"title":"LinkedIn","url":"https://www.linkedin.com/in/yusuke/","linkType":"LinkedIn"},{"title":"Company Website","url":"http://samuraism.com/","linkType":"Company_Website"}],"sessions":[16011],"fullName":"山本ユウスケ"},{"id":"025947ec-fb6b-4319-bae4-b049c8cdaf98","firstName":"","lastName":"","bio":"新潟のAndroider。一児の父で妻の夫で住宅ローンの債務者1年生。農業向けアプリを作っています。","tagLine":"ウォーターセル株式会社 モバイルエンジニア","profilePicture":"https://sessionize.com/image?f=1acb3b0f18d47cff1ea1f00443c9cd5a,200,200,True,False,861f9fef-87e8-4112-984f-43da99f49be5.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"http://twitter.com/Nkzn","linkType":"Twitter"},{"title":"Blog","url":"http://blog.nkzn.info","linkType":"Blog"}],"sessions":[16991],"fullName":"nkzn"},{"id":"621adbb8-8b2f-4a04-b2c0-778188ddb135","firstName":"","lastName":"","bio":"大学在学中に趣味でプログラミングを始め、趣味が高じてプログラマーとしてSI企業に就職。\r\nPHPやサーバーサイドJava、フロントエンドJavaScriptをメインでやっていたが、Android4.0の頃にAndroid開発に携わって以来すっかりAndroiderに。\r\nその後会社を退職しフリーランスとして4年ほど活動後、dely株式会社にジョイン。\r\n現在はdelyのAndroidチームのリーダーとしてGolangやDockerに浮気しつつ活動中。","tagLine":"dely, Inc. Lead Android Engineer","profilePicture":"https://sessionize.com/image?f=bcee96c42520e01d5d907290ab6df63a,200,200,True,False,b8-8b2f-4a04-b2c0-778188ddb135.09e441a4-1c16-47f3-9bb3-f5b7d4abab72.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/kr9ly","linkType":"Twitter"},{"title":"GitHub","url":"https://github.com/kr9ly","linkType":"Other"}],"sessions":[16709],"fullName":"kr9ly"},{"id":"3758e06c-baa7-414b-a736-1ba696dea164","firstName":"","lastName":"","bio":"元食えないダンサー、元超売れない女優、現フリーランス女Androidエンジニア。テーマパークダンサーを目指すも10年連続オーディションに落選、女優を目指しCM・映画に出演するも鳴かず飛ばずで三十路を迎える。崖っぷちに立たされ、人手不足のIT業界に参戦。アプリやWebサイトを作りまくる日々。","tagLine":"フリーランス体育会系女エンジニア","profilePicture":"https://sessionize.com/image?f=035aa5e02469f978e5e6f583e24c00ae,200,200,True,False,5bada0e5-39e1-4f57-b610-d2a1e11eccd3.jpg","isTopSpeaker":false,"links":[{"title":"Twitter","url":"https://twitter.com/nagaoyuriko","linkType":"Twitter"},{"title":"Blog","url":"http://www.nagaoyuriko.com/","linkType":"Blog"},{"title":"GooglePlay","url":"https://play.google.com/store/apps/dev?id=6936411299252906002","linkType":"Other"}],"sessions":[16945],"fullName":"長尾ユリコ"},{"id":"5ccaa6ed-b606-4a8c-a499-73a00c6c8170","firstName":"","lastName":"","bio":"C Channel 株式会社　所属\r\nAndroid Engineer 兼 PM\r\n「Soda.」と「mysta」というサービスを開発しています。\r\n\r\nhttps://github.com/MasayukiSuda\r\n","tagLine":"daasuu","profilePicture":"https://sessionize.com/image?f=030880631a2939ea04feedf9c191f3f0,200,200,True,False,ed-b606-4a8c-a499-73a00c6c8170.469e775c-2bf9-477c-97fa-07ff4b3ac027.jpg","isTopSpeaker":false,"links":[],"sessions":[16680],"fullName":"daasuu"}],"questions":[],"categories":[{"id":808,"title":"Session format","items":[{"id":3480,"name":"30minutes","sort":1},{"id":3481,"name":"50minutes","sort":2}],"sort":0},{"id":809,"title":"Language","items":[{"id":3483,"name":"日本語","sort":1},{"id":3482,"name":"English","sort":2},{"id":5379,"name":"Mixed","sort":3}],"sort":1},{"id":811,"title":"トピック / Topic","items":[{"id":3487,"name":"UI・トピック / UI and Design","sort":1},{"id":3488,"name":"ソフトウェアアーキテクチャ / Designing App Architecture","sort":2},{"id":3489,"name":"開発プロセス / Development Process and Methodology","sort":3},{"id":3490,"name":"チームビルディング・開発規約 / Team Building and Development Conventions","sort":4},{"id":3491,"name":"Continuous Integration (CI)","sort":5},{"id":3492,"name":"ハードウェア・IoT / Hardware and IoT","sort":6},{"id":3493,"name":"ソフトウェア保守・テスト / Quality and Sustainability","sort":7},{"id":3494,"name":"Android O","sort":8},{"id":3495,"name":"Android FrameworkとSupport Library / Android Framework and Support Library","sort":9},{"id":3496,"name":"OSS開発と運営 / OSS Development and Management","sort":10},{"id":3497,"name":"ハンズオン・コードラボ / Hands-on Codelabs","sort":11},{"id":3498,"name":"開発環境 / Productivity and Tools","sort":12},{"id":3499,"name":"マルチプラットフォーム / Platforms","sort":13},{"id":3500,"name":"その他 / Other","sort":14}],"sort":2},{"id":824,"title":"Level","items":[{"id":3540,"name":"初心者向け / for beginners","sort":1},{"id":3541,"name":"中・上級者向け / for intermediate and/or expert","sort":2},{"id":3542,"name":"ニッチ / Niche topic","sort":3}],"sort":3}],"rooms":[{"id":513,"name":"Hall","sort":0},{"id":514,"name":"Room 1","sort":1},{"id":515,"name":"Room 2","sort":2},{"id":516,"name":"Room 3","sort":3},{"id":517,"name":"Room 4","sort":4},{"id":518,"name":"Room 5","sort":5},{"id":519,"name":"Room 6","sort":6},{"id":520,"name":"Room 7","sort":7},{"id":521,"name":"Room Sponsor","sort":8}]}

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	////////////////////////////////////////////////////////////////////////////////
	// Helpers
	
	// Merge objects
	//
	function assign(obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	
	  sources.forEach(function (source) {
	    if (!source) { return; }
	
	    Object.keys(source).forEach(function (key) {
	      obj[key] = source[key];
	    });
	  });
	
	  return obj;
	}
	
	function _class(obj) { return Object.prototype.toString.call(obj); }
	function isString(obj) { return _class(obj) === '[object String]'; }
	function isObject(obj) { return _class(obj) === '[object Object]'; }
	function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
	function isFunction(obj) { return _class(obj) === '[object Function]'; }
	
	
	function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }
	
	////////////////////////////////////////////////////////////////////////////////
	
	
	var defaultOptions = {
	  fuzzyLink: true,
	  fuzzyEmail: true,
	  fuzzyIP: false
	};
	
	
	function isOptionsObj(obj) {
	  return Object.keys(obj || {}).reduce(function (acc, k) {
	    return acc || defaultOptions.hasOwnProperty(k);
	  }, false);
	}
	
	
	var defaultSchemas = {
	  'http:': {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.http) {
	        // compile lazily, because "host"-containing variables can change on tlds update.
	        self.re.http =  new RegExp(
	          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
	        );
	      }
	      if (self.re.http.test(tail)) {
	        return tail.match(self.re.http)[0].length;
	      }
	      return 0;
	    }
	  },
	  'https:':  'http:',
	  'ftp:':    'http:',
	  '//':      {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.no_http) {
	      // compile lazily, because "host"-containing variables can change on tlds update.
	        self.re.no_http =  new RegExp(
	          '^' +
	          self.re.src_auth +
	          // Don't allow single-level domains, because of false positives like '//test'
	          // with code comments
	          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
	          self.re.src_port +
	          self.re.src_host_terminator +
	          self.re.src_path,
	
	          'i'
	        );
	      }
	
	      if (self.re.no_http.test(tail)) {
	        // should not be `://` & `///`, that protects from errors in protocol name
	        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
	        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
	        return tail.match(self.re.no_http)[0].length;
	      }
	      return 0;
	    }
	  },
	  'mailto:': {
	    validate: function (text, pos, self) {
	      var tail = text.slice(pos);
	
	      if (!self.re.mailto) {
	        self.re.mailto =  new RegExp(
	          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
	        );
	      }
	      if (self.re.mailto.test(tail)) {
	        return tail.match(self.re.mailto)[0].length;
	      }
	      return 0;
	    }
	  }
	};
	
	/*eslint-disable max-len*/
	
	// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
	var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
	
	// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
	var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');
	
	/*eslint-enable max-len*/
	
	////////////////////////////////////////////////////////////////////////////////
	
	function resetScanCache(self) {
	  self.__index__ = -1;
	  self.__text_cache__   = '';
	}
	
	function createValidator(re) {
	  return function (text, pos) {
	    var tail = text.slice(pos);
	
	    if (re.test(tail)) {
	      return tail.match(re)[0].length;
	    }
	    return 0;
	  };
	}
	
	function createNormalizer() {
	  return function (match, self) {
	    self.normalize(match);
	  };
	}
	
	// Schemas compiler. Build regexps.
	//
	function compile(self) {
	
	  // Load & clone RE patterns.
	  var re = self.re = __webpack_require__(600)(self.__opts__);
	
	  // Define dynamic patterns
	  var tlds = self.__tlds__.slice();
	
	  self.onCompile();
	
	  if (!self.__tlds_replaced__) {
	    tlds.push(tlds_2ch_src_re);
	  }
	  tlds.push(re.src_xn);
	
	  re.src_tlds = tlds.join('|');
	
	  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }
	
	  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
	  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
	  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
	  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
	
	  //
	  // Compile each schema
	  //
	
	  var aliases = [];
	
	  self.__compiled__ = {}; // Reset compiled data
	
	  function schemaError(name, val) {
	    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
	  }
	
	  Object.keys(self.__schemas__).forEach(function (name) {
	    var val = self.__schemas__[name];
	
	    // skip disabled methods
	    if (val === null) { return; }
	
	    var compiled = { validate: null, link: null };
	
	    self.__compiled__[name] = compiled;
	
	    if (isObject(val)) {
	      if (isRegExp(val.validate)) {
	        compiled.validate = createValidator(val.validate);
	      } else if (isFunction(val.validate)) {
	        compiled.validate = val.validate;
	      } else {
	        schemaError(name, val);
	      }
	
	      if (isFunction(val.normalize)) {
	        compiled.normalize = val.normalize;
	      } else if (!val.normalize) {
	        compiled.normalize = createNormalizer();
	      } else {
	        schemaError(name, val);
	      }
	
	      return;
	    }
	
	    if (isString(val)) {
	      aliases.push(name);
	      return;
	    }
	
	    schemaError(name, val);
	  });
	
	  //
	  // Compile postponed aliases
	  //
	
	  aliases.forEach(function (alias) {
	    if (!self.__compiled__[self.__schemas__[alias]]) {
	      // Silently fail on missed schemas to avoid errons on disable.
	      // schemaError(alias, self.__schemas__[alias]);
	      return;
	    }
	
	    self.__compiled__[alias].validate =
	      self.__compiled__[self.__schemas__[alias]].validate;
	    self.__compiled__[alias].normalize =
	      self.__compiled__[self.__schemas__[alias]].normalize;
	  });
	
	  //
	  // Fake record for guessed links
	  //
	  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };
	
	  //
	  // Build schema condition
	  //
	  var slist = Object.keys(self.__compiled__)
	                      .filter(function (name) {
	                        // Filter disabled & fake schemas
	                        return name.length > 0 && self.__compiled__[name];
	                      })
	                      .map(escapeRE)
	                      .join('|');
	  // (?!_) cause 1.5x slowdown
	  self.re.schema_test   = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
	  self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
	
	  self.re.pretest       = RegExp(
	                            '(' + self.re.schema_test.source + ')|' +
	                            '(' + self.re.host_fuzzy_test.source + ')|' +
	                            '@',
	                            'i');
	
	  //
	  // Cleanup
	  //
	
	  resetScanCache(self);
	}
	
	/**
	 * class Match
	 *
	 * Match result. Single element of array, returned by [[LinkifyIt#match]]
	 **/
	function Match(self, shift) {
	  var start = self.__index__,
	      end   = self.__last_index__,
	      text  = self.__text_cache__.slice(start, end);
	
	  /**
	   * Match#schema -> String
	   *
	   * Prefix (protocol) for matched string.
	   **/
	  this.schema    = self.__schema__.toLowerCase();
	  /**
	   * Match#index -> Number
	   *
	   * First position of matched string.
	   **/
	  this.index     = start + shift;
	  /**
	   * Match#lastIndex -> Number
	   *
	   * Next position after matched string.
	   **/
	  this.lastIndex = end + shift;
	  /**
	   * Match#raw -> String
	   *
	   * Matched string.
	   **/
	  this.raw       = text;
	  /**
	   * Match#text -> String
	   *
	   * Notmalized text of matched string.
	   **/
	  this.text      = text;
	  /**
	   * Match#url -> String
	   *
	   * Normalized url of matched string.
	   **/
	  this.url       = text;
	}
	
	function createMatch(self, shift) {
	  var match = new Match(self, shift);
	
	  self.__compiled__[match.schema].normalize(match, self);
	
	  return match;
	}
	
	
	/**
	 * class LinkifyIt
	 **/
	
	/**
	 * new LinkifyIt(schemas, options)
	 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
	 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
	 *
	 * Creates new linkifier instance with optional additional schemas.
	 * Can be called without `new` keyword for convenience.
	 *
	 * By default understands:
	 *
	 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
	 * - "fuzzy" links and emails (example.com, foo@bar.com).
	 *
	 * `schemas` is an object, where each key/value describes protocol/rule:
	 *
	 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
	 *   for example). `linkify-it` makes shure that prefix is not preceeded with
	 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
	 * - __value__ - rule to check tail after link prefix
	 *   - _String_ - just alias to existing rule
	 *   - _Object_
	 *     - _validate_ - validator function (should return matched length on success),
	 *       or `RegExp`.
	 *     - _normalize_ - optional function to normalize text & url of matched result
	 *       (for example, for @twitter mentions).
	 *
	 * `options`:
	 *
	 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
	 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
	 *   like version numbers. Default `false`.
	 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
	 *
	 **/
	function LinkifyIt(schemas, options) {
	  if (!(this instanceof LinkifyIt)) {
	    return new LinkifyIt(schemas, options);
	  }
	
	  if (!options) {
	    if (isOptionsObj(schemas)) {
	      options = schemas;
	      schemas = {};
	    }
	  }
	
	  this.__opts__           = assign({}, defaultOptions, options);
	
	  // Cache last tested result. Used to skip repeating steps on next `match` call.
	  this.__index__          = -1;
	  this.__last_index__     = -1; // Next scan position
	  this.__schema__         = '';
	  this.__text_cache__     = '';
	
	  this.__schemas__        = assign({}, defaultSchemas, schemas);
	  this.__compiled__       = {};
	
	  this.__tlds__           = tlds_default;
	  this.__tlds_replaced__  = false;
	
	  this.re = {};
	
	  compile(this);
	}
	
	
	/** chainable
	 * LinkifyIt#add(schema, definition)
	 * - schema (String): rule name (fixed pattern prefix)
	 * - definition (String|RegExp|Object): schema definition
	 *
	 * Add new rule definition. See constructor description for details.
	 **/
	LinkifyIt.prototype.add = function add(schema, definition) {
	  this.__schemas__[schema] = definition;
	  compile(this);
	  return this;
	};
	
	
	/** chainable
	 * LinkifyIt#set(options)
	 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
	 *
	 * Set recognition options for links without schema.
	 **/
	LinkifyIt.prototype.set = function set(options) {
	  this.__opts__ = assign(this.__opts__, options);
	  return this;
	};
	
	
	/**
	 * LinkifyIt#test(text) -> Boolean
	 *
	 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
	 **/
	LinkifyIt.prototype.test = function test(text) {
	  // Reset scan cache
	  this.__text_cache__ = text;
	  this.__index__      = -1;
	
	  if (!text.length) { return false; }
	
	  var m, ml, me, len, shift, next, re, tld_pos, at_pos;
	
	  // try to scan for link with schema - that's the most simple rule
	  if (this.re.schema_test.test(text)) {
	    re = this.re.schema_search;
	    re.lastIndex = 0;
	    while ((m = re.exec(text)) !== null) {
	      len = this.testSchemaAt(text, m[2], re.lastIndex);
	      if (len) {
	        this.__schema__     = m[2];
	        this.__index__      = m.index + m[1].length;
	        this.__last_index__ = m.index + m[0].length + len;
	        break;
	      }
	    }
	  }
	
	  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
	    // guess schemaless links
	    tld_pos = text.search(this.re.host_fuzzy_test);
	    if (tld_pos >= 0) {
	      // if tld is located after found link - no need to check fuzzy pattern
	      if (this.__index__ < 0 || tld_pos < this.__index__) {
	        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
	
	          shift = ml.index + ml[1].length;
	
	          if (this.__index__ < 0 || shift < this.__index__) {
	            this.__schema__     = '';
	            this.__index__      = shift;
	            this.__last_index__ = ml.index + ml[0].length;
	          }
	        }
	      }
	    }
	  }
	
	  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
	    // guess schemaless emails
	    at_pos = text.indexOf('@');
	    if (at_pos >= 0) {
	      // We can't skip this check, because this cases are possible:
	      // 192.168.1.1@gmail.com, my.in@example.com
	      if ((me = text.match(this.re.email_fuzzy)) !== null) {
	
	        shift = me.index + me[1].length;
	        next  = me.index + me[0].length;
	
	        if (this.__index__ < 0 || shift < this.__index__ ||
	            (shift === this.__index__ && next > this.__last_index__)) {
	          this.__schema__     = 'mailto:';
	          this.__index__      = shift;
	          this.__last_index__ = next;
	        }
	      }
	    }
	  }
	
	  return this.__index__ >= 0;
	};
	
	
	/**
	 * LinkifyIt#pretest(text) -> Boolean
	 *
	 * Very quick check, that can give false positives. Returns true if link MAY BE
	 * can exists. Can be used for speed optimization, when you need to check that
	 * link NOT exists.
	 **/
	LinkifyIt.prototype.pretest = function pretest(text) {
	  return this.re.pretest.test(text);
	};
	
	
	/**
	 * LinkifyIt#testSchemaAt(text, name, position) -> Number
	 * - text (String): text to scan
	 * - name (String): rule (schema) name
	 * - position (Number): text offset to check from
	 *
	 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
	 * at given position. Returns length of found pattern (0 on fail).
	 **/
	LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
	  // If not supported schema check requested - terminate
	  if (!this.__compiled__[schema.toLowerCase()]) {
	    return 0;
	  }
	  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
	};
	
	
	/**
	 * LinkifyIt#match(text) -> Array|null
	 *
	 * Returns array of found link descriptions or `null` on fail. We strongly
	 * recommend to use [[LinkifyIt#test]] first, for best speed.
	 *
	 * ##### Result match description
	 *
	 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
	 *   protocol-neutral  links.
	 * - __index__ - offset of matched text
	 * - __lastIndex__ - index of next char after mathch end
	 * - __raw__ - matched text
	 * - __text__ - normalized text
	 * - __url__ - link, generated from matched text
	 **/
	LinkifyIt.prototype.match = function match(text) {
	  var shift = 0, result = [];
	
	  // Try to take previous element from cache, if .test() called before
	  if (this.__index__ >= 0 && this.__text_cache__ === text) {
	    result.push(createMatch(this, shift));
	    shift = this.__last_index__;
	  }
	
	  // Cut head if cache was used
	  var tail = shift ? text.slice(shift) : text;
	
	  // Scan string until end reached
	  while (this.test(tail)) {
	    result.push(createMatch(this, shift));
	
	    tail = tail.slice(this.__last_index__);
	    shift += this.__last_index__;
	  }
	
	  if (result.length) {
	    return result;
	  }
	
	  return null;
	};
	
	
	/** chainable
	 * LinkifyIt#tlds(list [, keepOld]) -> this
	 * - list (Array): list of tlds
	 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
	 *
	 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
	 * to avoid false positives. By default this algorythm used:
	 *
	 * - hostname with any 2-letter root zones are ok.
	 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
	 *   are ok.
	 * - encoded (`xn--...`) root zones are ok.
	 *
	 * If list is replaced, then exact match for 2-chars root zones will be checked.
	 **/
	LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
	  list = Array.isArray(list) ? list : [ list ];
	
	  if (!keepOld) {
	    this.__tlds__ = list.slice();
	    this.__tlds_replaced__ = true;
	    compile(this);
	    return this;
	  }
	
	  this.__tlds__ = this.__tlds__.concat(list)
	                                  .sort()
	                                  .filter(function (el, idx, arr) {
	                                    return el !== arr[idx - 1];
	                                  })
	                                  .reverse();
	
	  compile(this);
	  return this;
	};
	
	/**
	 * LinkifyIt#normalize(match)
	 *
	 * Default normalizer (if schema does not define it's own).
	 **/
	LinkifyIt.prototype.normalize = function normalize(match) {
	
	  // Do minimal possible changes by default. Need to collect feedback prior
	  // to move forward https://github.com/markdown-it/linkify-it/issues/1
	
	  if (!match.schema) { match.url = 'http://' + match.url; }
	
	  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
	    match.url = 'mailto:' + match.url;
	  }
	};
	
	
	/**
	 * LinkifyIt#onCompile()
	 *
	 * Override to modify basic RegExp-s.
	 **/
	LinkifyIt.prototype.onCompile = function onCompile() {
	};
	
	
	module.exports = LinkifyIt;


/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	
	module.exports = function (opts) {
	  var re = {};
	
	  // Use direct extract instead of `regenerate` to reduse browserified size
	  re.src_Any = __webpack_require__(802).source;
	  re.src_Cc  = __webpack_require__(799).source;
	  re.src_Z   = __webpack_require__(801).source;
	  re.src_P   = __webpack_require__(800).source;
	
	  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
	  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');
	
	  // \p{\Z\Cc} (white spaces + control)
	  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');
	
	  // Experimental. List of chars, completely prohibited in links
	  // because can separate it from other part of text
	  var text_separators = '[><\uff5c]';
	
	  // All possible word characters (everything without punctuation, spaces & controls)
	  // Defined via punctuation & spaces to save space
	  // Should be something like \p{\L\N\S\M} (\w but without `_`)
	  re.src_pseudo_letter       = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
	  // The same as abothe but without [0-9]
	  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
	
	  ////////////////////////////////////////////////////////////////////////////////
	
	  re.src_ip4 =
	
	    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
	
	  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
	  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
	
	  re.src_port =
	
	    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
	
	  re.src_host_terminator =
	
	    '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
	
	  re.src_path =
	
	    '(?:' +
	      '[/?#]' +
	        '(?:' +
	          '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' +
	          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
	          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
	          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
	          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
	          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
	          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
	          '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
	                                     // - english
	                                     // - percent-encoded
	                                     // - parts of file path
	                                     // until more examples found.
	          '\\.(?!' + re.src_ZCc + '|[.]).|' +
	          (opts && opts['---'] ?
	            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
	          :
	            '\\-+|'
	          ) +
	          '\\,(?!' + re.src_ZCc + ').|' +      // allow `,,,` in paths
	          '\\!(?!' + re.src_ZCc + '|[!]).|' +
	          '\\?(?!' + re.src_ZCc + '|[?]).' +
	        ')+' +
	      '|\\/' +
	    ')?';
	
	  re.src_email_name =
	
	    '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
	
	  re.src_xn =
	
	    'xn--[a-z0-9\\-]{1,59}';
	
	  // More to read about domain names
	  // http://serverfault.com/questions/638260/
	
	  re.src_domain_root =
	
	    // Allow letters & digits (http://test1)
	    '(?:' +
	      re.src_xn +
	      '|' +
	      re.src_pseudo_letter + '{1,63}' +
	    ')';
	
	  re.src_domain =
	
	    '(?:' +
	      re.src_xn +
	      '|' +
	      '(?:' + re.src_pseudo_letter + ')' +
	      '|' +
	      // don't allow `--` in domain names, because:
	      // - that can conflict with markdown &mdash; / &ndash;
	      // - nobody use those anyway
	      '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
	    ')';
	
	  re.src_host =
	
	    '(?:' +
	    // Don't need IP check, because digits are already allowed in normal domain names
	    //   src_ip4 +
	    // '|' +
	      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
	    ')';
	
	  re.tpl_host_fuzzy =
	
	    '(?:' +
	      re.src_ip4 +
	    '|' +
	      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
	    ')';
	
	  re.tpl_host_no_ip_fuzzy =
	
	    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
	
	  re.src_host_strict =
	
	    re.src_host + re.src_host_terminator;
	
	  re.tpl_host_fuzzy_strict =
	
	    re.tpl_host_fuzzy + re.src_host_terminator;
	
	  re.src_host_port_strict =
	
	    re.src_host + re.src_port + re.src_host_terminator;
	
	  re.tpl_host_port_fuzzy_strict =
	
	    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
	
	  re.tpl_host_port_no_ip_fuzzy_strict =
	
	    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
	
	
	  ////////////////////////////////////////////////////////////////////////////////
	  // Main rules
	
	  // Rude test fuzzy links by host, for quick deny
	  re.tpl_host_fuzzy_test =
	
	    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
	
	  re.tpl_email_fuzzy =
	
	      '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
	
	  re.tpl_link_fuzzy =
	      // Fuzzy link can't be prepended with .:/\- and non punctuation.
	      // but can start with > (markdown blockquote)
	      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
	      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
	
	  re.tpl_link_no_ip_fuzzy =
	      // Fuzzy link can't be prepended with .:/\- and non punctuation.
	      // but can start with > (markdown blockquote)
	      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
	      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
	
	  return re;
	};


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(28);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(49),
	    getRawTag = __webpack_require__(96),
	    objectToString = __webpack_require__(97);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(49);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(69);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(33),
	    now = __webpack_require__(99),
	    toNumber = __webpack_require__(100);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(32),
	    isObjectLike = __webpack_require__(37);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(28);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(33),
	    isSymbol = __webpack_require__(71);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ref;
	// @inheritedComponent ButtonBase
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _colorManipulator = __webpack_require__(73);
	
	var _ButtonBase = __webpack_require__(106);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: (0, _extends3.default)({}, theme.typography.button, {
	      lineHeight: '1em',
	      boxSizing: 'border-box',
	      minWidth: 88,
	      minHeight: 36,
	      padding: '11px ' + theme.spacing.unit * 2 + 'px',
	      borderRadius: 2,
	      color: theme.palette.text.primary,
	      backgroundColor: 'transparent',
	      transition: theme.transitions.create(['background-color', 'box-shadow'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        // Reset on mouse devices
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, 0.12),
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      }
	    }),
	    dense: {
	      padding: '10px ' + theme.spacing.unit + 'px',
	      minWidth: 64,
	      minHeight: 32,
	      fontSize: theme.typography.fontSize - 1
	    },
	    label: {
	      width: '100%',
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	    flatPrimary: {
	      color: theme.palette.primary[500],
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary[500], 0.12),
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    flatAccent: {
	      color: theme.palette.secondary.A200,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.A200, 0.12),
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    flatContrast: {
	      color: theme.palette.getContrastText(theme.palette.primary[500]),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.getContrastText(theme.palette.primary[500]), 0.12),
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    raised: {
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      boxShadow: theme.shadows[2],
	      '&$keyboardFocused': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[8]
	      },
	      '&$disabled': {
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.text.divider
	      },
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.text.divider,
	          // Reset on mouse devices
	          '@media (hover: none)': {
	            backgroundColor: theme.palette.grey[300]
	          }
	        }
	      }
	    },
	    keyboardFocused: {},
	    raisedPrimary: {
	      color: theme.palette.getContrastText(theme.palette.primary[500]),
	      backgroundColor: theme.palette.primary[500],
	      '&:hover': {
	        backgroundColor: theme.palette.primary[700],
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary[500]
	        }
	      }
	    },
	    raisedAccent: {
	      color: theme.palette.getContrastText(theme.palette.secondary.A200),
	      backgroundColor: theme.palette.secondary.A200,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.A400,
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.A200
	        }
	      }
	    },
	    raisedContrast: {
	      color: theme.palette.getContrastText(theme.palette.primary[500])
	    },
	    disabled: {
	      color: theme.palette.action.disabled
	    },
	    fab: {
	      borderRadius: '50%',
	      padding: 0,
	      minWidth: 0,
	      width: 56,
	      height: 56,
	      boxShadow: theme.shadows[6],
	      '&:active': {
	        boxShadow: theme.shadows[12]
	      }
	    }
	  };
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node.isRequired ? babelPluginFlowReactPropTypes_proptype_Node.isRequired : babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node).isRequired,
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  color: __webpack_require__(1).oneOf(['default', 'inherit', 'primary', 'accent', 'contrast']),
	  component: __webpack_require__(1).oneOfType([__webpack_require__(1).string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_ComponentType)]),
	  dense: __webpack_require__(1).bool,
	  disabled: __webpack_require__(1).bool,
	  disableFocusRipple: __webpack_require__(1).bool,
	  disableRipple: __webpack_require__(1).bool,
	  fab: __webpack_require__(1).bool,
	  href: __webpack_require__(1).string,
	  raised: __webpack_require__(1).bool,
	  type: __webpack_require__(1).string
	};
	
	
	function Button(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      dense = props.dense,
	      disabled = props.disabled,
	      disableFocusRipple = props.disableFocusRipple,
	      fab = props.fab,
	      raised = props.raised,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'dense', 'disabled', 'disableFocusRipple', 'fab', 'raised']);
	
	
	  var flat = !raised && !fab;
	  var className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.root, true), (0, _defineProperty3.default)(_classNames, classes.raised, raised || fab), (0, _defineProperty3.default)(_classNames, classes.fab, fab), (0, _defineProperty3.default)(_classNames, classes.colorInherit, color === 'inherit'), (0, _defineProperty3.default)(_classNames, classes.flatPrimary, flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.flatAccent, flat && color === 'accent'), (0, _defineProperty3.default)(_classNames, classes.flatContrast, flat && color === 'contrast'), (0, _defineProperty3.default)(_classNames, classes.raisedPrimary, !flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.raisedAccent, !flat && color === 'accent'), (0, _defineProperty3.default)(_classNames, classes.raisedContrast, !flat && color === 'contrast'), (0, _defineProperty3.default)(_classNames, classes.dense, dense), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
	
	  return _react2.default.createElement(
	    _ButtonBase2.default,
	    (0, _extends3.default)({
	      className: className,
	      disabled: disabled,
	      focusRipple: !disableFocusRipple,
	      keyboardFocusedClassName: classes.keyboardFocused
	    }, other),
	    _react2.default.createElement(
	      'span',
	      { className: classes.label },
	      children
	    )
	  );
	}
	
	Button.propTypes =  false ? (_ref = {
	  classes: require('prop-types').object.isRequired,
	  color: require('prop-types').oneOf(['default']).isRequired,
	  dense: require('prop-types').bool.isRequired,
	  disabled: require('prop-types').bool.isRequired,
	  fab: require('prop-types').bool.isRequired,
	  disableFocusRipple: require('prop-types').bool.isRequired,
	  raised: require('prop-types').bool.isRequired,
	  disableRipple: require('prop-types').bool.isRequired,
	  type: require('prop-types').oneOf(['button']).isRequired,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node.isRequired ? babelPluginFlowReactPropTypes_proptype_Node.isRequired : babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node).isRequired
	}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'color', require('prop-types').oneOf(['default', 'inherit', 'primary', 'accent', 'contrast'])), (0, _defineProperty3.default)(_ref, 'component', require('prop-types').oneOfType([require('prop-types').string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ComponentType)])), (0, _defineProperty3.default)(_ref, 'dense', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'disabled', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'disableFocusRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'disableRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'fab', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'href', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'raised', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'type', require('prop-types').string), _ref) : {};
	Button.defaultProps = {
	  color: 'default',
	  dense: false,
	  disabled: false,
	  fab: false,
	  disableFocusRipple: false,
	  raised: false,
	  disableRipple: false,
	  type: 'button'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButton' })(Button);

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(101);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ref2, _ref3; //  weak
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getDisplayName = __webpack_require__(124);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _keycode = __webpack_require__(43);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _keyboardFocus = __webpack_require__(111);
	
	var _TouchRipple = __webpack_require__(104);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _createRippleHandler = __webpack_require__(105);
	
	var _createRippleHandler2 = _interopRequireDefault(_createRippleHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      position: 'relative',
	      // Remove grey highlight
	      WebkitTapHighlightColor: theme.palette.common.transparent,
	      outline: 'none',
	      border: 0,
	      cursor: 'pointer',
	      userSelect: 'none',
	      appearance: 'none',
	      textDecoration: 'none',
	      // So we take precedent over the style of a native <a /> element.
	      color: 'inherit'
	    },
	    disabled: {
	      pointerEvents: 'none', // Disable link interactions
	      cursor: 'default'
	    }
	  };
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  centerRipple: __webpack_require__(1).bool,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node),
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  component: __webpack_require__(1).oneOfType([__webpack_require__(1).string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_ComponentType)]),
	  disabled: __webpack_require__(1).bool,
	  disableRipple: __webpack_require__(1).bool,
	  focusRipple: __webpack_require__(1).bool,
	  keyboardFocusedClassName: __webpack_require__(1).string,
	  onBlur: __webpack_require__(1).func,
	  onClick: __webpack_require__(1).func,
	  onFocus: __webpack_require__(1).func,
	  onKeyboardFocus: __webpack_require__(1).func,
	  onKeyDown: __webpack_require__(1).func,
	  onKeyUp: __webpack_require__(1).func,
	  onMouseDown: __webpack_require__(1).func,
	  onMouseLeave: __webpack_require__(1).func,
	  onMouseUp: __webpack_require__(1).func,
	  onTouchEnd: __webpack_require__(1).func,
	  onTouchStart: __webpack_require__(1).func,
	  role: __webpack_require__(1).string,
	  tabIndex: __webpack_require__(1).oneOfType([__webpack_require__(1).number, __webpack_require__(1).string]),
	  type: __webpack_require__(1).string.isRequired
	};
	
	var ButtonBase = function (_React$Component) {
	  (0, _inherits3.default)(ButtonBase, _React$Component);
	
	  function ButtonBase() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ButtonBase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonBase.__proto__ || (0, _getPrototypeOf2.default)(ButtonBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      keyboardFocused: false
	    }, _this.ripple = null, _this.keyDown = false, _this.button = null, _this.keyboardFocusTimeout = null, _this.keyboardFocusCheckTime = 40, _this.keyboardFocusMaxCheckTimes = 5, _this.focus = function () {
	      _this.button.focus();
	    }, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          component = _this$props.component,
	          focusRipple = _this$props.focusRipple,
	          onKeyDown = _this$props.onKeyDown,
	          onClick = _this$props.onClick;
	
	      var key = (0, _keycode2.default)(event);
	
	      // Check if key is already down to avoid repeats being counted as multiple activations
	      if (focusRipple && !_this.keyDown && _this.state.keyboardFocused && key === 'space') {
	        _this.keyDown = true;
	        event.persist();
	        _this.ripple.stop(event, function () {
	          _this.ripple.start(event);
	        });
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      }
	
	      // Keyboard accessibility for non interactive elements
	      if (event.target === _this.button && onClick && component && component !== 'a' && component !== 'button' && (key === 'space' || key === 'enter')) {
	        event.preventDefault();
	        onClick(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.props.focusRipple && (0, _keycode2.default)(event) === 'space' && _this.state.keyboardFocused) {
	        _this.keyDown = false;
	        event.persist();
	        _this.ripple.stop(event, function () {
	          return _this.ripple.pulsate(event);
	        });
	      }
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(event);
	      }
	    }, _this.handleMouseDown = (0, _createRippleHandler2.default)(_this, 'MouseDown', 'start', function () {
	      clearTimeout(_this.keyboardFocusTimeout);
	      (0, _keyboardFocus.focusKeyPressed)(false);
	      if (_this.state.keyboardFocused) {
	        _this.setState({ keyboardFocused: false });
	      }
	    }), _this.handleMouseUp = (0, _createRippleHandler2.default)(_this, 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _createRippleHandler2.default)(_this, 'MouseLeave', 'stop', function (event) {
	      if (_this.state.keyboardFocused) {
	        event.preventDefault();
	      }
	    }), _this.handleTouchStart = (0, _createRippleHandler2.default)(_this, 'TouchStart', 'start'), _this.handleTouchEnd = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleBlur = (0, _createRippleHandler2.default)(_this, 'Blur', 'stop', function () {
	      _this.setState({ keyboardFocused: false });
	    }), _this.handleFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this.button) {
	        event.persist();
	
	        var keyboardFocusCallback = _this.onKeyboardFocusHandler.bind(_this, event);
	        (0, _keyboardFocus.detectKeyboardFocus)(_this, (0, _reactDom.findDOMNode)(_this.button), keyboardFocusCallback);
	      }
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.onKeyboardFocusHandler = function (event) {
	      _this.keyDown = false;
	      _this.setState({ keyboardFocused: true });
	
	      if (_this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ButtonBase, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _keyboardFocus.listenForFocusKeys)();
	
	       false ? (0, _warning2.default)(this.button, ['Material-UI: you have provided a custom Component to the `component` ' + 'property of `ButtonBase`.', 'In order to make the keyboard focus logic work, we need a reference on the root element.', 'Please provide a class component instead of a functional component.',
	      // eslint-disable-next-line prefer-template
	      'You need to fix the: ' + ((0, _getDisplayName2.default)(this.props.component) === 'component' ? String(this.props.component) : (0, _getDisplayName2.default)(this.props.component)) + ' component.'].join('\n')) : void 0;
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.props.focusRipple && nextState.keyboardFocused && !this.state.keyboardFocused && !this.props.disableRipple) {
	        this.ripple.pulsate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.keyboardFocusTimeout);
	    } // Used to help track keyboard activation keyDown
	
	  }, {
	    key: 'renderRipple',
	    value: function renderRipple() {
	      var _this2 = this;
	
	      if (!this.props.disableRipple && !this.props.disabled) {
	        return _react2.default.createElement(_TouchRipple2.default, {
	          innerRef: function innerRef(node) {
	            _this2.ripple = node;
	          },
	          center: this.props.centerRipple
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames,
	          _this3 = this;
	
	      var _props = this.props,
	          centerRipple = _props.centerRipple,
	          children = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          component = _props.component,
	          disabled = _props.disabled,
	          disableRipple = _props.disableRipple,
	          focusRipple = _props.focusRipple,
	          keyboardFocusedClassName = _props.keyboardFocusedClassName,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onKeyDown = _props.onKeyDown,
	          onKeyUp = _props.onKeyUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseUp = _props.onMouseUp,
	          onTouchEnd = _props.onTouchEnd,
	          onTouchStart = _props.onTouchStart,
	          tabIndex = _props.tabIndex,
	          type = _props.type,
	          other = (0, _objectWithoutProperties3.default)(_props, ['centerRipple', 'children', 'classes', 'className', 'component', 'disabled', 'disableRipple', 'focusRipple', 'keyboardFocusedClassName', 'onBlur', 'onFocus', 'onKeyboardFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseLeave', 'onMouseUp', 'onTouchEnd', 'onTouchStart', 'tabIndex', 'type']);
	
	
	      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, keyboardFocusedClassName, keyboardFocusedClassName && this.state.keyboardFocused), _classNames), classNameProp);
	
	      var buttonProps = {};
	
	      var ComponentProp = component;
	
	      if (!ComponentProp) {
	        if (other.href) {
	          ComponentProp = 'a';
	        } else {
	          ComponentProp = 'button';
	        }
	      }
	
	      if (ComponentProp === 'button') {
	        buttonProps.type = type || 'button';
	      }
	
	      if (ComponentProp !== 'a') {
	        buttonProps.role = buttonProps.role || 'button';
	        buttonProps.disabled = disabled;
	      }
	
	      return _react2.default.createElement(
	        ComponentProp,
	        (0, _extends3.default)({
	          ref: function ref(node) {
	            _this3.button = node;
	          },
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseUp: this.handleMouseUp,
	          onTouchEnd: this.handleTouchEnd,
	          onTouchStart: this.handleTouchStart,
	          tabIndex: disabled ? -1 : tabIndex,
	          className: className
	        }, buttonProps, other),
	        children,
	        this.renderRipple()
	      );
	    }
	  }]);
	  return ButtonBase;
	}(_react2.default.Component);
	
	ButtonBase.defaultProps = {
	  centerRipple: false,
	  focusRipple: false,
	  disableRipple: false,
	  tabIndex: 0,
	  type: 'button'
	};
	ButtonBase.propTypes =  false ? (_ref2 = {
	  classes: require('prop-types').object.isRequired,
	  centerRipple: require('prop-types').bool,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
	}, (0, _defineProperty3.default)(_ref2, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref2, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref2, 'component', require('prop-types').oneOfType([require('prop-types').string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ComponentType)])), (0, _defineProperty3.default)(_ref2, 'disabled', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'disableRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'focusRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'keyboardFocusedClassName', require('prop-types').string), (0, _defineProperty3.default)(_ref2, 'onBlur', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onClick', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onFocus', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onKeyboardFocus', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onKeyDown', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onKeyUp', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onMouseDown', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onMouseLeave', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onMouseUp', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onTouchEnd', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onTouchStart', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'role', require('prop-types').string), (0, _defineProperty3.default)(_ref2, 'tabIndex', require('prop-types').oneOfType([require('prop-types').number, require('prop-types').string])), (0, _defineProperty3.default)(_ref2, 'type', require('prop-types').string.isRequired), _ref2) : {};
	ButtonBase.propTypes =  false ? (_ref3 = {
	  classes: require('prop-types').object.isRequired,
	  centerRipple: require('prop-types').bool,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
	}, (0, _defineProperty3.default)(_ref3, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref3, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref3, 'component', require('prop-types').oneOfType([require('prop-types').string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ComponentType)])), (0, _defineProperty3.default)(_ref3, 'disabled', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'disableRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'focusRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'keyboardFocusedClassName', require('prop-types').string), (0, _defineProperty3.default)(_ref3, 'onBlur', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onClick', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onFocus', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onKeyboardFocus', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onKeyDown', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onKeyUp', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onMouseDown', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onMouseLeave', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onMouseUp', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onTouchEnd', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onTouchStart', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'role', require('prop-types').string), (0, _defineProperty3.default)(_ref3, 'tabIndex', require('prop-types').oneOfType([require('prop-types').number, require('prop-types').string])), (0, _defineProperty3.default)(_ref3, 'type', require('prop-types').string.isRequired), _ref3) : {};
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButtonBase' })(ButtonBase);

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Transition = __webpack_require__(119);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  classes: __webpack_require__(1).object.isRequired,
	  className: __webpack_require__(1).string,
	  pulsate: __webpack_require__(1).bool,
	  rippleSize: __webpack_require__(1).number.isRequired,
	  rippleX: __webpack_require__(1).number.isRequired,
	  rippleY: __webpack_require__(1).number.isRequired
	}; //  weak
	
	/**
	 * @ignore - internal component.
	 */
	var Ripple = function (_React$Component) {
	  (0, _inherits3.default)(Ripple, _React$Component);
	
	  function Ripple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Ripple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ripple.__proto__ || (0, _getPrototypeOf2.default)(Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      rippleVisible: false,
	      rippleLeaving: false
	    }, _this.handleEnter = function () {
	      _this.setState({
	        rippleVisible: true
	      });
	    }, _this.handleExit = function () {
	      _this.setState({
	        rippleLeaving: true
	      });
	    }, _this.getRippleStyles = function (props) {
	      var rippleSize = props.rippleSize,
	          rippleX = props.rippleX,
	          rippleY = props.rippleY;
	
	
	      return {
	        width: rippleSize,
	        height: rippleSize,
	        top: -(rippleSize / 2) + rippleY,
	        left: -(rippleSize / 2) + rippleX
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Ripple, [{
	    key: 'render',
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _props = this.props,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          pulsate = _props.pulsate,
	          rippleX = _props.rippleX,
	          rippleY = _props.rippleY,
	          rippleSize = _props.rippleSize,
	          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'pulsate', 'rippleX', 'rippleY', 'rippleSize']);
	      var _state = this.state,
	          rippleVisible = _state.rippleVisible,
	          rippleLeaving = _state.rippleLeaving;
	
	
	      var className = (0, _classnames2.default)(classes.wrapper, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.wrapperLeaving, rippleLeaving), (0, _defineProperty3.default)(_classNames, classes.wrapperPulsating, pulsate), _classNames), classNameProp);
	
	      var rippleClassName = (0, _classnames2.default)(classes.ripple, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.rippleVisible, rippleVisible), (0, _defineProperty3.default)(_classNames2, classes.rippleFast, pulsate), _classNames2));
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        (0, _extends3.default)({ onEnter: this.handleEnter, onExit: this.handleExit }, other),
	        _react2.default.createElement(
	          'span',
	          { className: className },
	          _react2.default.createElement('span', { className: rippleClassName, style: this.getRippleStyles(this.props) })
	        )
	      );
	    }
	  }]);
	  return Ripple;
	}(_react2.default.Component);
	
	Ripple.defaultProps = {
	  pulsate: false
	};
	Ripple.propTypes =  false ? {
	  classes: require('prop-types').object.isRequired,
	  className: require('prop-types').string,
	  pulsate: require('prop-types').bool,
	  rippleSize: require('prop-types').number.isRequired,
	  rippleX: require('prop-types').number.isRequired,
	  rippleY: require('prop-types').number.isRequired
	} : {};
	Ripple.propTypes =  false ? {
	  classes: require('prop-types').object.isRequired,
	  className: require('prop-types').string,
	  pulsate: require('prop-types').bool,
	  rippleSize: require('prop-types').number.isRequired,
	  rippleX: require('prop-types').number.isRequired,
	  rippleY: require('prop-types').number.isRequired
	} : {};
	exports.default = Ripple;

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(154);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ref2, _ref3; //  weak
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionGroup = __webpack_require__(120);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Ripple = __webpack_require__(103);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DURATION = 550;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'block',
	      position: 'absolute',
	      overflow: 'hidden',
	      borderRadius: 'inherit',
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      pointerEvents: 'none',
	      zIndex: 0
	    },
	    wrapper: {
	      opacity: 1
	    },
	    wrapperLeaving: {
	      opacity: 0,
	      animation: 'mui-ripple-exit ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
	    },
	    wrapperPulsating: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      animation: 'mui-ripple-pulsate 1500ms ' + theme.transitions.easing.easeInOut + ' 200ms infinite',
	      rippleVisible: {
	        opacity: 0.2
	      }
	    },
	    '@keyframes mui-ripple-enter': {
	      '0%': {
	        transform: 'scale(0)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    },
	    '@keyframes mui-ripple-exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes mui-ripple-pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.9)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    },
	    ripple: {
	      width: 50,
	      height: 50,
	      left: 0,
	      top: 0,
	      opacity: 0,
	      position: 'absolute',
	      borderRadius: '50%',
	      background: 'currentColor'
	    },
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: 'mui-ripple-enter ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
	    },
	    rippleFast: {
	      animationDuration: '200ms'
	    }
	  };
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  center: __webpack_require__(1).bool,
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string
	};
	
	/**
	 * @ignore - internal component.
	 */
	var TouchRipple = function (_React$Component) {
	  (0, _inherits3.default)(TouchRipple, _React$Component);
	
	  function TouchRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      nextKey: 0,
	      ripples: []
	    }, _this.ignoringMouseDown = false, _this.pulsate = function () {
	      _this.start({}, { pulsate: true });
	    }, _this.start = function () {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var cb = arguments[2];
	      var _options$pulsate = options.pulsate,
	          pulsate = _options$pulsate === undefined ? false : _options$pulsate,
	          _options$center = options.center,
	          center = _options$center === undefined ? _this.props.center || options.pulsate : _options$center;
	
	
	      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
	        _this.ignoringMouseDown = false;
	        return;
	      }
	
	      if (event.type === 'touchstart') {
	        _this.ignoringMouseDown = true;
	      }
	
	      var ripples = _this.state.ripples;
	
	      var element = _reactDom2.default.findDOMNode(_this);
	      var rect = element ? // $FlowFixMe
	      element.getBoundingClientRect() : {
	        width: 0,
	        height: 0,
	        left: 0,
	        top: 0
	      };
	
	      // Get the size of the ripple
	      var rippleX = void 0;
	      var rippleY = void 0;
	      var rippleSize = void 0;
	
	      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	        rippleX = Math.round(rect.width / 2);
	        rippleY = Math.round(rect.height / 2);
	      } else {
	        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	        rippleX = Math.round(clientX - rect.left);
	        rippleY = Math.round(clientY - rect.top);
	      }
	
	      if (center) {
	        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);
	
	        // For some reason the animation is broken on Mobile Chrome if the size if even.
	        if (rippleSize % 2 === 0) {
	          rippleSize += 1;
	        }
	      } else {
	        var sizeX = Math.max(
	        // $FlowFixMe
	        Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	        var sizeY = Math.max(
	        // $FlowFixMe
	        Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	      }
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_Ripple2.default, {
	        key: _this.state.nextKey,
	        classes: _this.props.classes,
	        timeout: {
	          exit: DURATION,
	          enter: DURATION
	        },
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	
	      _this.setState({
	        nextKey: _this.state.nextKey + 1,
	        ripples: ripples
	      }, cb);
	    }, _this.stop = function (event, cb) {
	      var ripples = _this.state.ripples;
	
	      if (ripples && ripples.length) {
	        _this.setState({
	          ripples: ripples.slice(1)
	        }, cb);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // Used to filter out mouse emulated events on mobile.
	
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          center = _props.center,
	          classes = _props.classes,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['center', 'classes', 'className']);
	
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({
	          component: 'span',
	          enter: true,
	          exit: true,
	          className: (0, _classnames2.default)(classes.root, className)
	        }, other),
	        this.state.ripples
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react2.default.Component);
	
	TouchRipple.defaultProps = {
	  center: false
	};
	TouchRipple.propTypes =  false ? (_ref2 = {
	  classes: require('prop-types').object.isRequired,
	  center: require('prop-types').bool
	}, (0, _defineProperty3.default)(_ref2, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref2, 'className', require('prop-types').string), _ref2) : {};
	TouchRipple.propTypes =  false ? (_ref3 = {
	  classes: require('prop-types').object.isRequired,
	  center: require('prop-types').bool
	}, (0, _defineProperty3.default)(_ref3, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref3, 'className', require('prop-types').string), _ref3) : {};
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTouchRipple' })(TouchRipple);

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function createRippleHandler(instance, eventName, action, cb) {
	  return function handleEvent(event) {
	    if (cb) {
	      cb.call(instance, event);
	    }
	
	    if (event.defaultPrevented) {
	      return false;
	    }
	
	    if (instance.ripple) {
	      instance.ripple[action](event);
	    }
	
	    if (instance.props && typeof instance.props['on' + eventName] === 'function') {
	      instance.props['on' + eventName](event);
	    }
	
	    return true;
	  };
	}
	
	exports.default = createRippleHandler;

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ButtonBase = __webpack_require__(102);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonBase).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _ref;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(39);
	
	var _Modal = __webpack_require__(206);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Fade = __webpack_require__(110);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _transitions = __webpack_require__(109);
	
	var _Paper = __webpack_require__(202);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_TransitionCallback = __webpack_require__(50).babelPluginFlowReactPropTypes_proptype_TransitionCallback || __webpack_require__(1).any;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	    paper: {
	      display: 'flex',
	      margin: theme.spacing.unit * 4,
	      flexDirection: 'column',
	      flex: '0 1 auto',
	      position: 'relative',
	      maxHeight: '90vh',
	      '&:focus': {
	        outline: 'none'
	      }
	    },
	    paperWidthXs: {
	      maxWidth: theme.breakpoints.getWidth('xs')
	    },
	    paperWidthSm: {
	      maxWidth: theme.breakpoints.getWidth('sm')
	    },
	    paperWidthMd: {
	      maxWidth: theme.breakpoints.getWidth('md')
	    },
	    fullScreen: {
	      margin: 0,
	      width: '100%',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: '100%',
	      borderRadius: 0
	    }
	  };
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node),
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  fullScreen: __webpack_require__(1).bool,
	  ignoreBackdropClick: __webpack_require__(1).bool,
	  ignoreEscapeKeyUp: __webpack_require__(1).bool,
	  enterTransitionDuration: __webpack_require__(1).number,
	  leaveTransitionDuration: __webpack_require__(1).number,
	  maxWidth: __webpack_require__(1).oneOf(['xs', 'sm', 'md']),
	  onBackdropClick: __webpack_require__(1).func,
	  onEnter: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onEntering: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onEntered: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onEscapeKeyUp: __webpack_require__(1).func,
	  onExit: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onExiting: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onExited: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onRequestClose: __webpack_require__(1).func,
	  open: __webpack_require__(1).bool,
	  transition: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node)
	};
	
	
	/**
	 * Dialogs are overlaid modal paper based components with a backdrop.
	 */
	function Dialog(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      fullScreen = props.fullScreen,
	      ignoreBackdropClick = props.ignoreBackdropClick,
	      ignoreEscapeKeyUp = props.ignoreEscapeKeyUp,
	      enterTransitionDuration = props.enterTransitionDuration,
	      leaveTransitionDuration = props.leaveTransitionDuration,
	      maxWidth = props.maxWidth,
	      open = props.open,
	      onBackdropClick = props.onBackdropClick,
	      onEscapeKeyUp = props.onEscapeKeyUp,
	      onEnter = props.onEnter,
	      onEntering = props.onEntering,
	      onEntered = props.onEntered,
	      onExit = props.onExit,
	      onExiting = props.onExiting,
	      onExited = props.onExited,
	      onRequestClose = props.onRequestClose,
	      transition = props.transition,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'fullScreen', 'ignoreBackdropClick', 'ignoreEscapeKeyUp', 'enterTransitionDuration', 'leaveTransitionDuration', 'maxWidth', 'open', 'onBackdropClick', 'onEscapeKeyUp', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'onRequestClose', 'transition']);
	
	
	  var createTransitionFn = typeof transition === 'function' ? _react2.default.createElement : _react2.default.cloneElement;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    (0, _extends3.default)({
	      className: (0, _classnames2.default)(classes.root, className),
	      backdropTransitionDuration: open ? enterTransitionDuration : leaveTransitionDuration,
	      ignoreBackdropClick: ignoreBackdropClick,
	      ignoreEscapeKeyUp: ignoreEscapeKeyUp,
	      onBackdropClick: onBackdropClick,
	      onEscapeKeyUp: onEscapeKeyUp,
	      onRequestClose: onRequestClose,
	      show: open
	    }, other),
	    createTransitionFn(
	    /* $FlowFixMe - FIXME See Snackbar for similar create vs clone example */
	    transition, {
	      in: open,
	      transitionAppear: true,
	      enterTransitionDuration: enterTransitionDuration,
	      leaveTransitionDuration: leaveTransitionDuration,
	      onEnter: onEnter,
	      onEntering: onEntering,
	      onEntered: onEntered,
	      onExit: onExit,
	      onExiting: onExiting,
	      onExited: onExited
	    }, _react2.default.createElement(
	      _Paper2.default,
	      {
	        elevation: 24,
	        className: (0, _classnames2.default)(classes.paper, classes['paperWidth' + (0, _helpers.capitalizeFirstLetter)(maxWidth)], (0, _defineProperty3.default)({}, classes.fullScreen, fullScreen))
	      },
	      children
	    ))
	  );
	}
	
	Dialog.propTypes =  false ? (_ref = {
	  classes: require('prop-types').object.isRequired,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
	}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'fullScreen', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'ignoreBackdropClick', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'ignoreEscapeKeyUp', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'enterTransitionDuration', require('prop-types').number), (0, _defineProperty3.default)(_ref, 'leaveTransitionDuration', require('prop-types').number), (0, _defineProperty3.default)(_ref, 'maxWidth', require('prop-types').oneOf(['xs', 'sm', 'md'])), (0, _defineProperty3.default)(_ref, 'onBackdropClick', require('prop-types').func), (0, _defineProperty3.default)(_ref, 'onEnter', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref, 'onEntering', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref, 'onEntered', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref, 'onEscapeKeyUp', require('prop-types').func), (0, _defineProperty3.default)(_ref, 'onExit', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref, 'onExiting', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref, 'onExited', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref, 'onRequestClose', require('prop-types').func), (0, _defineProperty3.default)(_ref, 'open', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'transition', typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)), _ref) : {};
	Dialog.defaultProps = {
	  fullScreen: false,
	  ignoreBackdropClick: false,
	  ignoreEscapeKeyUp: false,
	  enterTransitionDuration: _transitions.duration.enteringScreen,
	  leaveTransitionDuration: _transitions.duration.leavingScreen,
	  maxWidth: 'sm',
	  open: false,
	  transition: _Fade2.default
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialog' })(Dialog);

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	__webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// So we don't have any override priority issue.
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-end',
	      alignItems: 'center',
	      margin: theme.spacing.unit + 'px 4px',
	      flex: '0 0 auto'
	    },
	    action: {
	      margin: '0 4px'
	    },
	    button: {
	      minWidth: 64
	    }
	  };
	}; //  weak
	
	function DialogActions(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    _react2.default.Children.map(children, function (button) {
	      return _react2.default.isValidElement(button) && _react2.default.createElement(
	        'div',
	        { className: classes.action },
	        _react2.default.cloneElement(button, {
	          className: (0, _classnames2.default)(classes.button, button.props.className)
	        })
	      );
	    })
	  );
	}
	
	DialogActions.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogActions' })(DialogActions);

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	var styles = exports.styles = function styles(theme) {
	  var spacing = theme.spacing.unit * 3;
	  return {
	    root: {
	      flex: '1 1 auto',
	      overflowY: 'auto',
	      padding: '0 ' + spacing + 'px ' + spacing + 'px ' + spacing + 'px',
	      '&:first-child': {
	        paddingTop: spacing
	      }
	    }
	  };
	};
	
	function DialogContent(props) {
	  var classes = props.classes,
	      children = props.children,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'children', 'className']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    children
	  );
	}
	
	DialogContent.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogContent' })(DialogContent);

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: (0, _extends3.default)({}, theme.typography.subheading, {
	      color: theme.palette.text.secondary,
	      margin: 0
	    })
	  };
	};
	
	function DialogContentText(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);
	
	
	  return _react2.default.createElement(
	    'p',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    children
	  );
	}
	
	DialogContentText.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogContentText' })(DialogContentText);

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(204);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      margin: 0,
	      padding: theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 3 + 'px       20px ' + theme.spacing.unit * 3 + 'px',
	      flex: '0 0 auto'
	    }
	  };
	}; //  weak
	
	function DialogTitle(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      disableTypography = props.disableTypography,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableTypography']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    disableTypography ? children : _react2.default.createElement(
	      _Typography2.default,
	      { type: 'title' },
	      children
	    )
	  );
	}
	
	DialogTitle.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, that can be useful to can render an h4 instead of a
	   */
	  disableTypography: _propTypes2.default.bool
	} : {};
	
	DialogTitle.defaultProps = {
	  disableTypography: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogTitle' })(DialogTitle);

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dialog = __webpack_require__(107);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dialog).default;
	  }
	});
	
	var _DialogActions = __webpack_require__(190);
	
	Object.defineProperty(exports, 'DialogActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogActions).default;
	  }
	});
	
	var _DialogTitle = __webpack_require__(193);
	
	Object.defineProperty(exports, 'DialogTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogTitle).default;
	  }
	});
	
	var _DialogContent = __webpack_require__(191);
	
	Object.defineProperty(exports, 'DialogContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogContent).default;
	  }
	});
	
	var _DialogContentText = __webpack_require__(192);
	
	Object.defineProperty(exports, 'DialogContentText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogContentText).default;
	  }
	});
	
	var _withResponsiveFullScreen = __webpack_require__(195);
	
	Object.defineProperty(exports, 'withResponsiveFullScreen', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withResponsiveFullScreen).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createEagerFactory = __webpack_require__(45);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _wrapDisplayName = __webpack_require__(46);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _withWidth = __webpack_require__(76);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _Dialog = __webpack_require__(107);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Breakpoint = __webpack_require__(24).babelPluginFlowReactPropTypes_proptype_Breakpoint || __webpack_require__(1).any;
	
	/**
	 * Dialog will responsively be full screen *at or below* the given breakpoint
	 * (defaults to 'sm' for mobile devices).
	 * Notice that this Higher-order Component is incompatible with server side rendering.
	 */
	function withResponsiveFullScreen() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { breakpoint: 'sm' };
	  var breakpoint = options.breakpoint;
	
	
	  return function (BaseDialog) {
	    var factory = (0, _createEagerFactory2.default)(BaseDialog);
	
	    function ResponsiveFullScreen(props) {
	      return factory((0, _extends3.default)({
	        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
	      }, props));
	    }
	
	    if (false) {
	      ResponsiveFullScreen.displayName = (0, _wrapDisplayName2.default)(BaseDialog, 'withResponsiveFullScreen');
	    }
	
	    return (0, _withWidth2.default)()(ResponsiveFullScreen);
	  };
	}
	
	exports.default = withResponsiveFullScreen;

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _ref;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      userSelect: 'none'
	    },
	    colorAccent: {
	      color: theme.palette.secondary.A200
	    },
	    colorAction: {
	      color: theme.palette.action.active
	    },
	    colorContrast: {
	      color: theme.palette.getContrastText(theme.palette.primary[500])
	    },
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	    colorError: {
	      color: theme.palette.error[500]
	    },
	    colorPrimary: {
	      color: theme.palette.primary[500]
	    }
	  };
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node),
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  color: __webpack_require__(1).oneOf(['inherit', 'accent', 'action', 'contrast', 'disabled', 'error', 'primary'])
	};
	
	
	function Icon(props) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color']);
	
	
	  var className = (0, _classnames2.default)('material-icons', classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'inherit'), classNameProp);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ className: className, 'aria-hidden': 'true' }, other),
	    children
	  );
	}
	
	Icon.propTypes =  false ? (_ref = {
	  classes: require('prop-types').object.isRequired,
	  color: require('prop-types').oneOf(['inherit']).isRequired,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
	}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'color', require('prop-types').oneOf(['inherit', 'accent', 'action', 'contrast', 'disabled', 'error', 'primary'])), _ref) : {};
	Icon.defaultProps = {
	  color: 'inherit'
	};
	
	Icon.muiName = 'Icon';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIcon' })(Icon);

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Icon = __webpack_require__(653);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ref;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func;
	
	var styles = exports.styles = function styles(theme) {
	  var shadows = {};
	
	  theme.shadows.forEach(function (shadow, index) {
	    shadows['shadow' + index] = {
	      boxShadow: shadow
	    };
	  });
	
	  return (0, _extends3.default)({
	    root: {
	      backgroundColor: theme.palette.background.paper
	    },
	    rounded: {
	      borderRadius: 2
	    }
	  }, shadows);
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  component: __webpack_require__(1).oneOfType([__webpack_require__(1).string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_ComponentType)]),
	  elevation: __webpack_require__(1).number,
	  square: __webpack_require__(1).bool
	};
	
	
	function Paper(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      ComponentProp = props.component,
	      square = props.square,
	      elevation = props.elevation,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'square', 'elevation']);
	
	
	   false ? (0, _warning2.default)(elevation >= 0 && elevation < 25, 'Material-UI: this elevation `' + elevation + '` is not implemented.') : void 0;
	
	  var className = (0, _classnames2.default)(classes.root, classes['shadow' + (elevation >= 0 ? elevation : 0)], (0, _defineProperty3.default)({}, classes.rounded, !square), classNameProp);
	
	  return _react2.default.createElement(ComponentProp, (0, _extends3.default)({ className: className }, other));
	}
	
	Paper.propTypes =  false ? (_ref = {
	  classes: require('prop-types').object.isRequired,
	  component: require('prop-types').string.isRequired,
	  elevation: require('prop-types').number.isRequired,
	  square: require('prop-types').bool.isRequired
	}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'component', require('prop-types').oneOfType([require('prop-types').string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ComponentType)])), (0, _defineProperty3.default)(_ref, 'elevation', require('prop-types').number), (0, _defineProperty3.default)(_ref, 'square', require('prop-types').bool), _ref) : {};
	Paper.defaultProps = {
	  component: 'div',
	  elevation: 2,
	  square: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPaper' })(Paper);

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Paper = __webpack_require__(201);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Paper).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _ref;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'block',
	      margin: 0
	    },
	    display4: theme.typography.display4,
	    display3: theme.typography.display3,
	    display2: theme.typography.display2,
	    display1: theme.typography.display1,
	    headline: theme.typography.headline,
	    title: theme.typography.title,
	    subheading: theme.typography.subheading,
	    body2: theme.typography.body2,
	    body1: theme.typography.body1,
	    caption: theme.typography.caption,
	    button: theme.typography.button,
	    alignLeft: {
	      textAlign: 'left'
	    },
	    alignCenter: {
	      textAlign: 'center'
	    },
	    alignRight: {
	      textAlign: 'right'
	    },
	    alignJustify: {
	      textAlign: 'justify'
	    },
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	    paragraph: {
	      marginBottom: theme.spacing.unit * 2
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    colorSecondary: {
	      color: theme.palette.text.secondary
	    },
	    colorAccent: {
	      color: theme.palette.secondary.A400
	    }
	  };
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  align: __webpack_require__(1).oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node),
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  component: __webpack_require__(1).oneOfType([__webpack_require__(1).string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_ComponentType)]),
	  color: __webpack_require__(1).oneOf(['inherit', 'secondary', 'accent', 'default']),
	  gutterBottom: __webpack_require__(1).bool,
	  headlineMapping: __webpack_require__(1).shape({}),
	  noWrap: __webpack_require__(1).bool,
	  paragraph: __webpack_require__(1).bool,
	  type: __webpack_require__(1).oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
	};
	
	
	function Typography(props) {
	  var _classNames;
	
	  var align = props.align,
	      classes = props.classes,
	      classNameProp = props.className,
	      componentProp = props.component,
	      color = props.color,
	      gutterBottom = props.gutterBottom,
	      headlineMapping = props.headlineMapping,
	      noWrap = props.noWrap,
	      paragraph = props.paragraph,
	      type = props.type,
	      other = (0, _objectWithoutProperties3.default)(props, ['align', 'classes', 'className', 'component', 'color', 'gutterBottom', 'headlineMapping', 'noWrap', 'paragraph', 'type']);
	
	
	  var className = (0, _classnames2.default)(classes.root, classes[type], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty3.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty3.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty3.default)(_classNames, classes['align' + (0, _helpers.capitalizeFirstLetter)(align)], align !== 'inherit'), _classNames), classNameProp);
	
	  var Component = componentProp || (paragraph ? 'p' : headlineMapping[type]) || 'span';
	
	  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
	}
	
	Typography.propTypes =  false ? (_ref = {
	  classes: require('prop-types').object.isRequired,
	  headlineMapping: require('prop-types').shape({}).isRequired,
	  type: require('prop-types').oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button']).isRequired,
	  align: require('prop-types').oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
	}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'component', require('prop-types').oneOfType([require('prop-types').string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ComponentType)])), (0, _defineProperty3.default)(_ref, 'color', require('prop-types').oneOf(['inherit', 'secondary', 'accent', 'default'])), (0, _defineProperty3.default)(_ref, 'gutterBottom', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'headlineMapping', require('prop-types').shape({})), (0, _defineProperty3.default)(_ref, 'noWrap', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'paragraph', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'type', require('prop-types').oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])), _ref) : {};
	Typography.defaultProps = {
	  align: 'inherit',
	  color: 'default',
	  gutterBottom: false,
	  headlineMapping: {
	    display4: 'h1',
	    display3: 'h1',
	    display2: 'h1',
	    display1: 'h1',
	    headline: 'h1',
	    title: 'h2',
	    subheading: 'h3',
	    body2: 'aside',
	    body1: 'p'
	  },
	  noWrap: false,
	  paragraph: false,
	  type: 'body1'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTypography' })(Typography);

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Typography = __webpack_require__(203);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Typography).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _ref;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      zIndex: -1,
	      width: '100%',
	      height: '100%',
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      // Remove grey highlight
	      WebkitTapHighlightColor: theme.palette.common.transparent,
	      backgroundColor: theme.palette.common.lightBlack,
	      transition: theme.transitions.create('opacity'),
	      willChange: 'opacity',
	      opacity: 0
	    },
	    invisible: {
	      backgroundColor: theme.palette.common.transparent
	    }
	  };
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node),
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  invisible: __webpack_require__(1).bool
	};
	
	
	/**
	 * @ignore - internal component.
	 */
	function Backdrop(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      invisible = props.invisible,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'invisible']);
	
	
	  var backdropClass = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.invisible, invisible), className);
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: backdropClass, 'aria-hidden': 'true' }, other),
	    children
	  );
	}
	
	Backdrop.propTypes =  false ? (_ref = {
	  classes: require('prop-types').object.isRequired,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
	}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'invisible', require('prop-types').bool), _ref) : {};
	Backdrop.defaultProps = {
	  invisible: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBackdrop' })(Backdrop);

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ref2, _ref3;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _keycode = __webpack_require__(43);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _contains = __webpack_require__(92);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _activeElement = __webpack_require__(275);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _ownerDocument = __webpack_require__(91);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _addEventListener = __webpack_require__(63);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _helpers = __webpack_require__(39);
	
	var _Fade = __webpack_require__(110);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _modalManager = __webpack_require__(209);
	
	var _modalManager2 = _interopRequireDefault(_modalManager);
	
	var _Backdrop = __webpack_require__(205);
	
	var _Backdrop2 = _interopRequireDefault(_Backdrop);
	
	var _Portal = __webpack_require__(207);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__(1).any;
	
	/**
	 * Modals don't open on the server so this won't break concurrency.
	 * Could also put this on context.
	 */
	var babelPluginFlowReactPropTypes_proptype_TransitionCallback = __webpack_require__(50).babelPluginFlowReactPropTypes_proptype_TransitionCallback || __webpack_require__(1).any;
	
	var modalManager = (0, _modalManager2.default)();
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      width: '100%',
	      height: '100%',
	      position: 'fixed',
	      zIndex: theme.zIndex.dialog,
	      top: 0,
	      left: 0
	    },
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  backdropClassName: __webpack_require__(1).string,
	  backdropComponent: __webpack_require__(1).func,
	  backdropInvisible: __webpack_require__(1).bool,
	  backdropTransitionDuration: __webpack_require__(1).number,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Element),
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  keepMounted: __webpack_require__(1).bool,
	  disableBackdrop: __webpack_require__(1).bool,
	  ignoreBackdropClick: __webpack_require__(1).bool,
	  ignoreEscapeKeyUp: __webpack_require__(1).bool,
	  modalManager: __webpack_require__(1).object,
	  onBackdropClick: __webpack_require__(1).func,
	  onEnter: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onEntering: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onEntered: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onEscapeKeyUp: __webpack_require__(1).func,
	  onExit: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onExiting: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onExited: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onRequestClose: __webpack_require__(1).func,
	  show: __webpack_require__(1).bool
	};
	
	/**
	 * @ignore - internal component.
	 */
	var Modal = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.show) {
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      if (this.props.show === true) {
	        this.handleShow();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.show && this.state.exited) {
	        this.setState({ exited: false });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (!this.props.show && nextProps.show) {
	        this.checkForFocus();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.show && this.props.show) {
	        this.handleShow();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.show || !this.state.exited) {
	        this.handleHide();
	      }
	      this.mounted = false;
	    }
	  }, {
	    key: 'checkForFocus',
	    value: function checkForFocus() {
	      if (_inDOM2.default) {
	        this.lastFocus = (0, _activeElement2.default)();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(this)));
	      var modalContent = this.modal && this.modal.lastChild;
	      var focusInModal = currentFocus && (0, _contains2.default)(modalContent, currentFocus);
	
	      if (modalContent && !focusInModal) {
	        this.lastFocus = currentFocus;
	
	        if (!modalContent.hasAttribute('tabIndex')) {
	          modalContent.setAttribute('tabIndex', -1);
	           false ? (0, _warning2.default)(false, 'Material-UI: the modal content node does not accept focus. ' + 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".') : void 0;
	        }
	
	        modalContent.focus();
	      }
	    }
	  }, {
	    key: 'restoreLastFocus',
	    value: function restoreLastFocus() {
	      if (this.lastFocus && this.lastFocus.focus) {
	        this.lastFocus.focus();
	        this.lastFocus = undefined;
	      }
	    }
	  }, {
	    key: 'handleShow',
	    value: function handleShow() {
	      var doc = (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(this));
	      this.props.modalManager.add(this);
	      this.onDocumentKeyUpListener = (0, _addEventListener2.default)(doc, 'keyup', this.handleDocumentKeyUp);
	      this.onFocusListener = (0, _addEventListener2.default)(doc, 'focus', this.handleFocusListener, true);
	      this.focus();
	    }
	  }, {
	    key: 'handleHide',
	    value: function handleHide() {
	      this.props.modalManager.remove(this);
	      if (this.onDocumentKeyUpListener) this.onDocumentKeyUpListener.remove();
	      if (this.onFocusListener) this.onFocusListener.remove();
	      this.restoreLastFocus();
	    }
	  }, {
	    key: 'renderBackdrop',
	    value: function renderBackdrop() {
	      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _props = this.props,
	          BackdropComponent = _props.backdropComponent,
	          backdropClassName = _props.backdropClassName,
	          backdropTransitionDuration = _props.backdropTransitionDuration,
	          backdropInvisible = _props.backdropInvisible,
	          show = _props.show;
	
	
	      return _react2.default.createElement(
	        _Fade2.default,
	        (0, _extends3.default)({
	          'in': show,
	          transitionAppear: true,
	          enterTransitionDuration: backdropTransitionDuration,
	          leaveTransitionDuration: backdropTransitionDuration,
	          timeout: backdropTransitionDuration + 20
	        }, other),
	        _react2.default.createElement(BackdropComponent, {
	          invisible: backdropInvisible,
	          className: backdropClassName,
	          onClick: this.handleBackdropClick
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          disableBackdrop = _props2.disableBackdrop,
	          backdropComponent = _props2.backdropComponent,
	          backdropClassName = _props2.backdropClassName,
	          backdropTransitionDuration = _props2.backdropTransitionDuration,
	          backdropInvisible = _props2.backdropInvisible,
	          ignoreBackdropClick = _props2.ignoreBackdropClick,
	          ignoreEscapeKeyUp = _props2.ignoreEscapeKeyUp,
	          children = _props2.children,
	          classes = _props2.classes,
	          className = _props2.className,
	          keepMounted = _props2.keepMounted,
	          modalManagerProp = _props2.modalManager,
	          onBackdropClick = _props2.onBackdropClick,
	          onEscapeKeyUp = _props2.onEscapeKeyUp,
	          onRequestClose = _props2.onRequestClose,
	          onEnter = _props2.onEnter,
	          onEntering = _props2.onEntering,
	          onEntered = _props2.onEntered,
	          onExit = _props2.onExit,
	          onExiting = _props2.onExiting,
	          onExited = _props2.onExited,
	          show = _props2.show,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['disableBackdrop', 'backdropComponent', 'backdropClassName', 'backdropTransitionDuration', 'backdropInvisible', 'ignoreBackdropClick', 'ignoreEscapeKeyUp', 'children', 'classes', 'className', 'keepMounted', 'modalManager', 'onBackdropClick', 'onEscapeKeyUp', 'onRequestClose', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'show']);
	
	
	      if (!keepMounted && !show && this.state.exited) {
	        return null;
	      }
	
	      var transitionCallbacks = {
	        onEnter: onEnter,
	        onEntering: onEntering,
	        onEntered: onEntered,
	        onExit: onExit,
	        onExiting: onExiting,
	        onExited: this.handleTransitionExited
	      };
	
	      var modalChild = _react2.default.Children.only(children);
	      var _modalChild$props = modalChild.props,
	          role = _modalChild$props.role,
	          tabIndex = _modalChild$props.tabIndex;
	
	      var childProps = {};
	
	      if (role === undefined) {
	        childProps.role = role === undefined ? 'document' : role;
	      }
	
	      if (tabIndex === undefined) {
	        childProps.tabIndex = tabIndex == null ? -1 : tabIndex;
	      }
	
	      var backdropProps = void 0;
	
	      // It's a Transition like component
	      if (modalChild.props.hasOwnProperty('in')) {
	        (0, _keys2.default)(transitionCallbacks).forEach(function (key) {
	          childProps[key] = (0, _helpers.createChainedFunction)(transitionCallbacks[key], modalChild.props[key]);
	        });
	      } else {
	        backdropProps = transitionCallbacks;
	      }
	
	      if ((0, _keys2.default)(childProps).length) {
	        modalChild = _react2.default.cloneElement(modalChild, childProps);
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        {
	          open: true,
	          ref: function ref(node) {
	            _this2.mountNode = node ? node.getLayer() : null;
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({
	            className: (0, _classnames2.default)(classes.root, className, (0, _defineProperty3.default)({}, classes.hidden, this.state.exited)),
	            ref: function ref(node) {
	              _this2.modal = node;
	            }
	          }, other),
	          !disableBackdrop && (!keepMounted || show || !this.state.exited) && this.renderBackdrop(backdropProps),
	          modalChild
	        )
	      );
	    }
	  }]);
	  return Modal;
	}(_react2.default.Component);
	
	Modal.defaultProps = {
	  backdropComponent: _Backdrop2.default,
	  backdropTransitionDuration: 300,
	  backdropInvisible: false,
	  keepMounted: false,
	  disableBackdrop: false,
	  ignoreBackdropClick: false,
	  ignoreEscapeKeyUp: false,
	  modalManager: modalManager,
	  show: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.state = {
	    exited: false
	  };
	  this.mounted = false;
	  this.lastFocus = undefined;
	  this.modal = null;
	  this.mountNode = null;
	  this.onDocumentKeyUpListener = null;
	  this.onFocusListener = null;
	
	  this.handleFocusListener = function () {
	    if (!_this3.mounted || !_this3.props.modalManager.isTopModal(_this3)) {
	      return;
	    }
	
	    var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(_this3)));
	    var modalContent = _this3.modal && _this3.modal.lastChild;
	
	    if (modalContent && modalContent !== currentFocus && !(0, _contains2.default)(modalContent, currentFocus)) {
	      modalContent.focus();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (event) {
	    if (!_this3.mounted || !_this3.props.modalManager.isTopModal(_this3)) {
	      return;
	    }
	
	    if ((0, _keycode2.default)(event) === 'esc') {
	      var _props3 = _this3.props,
	          _onEscapeKeyUp = _props3.onEscapeKeyUp,
	          _onRequestClose = _props3.onRequestClose,
	          _ignoreEscapeKeyUp = _props3.ignoreEscapeKeyUp;
	
	
	      if (_onEscapeKeyUp) {
	        _onEscapeKeyUp(event);
	      }
	
	      if (_onRequestClose && !_ignoreEscapeKeyUp) {
	        _onRequestClose(event);
	      }
	    }
	  };
	
	  this.handleBackdropClick = function (event) {
	    if (event.target !== event.currentTarget) {
	      return;
	    }
	
	    var _props4 = _this3.props,
	        onBackdropClick = _props4.onBackdropClick,
	        onRequestClose = _props4.onRequestClose,
	        ignoreBackdropClick = _props4.ignoreBackdropClick;
	
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (onRequestClose && !ignoreBackdropClick) {
	      onRequestClose(event);
	    }
	  };
	
	  this.handleTransitionExited = function () {
	    if (_this3.props.onExited) {
	      var _props5;
	
	      (_props5 = _this3.props).onExited.apply(_props5, arguments);
	    }
	
	    _this3.setState({ exited: true });
	    _this3.handleHide();
	  };
	};
	
	Modal.propTypes =  false ? (_ref2 = {
	  backdropComponent: require('prop-types').func.isRequired,
	  classes: require('prop-types').object.isRequired,
	  modalManager: require('prop-types').object.isRequired,
	  backdropClassName: require('prop-types').string
	}, (0, _defineProperty3.default)(_ref2, 'backdropComponent', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'backdropInvisible', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'backdropTransitionDuration', require('prop-types').number), (0, _defineProperty3.default)(_ref2, 'children', typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element)), (0, _defineProperty3.default)(_ref2, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref2, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref2, 'keepMounted', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'disableBackdrop', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'ignoreBackdropClick', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'ignoreEscapeKeyUp', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'modalManager', require('prop-types').object), (0, _defineProperty3.default)(_ref2, 'onBackdropClick', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onEnter', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onEntering', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onEntered', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onEscapeKeyUp', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onExit', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onExiting', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onExited', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onRequestClose', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'show', require('prop-types').bool), _ref2) : {};
	Modal.propTypes =  false ? (_ref3 = {
	  backdropComponent: require('prop-types').func.isRequired,
	  classes: require('prop-types').object.isRequired,
	  modalManager: require('prop-types').object.isRequired,
	  backdropClassName: require('prop-types').string
	}, (0, _defineProperty3.default)(_ref3, 'backdropComponent', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'backdropInvisible', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'backdropTransitionDuration', require('prop-types').number), (0, _defineProperty3.default)(_ref3, 'children', typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element)), (0, _defineProperty3.default)(_ref3, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref3, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref3, 'keepMounted', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'disableBackdrop', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'ignoreBackdropClick', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'ignoreEscapeKeyUp', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'modalManager', require('prop-types').object), (0, _defineProperty3.default)(_ref3, 'onBackdropClick', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onEnter', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onEntering', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onEntered', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onEscapeKeyUp', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onExit', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onExiting', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onExited', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onRequestClose', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'show', require('prop-types').bool), _ref3) : {};
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiModal' })(Modal);

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node),
	  open: __webpack_require__(1).bool
	};
	
	/**
	 * @ignore - internal component.
	 */
	var Portal = function (_React$Component) {
	  (0, _inherits3.default)(Portal, _React$Component);
	
	  function Portal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Portal.__proto__ || (0, _getPrototypeOf2.default)(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.layer = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Support react@15.x, will be removed at some point
	      if (!_reactDom2.default.unstable_createPortal) {
	        this.renderLayer();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // Support react@15.x, will be removed at some point
	      if (!_reactDom2.default.unstable_createPortal) {
	        this.renderLayer();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      if (!this.layer) {
	        this.layer = document.createElement('div');
	        this.layer.setAttribute('data-mui-portal', 'true');
	        if (document.body && this.layer) {
	          document.body.appendChild(this.layer);
	        }
	      }
	
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      // Support react@15.x, will be removed at some point
	      if (!_reactDom2.default.unstable_createPortal) {
	        _reactDom2.default.unmountComponentAtNode(this.layer);
	      }
	
	      if (document.body) {
	        document.body.removeChild(this.layer);
	      }
	      this.layer = null;
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _props = this.props,
	          children = _props.children,
	          open = _props.open;
	
	
	      if (open) {
	        // By calling this method in componentDidMount() and
	        // componentDidUpdate(), you're effectively creating a "wormhole" that
	        // funnels React's hierarchical updates through to a DOM node on an
	        // entirely different part of the page.
	        var layerElement = _react2.default.Children.only(children);
	        // $FlowFixMe
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, layerElement, this.getLayer());
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          open = _props2.open;
	
	      // Support react@15.x, will be removed at some point
	
	      if (!_reactDom2.default.unstable_createPortal) {
	        return null;
	      }
	
	      // Can't be rendered server-side.
	      if (_inDOM2.default) {
	        if (open) {
	          return _reactDom2.default.unstable_createPortal(children, this.getLayer());
	        }
	
	        this.unrenderLayer();
	      }
	
	      return null;
	    }
	  }]);
	  return Portal;
	}(_react2.default.Component);
	
	Portal.defaultProps = {
	  open: false
	};
	Portal.propTypes =  false ? {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node),
	  open: require('prop-types').bool
	} : {};
	exports.default = Portal;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _properties = __webpack_require__(276);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _on = __webpack_require__(67);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_SyntheticUIEventHandler = __webpack_require__(208).babelPluginFlowReactPropTypes_proptype_SyntheticUIEventHandler || __webpack_require__(1).any;
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * A helper function that calls back when any pending animations have started This is needed as the
	 * callback hooks might be setting some style properties that needs a frame to take effect.
	 */
	function requestAnimationStart(callback) {
	  // Feature detect rAF, fallback to setTimeout
	  if (window.requestAnimationFrame) {
	    // Chrome and Safari have a bug where calling rAF once returns the current
	    // frame instead of the next frame, so we need to call a double rAF here.
	    // See https://crbug.com/675795 for more.
	    window.requestAnimationFrame(function () {
	      window.requestAnimationFrame(callback);
	    });
	  } else {
	    setTimeout(callback, 0);
	  }
	}
	
	var babelPluginFlowReactPropTypes_proptype_TransitionCallback = __webpack_require__(1).func;
	
	var babelPluginFlowReactPropTypes_proptype_TransitionRequestTimeout = __webpack_require__(1).func;
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Element),
	  className: __webpack_require__(1).string,
	  enteredClassName: __webpack_require__(1).string,
	  enteringClassName: __webpack_require__(1).string,
	  exitedClassName: __webpack_require__(1).string,
	  exitingClassName: __webpack_require__(1).string,
	  in: __webpack_require__(1).bool,
	  onEnter: __webpack_require__(1).func,
	  onEntering: __webpack_require__(1).func,
	  onEntered: __webpack_require__(1).func,
	  onExit: __webpack_require__(1).func,
	  onExiting: __webpack_require__(1).func,
	  onExited: __webpack_require__(1).func,
	  onRequestTimeout: __webpack_require__(1).func,
	  timeout: __webpack_require__(1).number,
	  transitionAppear: __webpack_require__(1).bool,
	  unmountOnExit: __webpack_require__(1).bool
	};
	
	/**
	 * @ignore - internal component.
	 *
	 * Drawn from https://raw.githubusercontent.com/react-bootstrap/react-overlays/master/src/Transition.js
	 *
	 * The Transition component lets you define and run CSS transitions with a simple declarative api.
	 * It works similarly to React's own CSSTransitionGroup
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based CSS transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecyle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	var Transition = function (_React$Component) {
	  (0, _inherits3.default)(Transition, _React$Component);
	
	  function Transition() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Transition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Transition.__proto__ || (0, _getPrototypeOf2.default)(Transition)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      status: UNMOUNTED
	    }, _this.nextCallback = null, _this.needsUpdate = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Transition, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var status = void 0;
	
	      if (this.props.in) {
	        // Start enter transition in componentDidMount.
	        status = this.props.transitionAppear ? EXITED : ENTERED;
	      } else {
	        status = this.props.unmountOnExit ? UNMOUNTED : EXITED;
	      }
	
	      this.setState({ status: status });
	      this.nextCallback = null;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.transitionAppear && this.props.in) {
	        this.performEnter(this.props);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.in && this.props.unmountOnExit) {
	        if (this.state.status === UNMOUNTED) {
	          // Start enter transition in componentDidUpdate.
	          this.setState({ status: EXITED });
	        }
	      } else {
	        this.needsUpdate = true;
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (this.props.in && this.state.status === EXITED && this.state.status === nextState.status) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var status = this.state.status;
	
	      if (this.props.unmountOnExit && status === EXITED) {
	        // EXITED is always a transitional state to either ENTERING or UNMOUNTED
	        // when using unmountOnExit.
	        if (this.props.in) {
	          this.performEnter(this.props);
	        } else {
	          this.setState({ status: UNMOUNTED }); // eslint-disable-line react/no-did-update-set-state
	        }
	
	        return;
	      }
	
	      // guard ensures we are only responding to prop changes
	      if (this.needsUpdate) {
	        this.needsUpdate = false;
	
	        if (this.props.in) {
	          if (status === EXITING) {
	            this.performEnter(this.props);
	          } else if (status === EXITED) {
	            this.performEnter(this.props);
	          }
	          // Otherwise we're already entering or entered.
	        } else if (status === ENTERING || status === ENTERED) {
	          this.performExit(this.props);
	        }
	        // Otherwise we're already exited or exiting.
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelNextCallback();
	    }
	  }, {
	    key: 'performEnter',
	    value: function performEnter(props) {
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	      if (node instanceof HTMLElement) {
	        if (props.onEnter) {
	          props.onEnter(node);
	        }
	        this.performEntering(node);
	      }
	    }
	  }, {
	    key: 'performEntering',
	    value: function performEntering(element) {
	      var _this2 = this;
	
	      this.safeSetState({ status: ENTERING }, function () {
	        if (_this2.props.onEntering) {
	          _this2.props.onEntering(element);
	        }
	
	        _this2.onTransitionEnd(element, function () {
	          _this2.safeSetState({ status: ENTERED }, function () {
	            if (_this2.props.onEntered) {
	              _this2.props.onEntered(element);
	            }
	          });
	        });
	      });
	    }
	  }, {
	    key: 'performExit',
	    value: function performExit(props) {
	      var _this3 = this;
	
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	      if (node instanceof HTMLElement) {
	        // Not this.props, because we might be about to receive new props.
	        if (props.onExit) {
	          props.onExit(node);
	        }
	
	        this.safeSetState({ status: EXITING }, function () {
	          if (_this3.props.onExiting) {
	            _this3.props.onExiting(node);
	          }
	
	          _this3.onTransitionEnd(node, function () {
	            _this3.safeSetState({ status: EXITED }, function () {
	              if (_this3.props.onExited) {
	                _this3.props.onExited(node);
	              }
	            });
	          });
	        });
	      }
	    }
	  }, {
	    key: 'cancelNextCallback',
	    value: function cancelNextCallback() {
	      if (this.nextCallback !== null) {
	        this.nextCallback.cancel();
	        this.nextCallback = null;
	      }
	    }
	  }, {
	    key: 'safeSetState',
	    value: function safeSetState(nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      this.setState(nextState, this.setNextCallback(callback));
	    }
	  }, {
	    key: 'setNextCallback',
	    value: function setNextCallback(callback) {
	      var _this4 = this;
	
	      var active = true;
	
	      // FIXME: These next two blocks are a real enigma for flow typing outside of weak mode.
	      // FIXME: I suggest we refactor - rosskevin
	      this.nextCallback = function (event) {
	        requestAnimationStart(function () {
	          if (active) {
	            active = false;
	            _this4.nextCallback = null;
	
	            callback(event);
	          }
	        });
	      };
	
	      this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return this.nextCallback;
	    }
	  }, {
	    key: 'onTransitionEnd',
	    value: function onTransitionEnd(element, handler) {
	      var _this5 = this;
	
	      this.setNextCallback(handler);
	
	      if (element) {
	        (0, _on2.default)(element, transitionEndEvent, function (event) {
	          if (event.target === element && _this5.nextCallback) {
	            _this5.nextCallback();
	          }
	        });
	        setTimeout(this.nextCallback, this.getTimeout(element));
	      } else {
	        setTimeout(this.nextCallback, 0);
	      }
	    }
	  }, {
	    key: 'getTimeout',
	    value: function getTimeout(element) {
	      var timeout = void 0;
	
	      if (this.props.onRequestTimeout && element instanceof HTMLElement) {
	        timeout = this.props.onRequestTimeout(element);
	      }
	
	      if (typeof timeout !== 'number') {
	        timeout = this.props.timeout;
	      }
	
	      return timeout;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var status = this.state.status;
	
	      if (status === UNMOUNTED) {
	        return null;
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          inProp = _props.in,
	          enteredClassName = _props.enteredClassName,
	          enteringClassName = _props.enteringClassName,
	          exitedClassName = _props.exitedClassName,
	          exitingClassName = _props.exitingClassName,
	          onEnter = _props.onEnter,
	          onEntering = _props.onEntering,
	          onEntered = _props.onEntered,
	          onExit = _props.onExit,
	          onExiting = _props.onExiting,
	          onExited = _props.onExited,
	          onRequestTimeout = _props.onRequestTimeout,
	          timeout = _props.timeout,
	          transitionAppear = _props.transitionAppear,
	          unmountOnExit = _props.unmountOnExit,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'in', 'enteredClassName', 'enteringClassName', 'exitedClassName', 'exitingClassName', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'onRequestTimeout', 'timeout', 'transitionAppear', 'unmountOnExit']);
	
	
	      var transitionClassName = void 0;
	      if (status === EXITED) {
	        transitionClassName = this.props.exitedClassName;
	      } else if (status === ENTERING) {
	        transitionClassName = this.props.enteringClassName;
	      } else if (status === ENTERED) {
	        transitionClassName = this.props.enteredClassName;
	      } else if (status === EXITING) {
	        transitionClassName = this.props.exitingClassName;
	      }
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, (0, _extends3.default)({
	        className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	      }, other));
	    }
	  }]);
	  return Transition;
	}(_react2.default.Component);
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	  timeout: 5000
	};
	Transition.propTypes =  false ? {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element),
	  className: require('prop-types').string,
	  enteredClassName: require('prop-types').string,
	  enteringClassName: require('prop-types').string,
	  exitedClassName: require('prop-types').string,
	  exitingClassName: require('prop-types').string,
	  in: require('prop-types').bool,
	  onEnter: require('prop-types').func,
	  onEntering: require('prop-types').func,
	  onEntered: require('prop-types').func,
	  onExit: require('prop-types').func,
	  onExiting: require('prop-types').func,
	  onExited: require('prop-types').func,
	  onRequestTimeout: require('prop-types').func,
	  timeout: require('prop-types').number,
	  transitionAppear: require('prop-types').bool,
	  unmountOnExit: require('prop-types').bool
	} : {};
	Transition.propTypes =  false ? {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element),
	  className: require('prop-types').string,
	  enteredClassName: require('prop-types').string,
	  enteringClassName: require('prop-types').string,
	  exitedClassName: require('prop-types').string,
	  exitingClassName: require('prop-types').string,
	  in: require('prop-types').bool,
	  onEnter: require('prop-types').func,
	  onEntering: require('prop-types').func,
	  onEntered: require('prop-types').func,
	  onExit: require('prop-types').func,
	  onExiting: require('prop-types').func,
	  onExited: require('prop-types').func,
	  onRequestTimeout: require('prop-types').func,
	  timeout: require('prop-types').number,
	  transitionAppear: require('prop-types').bool,
	  unmountOnExit: require('prop-types').bool
	} : {};
	exports.default = Transition;

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var babelPluginFlowReactPropTypes_proptype_SyntheticUIEventHandler = __webpack_require__(1).func;
	
	var babelPluginFlowReactPropTypes_proptype_DOMNode = __webpack_require__(1).oneOfType([__webpack_require__(1).any, __webpack_require__(1).any]);
	
	/**
	 * return type of ReactDOM.findDOMNode()
	 *
	 * NOTE: `Element` is NOT the same as `type { Element } from 'react'` a.k.a React$Element
	 *
	 * To use it as a typical node, check with `if (node instanceof HTMLElement) { ... }`
	 */
	// Actual flow type:
	// export type DOMNode = Element | Text | null;
	
	// Workaround type (results in `any`) due to https://github.com/brigand/babel-plugin-flow-react-proptypes/issues/115

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isWindow = __webpack_require__(140);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(91);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(277);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _manageAriaHidden = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Taken from https://github.com/react-bootstrap/react-overlays/blob/master/src/ModalManager.js
	
	function getPaddingRight(node) {
	  return parseInt(node.style.paddingRight || 0, 10);
	}
	
	// Do we have a scroll bar?
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	
	  // Takes in account potential non zero margin on the body.
	  var style = window.getComputedStyle(doc.body);
	  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
	  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
	
	  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
	}
	
	// The container shouldn't be used on the server.
	var defaultContainer = _inDOM2.default ? window.document.body : {};
	
	/**
	 * State management helper for modals/layers.
	 * Simplified, but inspired by react-overlay's ModalManager class
	 *
	 * @internal Used by the Modal to ensure proper focus management.
	 */
	function createModalManager() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$container = _ref.container,
	      container = _ref$container === undefined ? defaultContainer : _ref$container,
	      _ref$hideSiblingNodes = _ref.hideSiblingNodes,
	      hideSiblingNodes = _ref$hideSiblingNodes === undefined ? true : _ref$hideSiblingNodes;
	
	   false ? (0, _warning2.default)(container !== null, '\n    Material-UI: you are most likely evaluating the code before the\n    browser has a chance to reach the <body>.\n    Please move the import at the end of the <body>.\n  ') : void 0;
	
	  var modals = [];
	
	  var prevOverflow = void 0;
	  var prevPaddings = [];
	
	  function add(modal) {
	    var modalIdx = modals.indexOf(modal);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = modals.length;
	    modals.push(modal);
	
	    if (hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (modals.length === 1) {
	      // Save our current overflow so we can revert
	      // back to it when all modals are closed!
	      prevOverflow = container.style.overflow;
	
	      if (bodyIsOverflowing(container)) {
	        prevPaddings = [getPaddingRight(container)];
	        var scrollbarSize = (0, _scrollbarSize2.default)();
	        container.style.paddingRight = prevPaddings[0] + scrollbarSize + 'px';
	
	        var fixedNodes = document.querySelectorAll('.mui-fixed');
	        for (var i = 0; i < fixedNodes.length; i += 1) {
	          var paddingRight = getPaddingRight(fixedNodes[i]);
	          prevPaddings.push(paddingRight);
	          fixedNodes[i].style.paddingRight = paddingRight + scrollbarSize + 'px';
	        }
	      }
	
	      container.style.overflow = 'hidden';
	    }
	
	    return modalIdx;
	  }
	
	  function remove(modal) {
	    var modalIdx = modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return modalIdx;
	    }
	
	    modals.splice(modalIdx, 1);
	
	    if (modals.length === 0) {
	      container.style.overflow = prevOverflow;
	      container.style.paddingRight = prevPaddings[0];
	
	      var fixedNodes = document.querySelectorAll('.mui-fixed');
	      for (var i = 0; i < fixedNodes.length; i += 1) {
	        fixedNodes[i].style.paddingRight = prevPaddings[i + 1] + 'px';
	      }
	
	      prevOverflow = undefined;
	      prevPaddings = [];
	      if (hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	    } else if (hideSiblingNodes) {
	      // otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, modals[modals.length - 1].mountNode);
	    }
	
	    return modalIdx;
	  }
	
	  function isTopModal(modal) {
	    return !!modals.length && modals[modals.length - 1] === modal;
	  }
	
	  var modalManager = { add: add, remove: remove, isTopModal: isTopModal };
	
	  return modalManager;
	}
	
	exports.default = createModalManager;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withTheme;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createEagerFactory = __webpack_require__(45);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _wrapDisplayName = __webpack_require__(46);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createMuiTheme = __webpack_require__(74);
	
	var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);
	
	var _themeListener = __webpack_require__(75);
	
	var _themeListener2 = _interopRequireDefault(_themeListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func; //  weak
	
	var defaultTheme = void 0;
	
	function getDefaultTheme() {
	  if (defaultTheme) {
	    return defaultTheme;
	  }
	
	  defaultTheme = (0, _createMuiTheme2.default)();
	  return defaultTheme;
	}
	
	// Provide the theme object as a property to the input component.
	function withTheme(BaseComponent) {
	  var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	  var WithTheme = function (_React$Component) {
	    (0, _inherits3.default)(WithTheme, _React$Component);
	
	    function WithTheme(props, context) {
	      (0, _classCallCheck3.default)(this, WithTheme);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (WithTheme.__proto__ || (0, _getPrototypeOf2.default)(WithTheme)).call(this, props, context));
	
	      _this.state = {};
	      _this.unsubscribeId = null;
	
	      _this.state = {
	        // We use || as it's lazy evaluated.
	        theme: _themeListener2.default.initial(context) || getDefaultTheme()
	      };
	      return _this;
	    }
	
	    // Exposed for test purposes.
	
	
	    (0, _createClass3.default)(WithTheme, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
	          _this2.setState({ theme: theme });
	        });
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.unsubscribeId !== null) {
	          _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return factory((0, _extends3.default)({ theme: this.state.theme }, this.props));
	      }
	    }]);
	    return WithTheme;
	  }(_react2.default.Component);
	
	  WithTheme.displayName = (0, _wrapDisplayName2.default)(BaseComponent, 'withTheme');
	  WithTheme.Naked = BaseComponent;
	
	
	  WithTheme.contextTypes = _themeListener2.default.contextTypes;
	
	  return WithTheme;
	}

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ref2, _ref3; //  weak
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(50);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _transitions = __webpack_require__(109);
	
	var _withTheme = __webpack_require__(51);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_TransitionCallback = __webpack_require__(50).babelPluginFlowReactPropTypes_proptype_TransitionCallback || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Element),
	  in: __webpack_require__(1).bool,
	  enterTransitionDuration: __webpack_require__(1).number,
	  leaveTransitionDuration: __webpack_require__(1).number,
	  onEnter: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onEntering: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onEntered: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onExit: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onExiting: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  onExited: typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback),
	  theme: __webpack_require__(1).object
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3.default)(Fade, _React$Component);
	
	  function Fade() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Fade);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Fade.__proto__ || (0, _getPrototypeOf2.default)(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = function (element) {
	      element.style.opacity = 0;
	      if (_this.props.onEnter) {
	        _this.props.onEnter(element);
	      }
	    }, _this.handleEntering = function (element) {
	      var transitions = _this.props.theme.transitions;
	
	      element.style.transition = transitions.create('opacity', {
	        duration: _this.props.enterTransitionDuration
	      });
	      element.style.WebkitTransition = transitions.create('opacity', {
	        duration: _this.props.enterTransitionDuration
	      });
	      element.style.opacity = 1;
	      if (_this.props.onEntering) {
	        _this.props.onEntering(element);
	      }
	    }, _this.handleExit = function (element) {
	      var transitions = _this.props.theme.transitions;
	
	      element.style.transition = transitions.create('opacity', {
	        duration: _this.props.leaveTransitionDuration
	      });
	      element.style.WebkitTransition = transitions.create('opacity', {
	        duration: _this.props.leaveTransitionDuration
	      });
	      element.style.opacity = 0;
	      if (_this.props.onExit) {
	        _this.props.onExit(element);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Fade, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterTransitionDuration = _props.enterTransitionDuration,
	          leaveTransitionDuration = _props.leaveTransitionDuration,
	          onEnter = _props.onEnter,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterTransitionDuration', 'leaveTransitionDuration', 'onEnter', 'onEntering', 'onExit', 'theme']);
	
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        (0, _extends3.default)({
	          onEnter: this.handleEnter,
	          onEntering: this.handleEntering,
	          onExit: this.handleExit,
	          timeout: Math.max(enterTransitionDuration, leaveTransitionDuration) + 10,
	          transitionAppear: true
	        }, other),
	        children
	      );
	    }
	  }]);
	  return Fade;
	}(_react2.default.Component);
	
	Fade.defaultProps = {
	  in: false,
	  enterTransitionDuration: _transitions.duration.enteringScreen,
	  leaveTransitionDuration: _transitions.duration.leavingScreen,
	  theme: {}
	};
	Fade.propTypes =  false ? (_ref2 = {
	  enterTransitionDuration: require('prop-types').number.isRequired,
	  leaveTransitionDuration: require('prop-types').number.isRequired,
	  theme: require('prop-types').object.isRequired,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element),
	  in: require('prop-types').bool
	}, (0, _defineProperty3.default)(_ref2, 'enterTransitionDuration', require('prop-types').number), (0, _defineProperty3.default)(_ref2, 'leaveTransitionDuration', require('prop-types').number), (0, _defineProperty3.default)(_ref2, 'onEnter', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onEntering', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onEntered', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onExit', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onExiting', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'onExited', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref2, 'theme', require('prop-types').object), _ref2) : {};
	Fade.propTypes =  false ? (_ref3 = {
	  enterTransitionDuration: require('prop-types').number.isRequired,
	  leaveTransitionDuration: require('prop-types').number.isRequired,
	  theme: require('prop-types').object.isRequired,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element),
	  in: require('prop-types').bool
	}, (0, _defineProperty3.default)(_ref3, 'enterTransitionDuration', require('prop-types').number), (0, _defineProperty3.default)(_ref3, 'leaveTransitionDuration', require('prop-types').number), (0, _defineProperty3.default)(_ref3, 'onEnter', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onEntering', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onEntered', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onExit', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onExiting', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'onExited', typeof babelPluginFlowReactPropTypes_proptype_TransitionCallback === 'function' ? babelPluginFlowReactPropTypes_proptype_TransitionCallback : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_TransitionCallback)), (0, _defineProperty3.default)(_ref3, 'theme', require('prop-types').object), _ref3) : {};
	exports.default = (0, _withTheme2.default)(Fade);

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(67);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(139);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(55);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.capitalizeFirstLetter = capitalizeFirstLetter;
	exports.contains = contains;
	exports.findIndex = findIndex;
	exports.find = find;
	exports.createChainedFunction = createChainedFunction;
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function capitalizeFirstLetter(string) {
	   false ? (0, _warning2.default)(typeof string === 'string', 'Material-UI: capitalizeFirstLetter(string) expects a string argument.') : void 0;
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	} //  weak
	
	function contains(obj, pred) {
	  return (0, _keys2.default)(pred).every(function (key) {
	    return obj.hasOwnProperty(key) && obj[key] === pred[key];
	  });
	}
	
	function findIndex(arr, pred) {
	  var predType = typeof pred === 'undefined' ? 'undefined' : (0, _typeof3.default)(pred);
	  for (var i = 0; i < arr.length; i += 1) {
	    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
	      return i;
	    }
	    if (predType === 'object' && contains(arr[i], pred)) {
	      return i;
	    }
	    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
	      return arr.indexOf(pred);
	    }
	  }
	  return -1;
	}
	
	function find(arr, pred) {
	  var index = findIndex(arr, pred);
	  return index > -1 ? arr[index] : undefined;
	}
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (func) {
	    return func != null;
	  }).reduce(function (acc, func) {
	     false ? (0, _warning2.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
	
	    if (acc === null) {
	      return func;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, null);
	}

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.focusKeyPressed = focusKeyPressed;
	exports.detectKeyboardFocus = detectKeyboardFocus;
	exports.listenForFocusKeys = listenForFocusKeys;
	
	var _keycode = __webpack_require__(43);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _contains = __webpack_require__(92);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(63);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right']; //  weak
	
	var internal = {
	  listening: false,
	  focusKeyPressed: false
	};
	
	function isFocusKey(event) {
	  return FOCUS_KEYS.indexOf((0, _keycode2.default)(event)) !== -1;
	}
	
	function focusKeyPressed(pressed) {
	  if (typeof pressed !== 'undefined') {
	    internal.focusKeyPressed = Boolean(pressed);
	  }
	
	  return internal.focusKeyPressed;
	}
	
	function detectKeyboardFocus(instance, element, cb) {
	  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	  instance.keyboardFocusTimeout = setTimeout(function () {
	    if (focusKeyPressed() && (document.activeElement === element || (0, _contains2.default)(element, document.activeElement))) {
	      cb();
	    } else if (attempt < instance.keyboardFocusMaxCheckTimes) {
	      detectKeyboardFocus(instance, element, cb, attempt + 1);
	    }
	  }, instance.keyboardFocusCheckTime);
	}
	
	function listenForFocusKeys() {
	  if (!internal.listening) {
	    (0, _addEventListener2.default)(window, 'keyup', function (event) {
	      if (isFocusKey(event)) {
	        internal.focusKeyPressed = true;
	      }
	    });
	    internal.listening = true;
	  }
	}

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	//  weak
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount); // eslint-disable-line no-param-reassign
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isWidthDown = exports.isWidthUp = undefined;
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(117);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _debounce = __webpack_require__(98);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _createEagerFactory = __webpack_require__(45);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _wrapDisplayName = __webpack_require__(46);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _withTheme = __webpack_require__(51);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	var _createBreakpoints = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func; //  weak
	
	/**
	 * By default, returns true if screen width is the same or greater than the given breakpoint.
	 *
	 * @param screenWidth
	 * @param breakpoint
	 * @param inclusive - defaults to true
	 */
	var babelPluginFlowReactPropTypes_proptype_Breakpoint = __webpack_require__(24).babelPluginFlowReactPropTypes_proptype_Breakpoint || __webpack_require__(1).any;
	
	var isWidthUp = exports.isWidthUp = function isWidthUp(breakpoint, screenWidth) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(screenWidth);
	  }
	  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(screenWidth);
	};
	
	/**
	 * By default, returns true if screen width is the same or less than the given breakpoint.
	 *
	 * @param screenWidth
	 * @param breakpoint
	 * @param inclusive - defaults to true
	 */
	var isWidthDown = exports.isWidthDown = function isWidthDown(breakpoint, screenWidth) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(screenWidth) <= _createBreakpoints.keys.indexOf(breakpoint);
	  }
	  return _createBreakpoints.keys.indexOf(screenWidth) < _createBreakpoints.keys.indexOf(breakpoint);
	};
	
	function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$resizeInterv = options.resizeInterval,
	      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  function enhance(BaseComponent) {
	    var _ref2, _ref3;
	
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var Width = function (_React$Component) {
	      (0, _inherits3.default)(Width, _React$Component);
	
	      function Width() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Width);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Width.__proto__ || (0, _getPrototypeOf2.default)(Width)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: undefined
	        }, _this.handleResize = (0, _debounce2.default)(function () {
	          _this.updateWidth(window.innerWidth);
	        }, resizeInterval), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(Width, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth(window.innerWidth);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.handleResize.cancel();
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth(innerWidth) {
	          var breakpoints = this.props.theme.breakpoints;
	          var width = null;
	
	          /**
	           * Start with the slowest value as low end devices often have a small screen.
	           *
	           * innerWidth |0      xs      sm      md      lg      xl
	           *            |-------|-------|-------|-------|-------|------>
	           * width      |  xs   |  xs   |  sm   |  md   |  lg   |  xl
	           */
	          var index = 1;
	          while (width === null && index < breakpoints.keys.length) {
	            var currentWidth = breakpoints.keys[index];
	
	            // @media are inclusive, so reproduce the behavior here.
	            if (innerWidth < breakpoints.getWidth(currentWidth)) {
	              width = breakpoints.keys[index - 1];
	              break;
	            }
	
	            index += 1;
	          }
	
	          width = width || 'xl';
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              initialWidth = _props.initialWidth,
	              theme = _props.theme,
	              width = _props.width,
	              other = (0, _objectWithoutProperties3.default)(_props, ['initialWidth', 'theme', 'width']);
	
	          var props = (0, _extends3.default)({
	            width: width || this.state.width || initialWidth
	          }, other);
	
	          /**
	           * When rendering the component on the server,
	           * we have no idea about the client browser screen width.
	           * In order to prevent blinks and help the reconciliation of the React tree
	           * we are not rendering the child component.
	           *
	           * An alternative is to use the `initialWidth` property.
	           */
	          if (props.width === undefined) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            factory(props)
	          );
	        }
	      }]);
	      return Width;
	    }(_react2.default.Component);
	
	    Width.propTypes =  false ? (_ref2 = {
	      theme: require('prop-types').object.isRequired,
	      initialWidth: typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Breakpoint)
	    }, (0, _defineProperty3.default)(_ref2, 'theme', require('prop-types').object), (0, _defineProperty3.default)(_ref2, 'width', typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Breakpoint)), _ref2) : {};
	    Width.propTypes =  false ? (_ref3 = {
	      theme: require('prop-types').object.isRequired,
	      initialWidth: typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Breakpoint)
	    }, (0, _defineProperty3.default)(_ref3, 'theme', require('prop-types').object), (0, _defineProperty3.default)(_ref3, 'width', typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Breakpoint)), _ref3) : {};
	
	
	    if (false) {
	      Width.displayName = (0, _wrapDisplayName2.default)(BaseComponent, 'withWidth');
	    }
	
	    return (0, _withTheme2.default)(Width);
	  }
	
	  enhance.propTypes =  false ? babelPluginFlowReactPropTypes_proptype_ComponentType === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_ComponentType : {};
	  return enhance;
	}
	
	exports.default = withWidth;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(84);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = defineProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function defineProperty(o, p, attr) {
	  return (0, _defineProperty2.default)(o, p, attr);
	}

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(55);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(83);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(68);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(118);
	
	var supports = _interopRequireWildcard(_supports);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	/* eslint-disable prefer-spread */
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  if (supports.addEventListener) {
	    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	
	function off(target, eventName, callback, options) {
	  if (supports.removeEventListener) {
	    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);
	
	
	  (0, _keys2.default)(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_Component) {
	  (0, _inherits3.default)(EventListener, _Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react.Component);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
	} : {};
	exports.default = EventListener;

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;
	
	var _defineProperty = __webpack_require__(116);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
	var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;
	
	// IE8+ Support
	var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
	var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (e) {} // eslint-disable-line no-empty
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linkify = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _linkifyIt = __webpack_require__(599);
	
	var _linkifyIt2 = _interopRequireDefault(_linkifyIt);
	
	var _tlds = __webpack_require__(798);
	
	var _tlds2 = _interopRequireDefault(_tlds);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linkify = exports.linkify = new _linkifyIt2.default();
	linkify.tlds(_tlds2.default);
	
	var Linkify = function (_React$Component) {
	  _inherits(Linkify, _React$Component);
	
	  function Linkify() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Linkify);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Linkify.__proto__ || Object.getPrototypeOf(Linkify)).call.apply(_ref, [this].concat(args))), _this), _this.parseCounter = 0, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Linkify, [{
	    key: 'getMatches',
	    value: function getMatches(string) {
	      return linkify.match(string);
	    }
	  }, {
	    key: 'parseString',
	    value: function parseString(string) {
	      var _this2 = this;
	
	      var elements = [];
	      if (string === '') {
	        return elements;
	      }
	
	      var matches = this.getMatches(string);
	      if (!matches) {
	        return string;
	      }
	
	      var lastIndex = 0;
	      matches.forEach(function (match, idx) {
	        // Push the preceding text if there is any
	        if (match.index > lastIndex) {
	          elements.push(string.substring(lastIndex, match.index));
	        }
	        // Shallow update values that specified the match
	        var props = { href: match.url, key: 'parse' + _this2.parseCounter + 'match' + idx };
	        for (var key in _this2.props.properties) {
	          var val = _this2.props.properties[key];
	          if (val === Linkify.MATCH) {
	            val = match.url;
	          }
	
	          props[key] = val;
	        }
	        elements.push(_react2.default.createElement(_this2.props.component, props, match.text));
	        lastIndex = match.lastIndex;
	      });
	
	      if (lastIndex < string.length) {
	        elements.push(string.substring(lastIndex));
	      }
	
	      return elements.length === 1 ? elements[0] : elements;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(children) {
	      var _this3 = this;
	
	      var parsed = children;
	
	      if (typeof children === 'string') {
	        parsed = this.parseString(children);
	      } else if (_react2.default.isValidElement(children) && children.type !== 'a' && children.type !== 'button') {
	        parsed = _react2.default.cloneElement(children, { key: 'parse' + ++this.parseCounter }, this.parse(children.props.children));
	      } else if (children instanceof Array) {
	        parsed = children.map(function (child) {
	          return _this3.parse(child);
	        });
	      }
	
	      return parsed;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.parseCounter = 0;
	      var parsedChildren = this.parse(this.props.children);
	
	      return _react2.default.createElement(
	        'span',
	        { className: this.props.className },
	        parsedChildren
	      );
	    }
	  }]);
	
	  return Linkify;
	}(_react2.default.Component);
	
	Linkify.MATCH = 'LINKIFY_MATCH';
	Linkify.propTypes = {
	  className: _propTypes2.default.string,
	  component: _propTypes2.default.any,
	  properties: _propTypes2.default.object,
	  urlRegex: _propTypes2.default.object,
	  emailRegex: _propTypes2.default.object
	};
	Linkify.defaultProps = {
	  className: 'Linkify',
	  component: 'a',
	  properties: {}
	};
	exports.default = Linkify;


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(1);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var status = this.state.status;
	
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
	    if (this.nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (this.nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	
	      this.nextStatus = null;
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    this.setState(nextState, this.setNextCallback(callback));
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `apprear` only an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "enter" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them throguh if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifiying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifiying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifiying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

	module.exports = [
	  "aaa",
	  "aarp",
	  "abarth",
	  "abb",
	  "abbott",
	  "abbvie",
	  "abc",
	  "able",
	  "abogado",
	  "abudhabi",
	  "ac",
	  "academy",
	  "accenture",
	  "accountant",
	  "accountants",
	  "aco",
	  "active",
	  "actor",
	  "ad",
	  "adac",
	  "ads",
	  "adult",
	  "ae",
	  "aeg",
	  "aero",
	  "aetna",
	  "af",
	  "afamilycompany",
	  "afl",
	  "africa",
	  "ag",
	  "agakhan",
	  "agency",
	  "ai",
	  "aig",
	  "aigo",
	  "airbus",
	  "airforce",
	  "airtel",
	  "akdn",
	  "al",
	  "alfaromeo",
	  "alibaba",
	  "alipay",
	  "allfinanz",
	  "allstate",
	  "ally",
	  "alsace",
	  "alstom",
	  "am",
	  "americanexpress",
	  "americanfamily",
	  "amex",
	  "amfam",
	  "amica",
	  "amsterdam",
	  "analytics",
	  "android",
	  "anquan",
	  "anz",
	  "ao",
	  "aol",
	  "apartments",
	  "app",
	  "apple",
	  "aq",
	  "aquarelle",
	  "ar",
	  "arab",
	  "aramco",
	  "archi",
	  "army",
	  "arpa",
	  "art",
	  "arte",
	  "as",
	  "asda",
	  "asia",
	  "associates",
	  "at",
	  "athleta",
	  "attorney",
	  "au",
	  "auction",
	  "audi",
	  "audible",
	  "audio",
	  "auspost",
	  "author",
	  "auto",
	  "autos",
	  "avianca",
	  "aw",
	  "aws",
	  "ax",
	  "axa",
	  "az",
	  "azure",
	  "ba",
	  "baby",
	  "baidu",
	  "banamex",
	  "bananarepublic",
	  "band",
	  "bank",
	  "bar",
	  "barcelona",
	  "barclaycard",
	  "barclays",
	  "barefoot",
	  "bargains",
	  "baseball",
	  "basketball",
	  "bauhaus",
	  "bayern",
	  "bb",
	  "bbc",
	  "bbt",
	  "bbva",
	  "bcg",
	  "bcn",
	  "bd",
	  "be",
	  "beats",
	  "beauty",
	  "beer",
	  "bentley",
	  "berlin",
	  "best",
	  "bestbuy",
	  "bet",
	  "bf",
	  "bg",
	  "bh",
	  "bharti",
	  "bi",
	  "bible",
	  "bid",
	  "bike",
	  "bing",
	  "bingo",
	  "bio",
	  "biz",
	  "bj",
	  "black",
	  "blackfriday",
	  "blanco",
	  "blockbuster",
	  "blog",
	  "bloomberg",
	  "blue",
	  "bm",
	  "bms",
	  "bmw",
	  "bn",
	  "bnl",
	  "bnpparibas",
	  "bo",
	  "boats",
	  "boehringer",
	  "bofa",
	  "bom",
	  "bond",
	  "boo",
	  "book",
	  "booking",
	  "boots",
	  "bosch",
	  "bostik",
	  "boston",
	  "bot",
	  "boutique",
	  "box",
	  "br",
	  "bradesco",
	  "bridgestone",
	  "broadway",
	  "broker",
	  "brother",
	  "brussels",
	  "bs",
	  "bt",
	  "budapest",
	  "bugatti",
	  "build",
	  "builders",
	  "business",
	  "buy",
	  "buzz",
	  "bv",
	  "bw",
	  "by",
	  "bz",
	  "bzh",
	  "ca",
	  "cab",
	  "cafe",
	  "cal",
	  "call",
	  "calvinklein",
	  "cam",
	  "camera",
	  "camp",
	  "cancerresearch",
	  "canon",
	  "capetown",
	  "capital",
	  "capitalone",
	  "car",
	  "caravan",
	  "cards",
	  "care",
	  "career",
	  "careers",
	  "cars",
	  "cartier",
	  "casa",
	  "case",
	  "caseih",
	  "cash",
	  "casino",
	  "cat",
	  "catering",
	  "catholic",
	  "cba",
	  "cbn",
	  "cbre",
	  "cbs",
	  "cc",
	  "cd",
	  "ceb",
	  "center",
	  "ceo",
	  "cern",
	  "cf",
	  "cfa",
	  "cfd",
	  "cg",
	  "ch",
	  "chanel",
	  "channel",
	  "chase",
	  "chat",
	  "cheap",
	  "chintai",
	  "christmas",
	  "chrome",
	  "chrysler",
	  "church",
	  "ci",
	  "cipriani",
	  "circle",
	  "cisco",
	  "citadel",
	  "citi",
	  "citic",
	  "city",
	  "cityeats",
	  "ck",
	  "cl",
	  "claims",
	  "cleaning",
	  "click",
	  "clinic",
	  "clinique",
	  "clothing",
	  "cloud",
	  "club",
	  "clubmed",
	  "cm",
	  "cn",
	  "co",
	  "coach",
	  "codes",
	  "coffee",
	  "college",
	  "cologne",
	  "com",
	  "comcast",
	  "commbank",
	  "community",
	  "company",
	  "compare",
	  "computer",
	  "comsec",
	  "condos",
	  "construction",
	  "consulting",
	  "contact",
	  "contractors",
	  "cooking",
	  "cookingchannel",
	  "cool",
	  "coop",
	  "corsica",
	  "country",
	  "coupon",
	  "coupons",
	  "courses",
	  "cr",
	  "credit",
	  "creditcard",
	  "creditunion",
	  "cricket",
	  "crown",
	  "crs",
	  "cruise",
	  "cruises",
	  "csc",
	  "cu",
	  "cuisinella",
	  "cv",
	  "cw",
	  "cx",
	  "cy",
	  "cymru",
	  "cyou",
	  "cz",
	  "dabur",
	  "dad",
	  "dance",
	  "data",
	  "date",
	  "dating",
	  "datsun",
	  "day",
	  "dclk",
	  "dds",
	  "de",
	  "deal",
	  "dealer",
	  "deals",
	  "degree",
	  "delivery",
	  "dell",
	  "deloitte",
	  "delta",
	  "democrat",
	  "dental",
	  "dentist",
	  "desi",
	  "design",
	  "dev",
	  "dhl",
	  "diamonds",
	  "diet",
	  "digital",
	  "direct",
	  "directory",
	  "discount",
	  "discover",
	  "dish",
	  "diy",
	  "dj",
	  "dk",
	  "dm",
	  "dnp",
	  "do",
	  "docs",
	  "doctor",
	  "dodge",
	  "dog",
	  "doha",
	  "domains",
	  "dot",
	  "download",
	  "drive",
	  "dtv",
	  "dubai",
	  "duck",
	  "dunlop",
	  "duns",
	  "dupont",
	  "durban",
	  "dvag",
	  "dvr",
	  "dz",
	  "earth",
	  "eat",
	  "ec",
	  "eco",
	  "edeka",
	  "edu",
	  "education",
	  "ee",
	  "eg",
	  "email",
	  "emerck",
	  "energy",
	  "engineer",
	  "engineering",
	  "enterprises",
	  "epost",
	  "epson",
	  "equipment",
	  "er",
	  "ericsson",
	  "erni",
	  "es",
	  "esq",
	  "estate",
	  "esurance",
	  "et",
	  "etisalat",
	  "eu",
	  "eurovision",
	  "eus",
	  "events",
	  "everbank",
	  "exchange",
	  "expert",
	  "exposed",
	  "express",
	  "extraspace",
	  "fage",
	  "fail",
	  "fairwinds",
	  "faith",
	  "family",
	  "fan",
	  "fans",
	  "farm",
	  "farmers",
	  "fashion",
	  "fast",
	  "fedex",
	  "feedback",
	  "ferrari",
	  "ferrero",
	  "fi",
	  "fiat",
	  "fidelity",
	  "fido",
	  "film",
	  "final",
	  "finance",
	  "financial",
	  "fire",
	  "firestone",
	  "firmdale",
	  "fish",
	  "fishing",
	  "fit",
	  "fitness",
	  "fj",
	  "fk",
	  "flickr",
	  "flights",
	  "flir",
	  "florist",
	  "flowers",
	  "fly",
	  "fm",
	  "fo",
	  "foo",
	  "food",
	  "foodnetwork",
	  "football",
	  "ford",
	  "forex",
	  "forsale",
	  "forum",
	  "foundation",
	  "fox",
	  "fr",
	  "free",
	  "fresenius",
	  "frl",
	  "frogans",
	  "frontdoor",
	  "frontier",
	  "ftr",
	  "fujitsu",
	  "fujixerox",
	  "fun",
	  "fund",
	  "furniture",
	  "futbol",
	  "fyi",
	  "ga",
	  "gal",
	  "gallery",
	  "gallo",
	  "gallup",
	  "game",
	  "games",
	  "gap",
	  "garden",
	  "gb",
	  "gbiz",
	  "gd",
	  "gdn",
	  "ge",
	  "gea",
	  "gent",
	  "genting",
	  "george",
	  "gf",
	  "gg",
	  "ggee",
	  "gh",
	  "gi",
	  "gift",
	  "gifts",
	  "gives",
	  "giving",
	  "gl",
	  "glade",
	  "glass",
	  "gle",
	  "global",
	  "globo",
	  "gm",
	  "gmail",
	  "gmbh",
	  "gmo",
	  "gmx",
	  "gn",
	  "godaddy",
	  "gold",
	  "goldpoint",
	  "golf",
	  "goo",
	  "goodhands",
	  "goodyear",
	  "goog",
	  "google",
	  "gop",
	  "got",
	  "gov",
	  "gp",
	  "gq",
	  "gr",
	  "grainger",
	  "graphics",
	  "gratis",
	  "green",
	  "gripe",
	  "grocery",
	  "group",
	  "gs",
	  "gt",
	  "gu",
	  "guardian",
	  "gucci",
	  "guge",
	  "guide",
	  "guitars",
	  "guru",
	  "gw",
	  "gy",
	  "hair",
	  "hamburg",
	  "hangout",
	  "haus",
	  "hbo",
	  "hdfc",
	  "hdfcbank",
	  "health",
	  "healthcare",
	  "help",
	  "helsinki",
	  "here",
	  "hermes",
	  "hgtv",
	  "hiphop",
	  "hisamitsu",
	  "hitachi",
	  "hiv",
	  "hk",
	  "hkt",
	  "hm",
	  "hn",
	  "hockey",
	  "holdings",
	  "holiday",
	  "homedepot",
	  "homegoods",
	  "homes",
	  "homesense",
	  "honda",
	  "honeywell",
	  "horse",
	  "hospital",
	  "host",
	  "hosting",
	  "hot",
	  "hoteles",
	  "hotels",
	  "hotmail",
	  "house",
	  "how",
	  "hr",
	  "hsbc",
	  "ht",
	  "hu",
	  "hughes",
	  "hyatt",
	  "hyundai",
	  "ibm",
	  "icbc",
	  "ice",
	  "icu",
	  "id",
	  "ie",
	  "ieee",
	  "ifm",
	  "ikano",
	  "il",
	  "im",
	  "imamat",
	  "imdb",
	  "immo",
	  "immobilien",
	  "in",
	  "industries",
	  "infiniti",
	  "info",
	  "ing",
	  "ink",
	  "institute",
	  "insurance",
	  "insure",
	  "int",
	  "intel",
	  "international",
	  "intuit",
	  "investments",
	  "io",
	  "ipiranga",
	  "iq",
	  "ir",
	  "irish",
	  "is",
	  "iselect",
	  "ismaili",
	  "ist",
	  "istanbul",
	  "it",
	  "itau",
	  "itv",
	  "iveco",
	  "iwc",
	  "jaguar",
	  "java",
	  "jcb",
	  "jcp",
	  "je",
	  "jeep",
	  "jetzt",
	  "jewelry",
	  "jio",
	  "jlc",
	  "jll",
	  "jm",
	  "jmp",
	  "jnj",
	  "jo",
	  "jobs",
	  "joburg",
	  "jot",
	  "joy",
	  "jp",
	  "jpmorgan",
	  "jprs",
	  "juegos",
	  "juniper",
	  "kaufen",
	  "kddi",
	  "ke",
	  "kerryhotels",
	  "kerrylogistics",
	  "kerryproperties",
	  "kfh",
	  "kg",
	  "kh",
	  "ki",
	  "kia",
	  "kim",
	  "kinder",
	  "kindle",
	  "kitchen",
	  "kiwi",
	  "km",
	  "kn",
	  "koeln",
	  "komatsu",
	  "kosher",
	  "kp",
	  "kpmg",
	  "kpn",
	  "kr",
	  "krd",
	  "kred",
	  "kuokgroup",
	  "kw",
	  "ky",
	  "kyoto",
	  "kz",
	  "la",
	  "lacaixa",
	  "ladbrokes",
	  "lamborghini",
	  "lamer",
	  "lancaster",
	  "lancia",
	  "lancome",
	  "land",
	  "landrover",
	  "lanxess",
	  "lasalle",
	  "lat",
	  "latino",
	  "latrobe",
	  "law",
	  "lawyer",
	  "lb",
	  "lc",
	  "lds",
	  "lease",
	  "leclerc",
	  "lefrak",
	  "legal",
	  "lego",
	  "lexus",
	  "lgbt",
	  "li",
	  "liaison",
	  "lidl",
	  "life",
	  "lifeinsurance",
	  "lifestyle",
	  "lighting",
	  "like",
	  "lilly",
	  "limited",
	  "limo",
	  "lincoln",
	  "linde",
	  "link",
	  "lipsy",
	  "live",
	  "living",
	  "lixil",
	  "lk",
	  "loan",
	  "loans",
	  "locker",
	  "locus",
	  "loft",
	  "lol",
	  "london",
	  "lotte",
	  "lotto",
	  "love",
	  "lpl",
	  "lplfinancial",
	  "lr",
	  "ls",
	  "lt",
	  "ltd",
	  "ltda",
	  "lu",
	  "lundbeck",
	  "lupin",
	  "luxe",
	  "luxury",
	  "lv",
	  "ly",
	  "ma",
	  "macys",
	  "madrid",
	  "maif",
	  "maison",
	  "makeup",
	  "man",
	  "management",
	  "mango",
	  "map",
	  "market",
	  "marketing",
	  "markets",
	  "marriott",
	  "marshalls",
	  "maserati",
	  "mattel",
	  "mba",
	  "mc",
	  "mckinsey",
	  "md",
	  "me",
	  "med",
	  "media",
	  "meet",
	  "melbourne",
	  "meme",
	  "memorial",
	  "men",
	  "menu",
	  "meo",
	  "merckmsd",
	  "metlife",
	  "mg",
	  "mh",
	  "miami",
	  "microsoft",
	  "mil",
	  "mini",
	  "mint",
	  "mit",
	  "mitsubishi",
	  "mk",
	  "ml",
	  "mlb",
	  "mls",
	  "mm",
	  "mma",
	  "mn",
	  "mo",
	  "mobi",
	  "mobile",
	  "mobily",
	  "moda",
	  "moe",
	  "moi",
	  "mom",
	  "monash",
	  "money",
	  "monster",
	  "mopar",
	  "mormon",
	  "mortgage",
	  "moscow",
	  "moto",
	  "motorcycles",
	  "mov",
	  "movie",
	  "movistar",
	  "mp",
	  "mq",
	  "mr",
	  "ms",
	  "msd",
	  "mt",
	  "mtn",
	  "mtr",
	  "mu",
	  "museum",
	  "mutual",
	  "mv",
	  "mw",
	  "mx",
	  "my",
	  "mz",
	  "na",
	  "nab",
	  "nadex",
	  "nagoya",
	  "name",
	  "nationwide",
	  "natura",
	  "navy",
	  "nba",
	  "nc",
	  "ne",
	  "nec",
	  "net",
	  "netbank",
	  "netflix",
	  "network",
	  "neustar",
	  "new",
	  "newholland",
	  "news",
	  "next",
	  "nextdirect",
	  "nexus",
	  "nf",
	  "nfl",
	  "ng",
	  "ngo",
	  "nhk",
	  "ni",
	  "nico",
	  "nike",
	  "nikon",
	  "ninja",
	  "nissan",
	  "nissay",
	  "nl",
	  "no",
	  "nokia",
	  "northwesternmutual",
	  "norton",
	  "now",
	  "nowruz",
	  "nowtv",
	  "np",
	  "nr",
	  "nra",
	  "nrw",
	  "ntt",
	  "nu",
	  "nyc",
	  "nz",
	  "obi",
	  "observer",
	  "off",
	  "office",
	  "okinawa",
	  "olayan",
	  "olayangroup",
	  "oldnavy",
	  "ollo",
	  "om",
	  "omega",
	  "one",
	  "ong",
	  "onl",
	  "online",
	  "onyourside",
	  "ooo",
	  "open",
	  "oracle",
	  "orange",
	  "org",
	  "organic",
	  "origins",
	  "osaka",
	  "otsuka",
	  "ott",
	  "ovh",
	  "pa",
	  "page",
	  "panasonic",
	  "panerai",
	  "paris",
	  "pars",
	  "partners",
	  "parts",
	  "party",
	  "passagens",
	  "pay",
	  "pccw",
	  "pe",
	  "pet",
	  "pf",
	  "pfizer",
	  "pg",
	  "ph",
	  "pharmacy",
	  "phd",
	  "philips",
	  "phone",
	  "photo",
	  "photography",
	  "photos",
	  "physio",
	  "piaget",
	  "pics",
	  "pictet",
	  "pictures",
	  "pid",
	  "pin",
	  "ping",
	  "pink",
	  "pioneer",
	  "pizza",
	  "pk",
	  "pl",
	  "place",
	  "play",
	  "playstation",
	  "plumbing",
	  "plus",
	  "pm",
	  "pn",
	  "pnc",
	  "pohl",
	  "poker",
	  "politie",
	  "porn",
	  "post",
	  "pr",
	  "pramerica",
	  "praxi",
	  "press",
	  "prime",
	  "pro",
	  "prod",
	  "productions",
	  "prof",
	  "progressive",
	  "promo",
	  "properties",
	  "property",
	  "protection",
	  "pru",
	  "prudential",
	  "ps",
	  "pt",
	  "pub",
	  "pw",
	  "pwc",
	  "py",
	  "qa",
	  "qpon",
	  "quebec",
	  "quest",
	  "qvc",
	  "racing",
	  "radio",
	  "raid",
	  "re",
	  "read",
	  "realestate",
	  "realtor",
	  "realty",
	  "recipes",
	  "red",
	  "redstone",
	  "redumbrella",
	  "rehab",
	  "reise",
	  "reisen",
	  "reit",
	  "reliance",
	  "ren",
	  "rent",
	  "rentals",
	  "repair",
	  "report",
	  "republican",
	  "rest",
	  "restaurant",
	  "review",
	  "reviews",
	  "rexroth",
	  "rich",
	  "richardli",
	  "ricoh",
	  "rightathome",
	  "ril",
	  "rio",
	  "rip",
	  "rmit",
	  "ro",
	  "rocher",
	  "rocks",
	  "rodeo",
	  "rogers",
	  "room",
	  "rs",
	  "rsvp",
	  "ru",
	  "rugby",
	  "ruhr",
	  "run",
	  "rw",
	  "rwe",
	  "ryukyu",
	  "sa",
	  "saarland",
	  "safe",
	  "safety",
	  "sakura",
	  "sale",
	  "salon",
	  "samsclub",
	  "samsung",
	  "sandvik",
	  "sandvikcoromant",
	  "sanofi",
	  "sap",
	  "sapo",
	  "sarl",
	  "sas",
	  "save",
	  "saxo",
	  "sb",
	  "sbi",
	  "sbs",
	  "sc",
	  "sca",
	  "scb",
	  "schaeffler",
	  "schmidt",
	  "scholarships",
	  "school",
	  "schule",
	  "schwarz",
	  "science",
	  "scjohnson",
	  "scor",
	  "scot",
	  "sd",
	  "se",
	  "search",
	  "seat",
	  "secure",
	  "security",
	  "seek",
	  "select",
	  "sener",
	  "services",
	  "ses",
	  "seven",
	  "sew",
	  "sex",
	  "sexy",
	  "sfr",
	  "sg",
	  "sh",
	  "shangrila",
	  "sharp",
	  "shaw",
	  "shell",
	  "shia",
	  "shiksha",
	  "shoes",
	  "shop",
	  "shopping",
	  "shouji",
	  "show",
	  "showtime",
	  "shriram",
	  "si",
	  "silk",
	  "sina",
	  "singles",
	  "site",
	  "sj",
	  "sk",
	  "ski",
	  "skin",
	  "sky",
	  "skype",
	  "sl",
	  "sling",
	  "sm",
	  "smart",
	  "smile",
	  "sn",
	  "sncf",
	  "so",
	  "soccer",
	  "social",
	  "softbank",
	  "software",
	  "sohu",
	  "solar",
	  "solutions",
	  "song",
	  "sony",
	  "soy",
	  "space",
	  "spiegel",
	  "spot",
	  "spreadbetting",
	  "sr",
	  "srl",
	  "srt",
	  "st",
	  "stada",
	  "staples",
	  "star",
	  "starhub",
	  "statebank",
	  "statefarm",
	  "statoil",
	  "stc",
	  "stcgroup",
	  "stockholm",
	  "storage",
	  "store",
	  "stream",
	  "studio",
	  "study",
	  "style",
	  "su",
	  "sucks",
	  "supplies",
	  "supply",
	  "support",
	  "surf",
	  "surgery",
	  "suzuki",
	  "sv",
	  "swatch",
	  "swiftcover",
	  "swiss",
	  "sx",
	  "sy",
	  "sydney",
	  "symantec",
	  "systems",
	  "sz",
	  "tab",
	  "taipei",
	  "talk",
	  "taobao",
	  "target",
	  "tatamotors",
	  "tatar",
	  "tattoo",
	  "tax",
	  "taxi",
	  "tc",
	  "tci",
	  "td",
	  "tdk",
	  "team",
	  "tech",
	  "technology",
	  "tel",
	  "telecity",
	  "telefonica",
	  "temasek",
	  "tennis",
	  "teva",
	  "tf",
	  "tg",
	  "th",
	  "thd",
	  "theater",
	  "theatre",
	  "tiaa",
	  "tickets",
	  "tienda",
	  "tiffany",
	  "tips",
	  "tires",
	  "tirol",
	  "tj",
	  "tjmaxx",
	  "tjx",
	  "tk",
	  "tkmaxx",
	  "tl",
	  "tm",
	  "tmall",
	  "tn",
	  "to",
	  "today",
	  "tokyo",
	  "tools",
	  "top",
	  "toray",
	  "toshiba",
	  "total",
	  "tours",
	  "town",
	  "toyota",
	  "toys",
	  "tr",
	  "trade",
	  "trading",
	  "training",
	  "travel",
	  "travelchannel",
	  "travelers",
	  "travelersinsurance",
	  "trust",
	  "trv",
	  "tt",
	  "tube",
	  "tui",
	  "tunes",
	  "tushu",
	  "tv",
	  "tvs",
	  "tw",
	  "tz",
	  "ua",
	  "ubank",
	  "ubs",
	  "uconnect",
	  "ug",
	  "uk",
	  "unicom",
	  "university",
	  "uno",
	  "uol",
	  "ups",
	  "us",
	  "uy",
	  "uz",
	  "va",
	  "vacations",
	  "vana",
	  "vanguard",
	  "vc",
	  "ve",
	  "vegas",
	  "ventures",
	  "verisign",
	  "versicherung",
	  "vet",
	  "vg",
	  "vi",
	  "viajes",
	  "video",
	  "vig",
	  "viking",
	  "villas",
	  "vin",
	  "vip",
	  "virgin",
	  "visa",
	  "vision",
	  "vista",
	  "vistaprint",
	  "viva",
	  "vivo",
	  "vlaanderen",
	  "vn",
	  "vodka",
	  "volkswagen",
	  "volvo",
	  "vote",
	  "voting",
	  "voto",
	  "voyage",
	  "vu",
	  "vuelos",
	  "wales",
	  "walmart",
	  "walter",
	  "wang",
	  "wanggou",
	  "warman",
	  "watch",
	  "watches",
	  "weather",
	  "weatherchannel",
	  "webcam",
	  "weber",
	  "website",
	  "wed",
	  "wedding",
	  "weibo",
	  "weir",
	  "wf",
	  "whoswho",
	  "wien",
	  "wiki",
	  "williamhill",
	  "win",
	  "windows",
	  "wine",
	  "winners",
	  "wme",
	  "wolterskluwer",
	  "woodside",
	  "work",
	  "works",
	  "world",
	  "wow",
	  "ws",
	  "wtc",
	  "wtf",
	  "xbox",
	  "xerox",
	  "xfinity",
	  "xihuan",
	  "xin",
	  "कॉम", // xn--11b4c3d
	  "セール", // xn--1ck2e1b
	  "佛山", // xn--1qqw23a
	  "ಭಾರತ", // xn--2scrj9c
	  "慈善", // xn--30rr7y
	  "集团", // xn--3bst00m
	  "在线", // xn--3ds443g
	  "한국", // xn--3e0b707e
	  "ଭାରତ", // xn--3hcrj9c
	  "大众汽车", // xn--3oq18vl8pn36a
	  "点看", // xn--3pxu8k
	  "คอม", // xn--42c2d9a
	  "ভাৰত", // xn--45br5cyl
	  "ভারত", // xn--45brj9c
	  "八卦", // xn--45q11c
	  "موقع", // xn--4gbrim
	  "বাংলা", // xn--54b7fta0cc
	  "公益", // xn--55qw42g
	  "公司", // xn--55qx5d
	  "香格里拉", // xn--5su34j936bgsg
	  "网站", // xn--5tzm5g
	  "移动", // xn--6frz82g
	  "我爱你", // xn--6qq986b3xl
	  "москва", // xn--80adxhks
	  "қаз", // xn--80ao21a
	  "католик", // xn--80aqecdr1a
	  "онлайн", // xn--80asehdb
	  "сайт", // xn--80aswg
	  "联通", // xn--8y0a063a
	  "срб", // xn--90a3ac
	  "бг", // xn--90ae
	  "бел", // xn--90ais
	  "קום", // xn--9dbq2a
	  "时尚", // xn--9et52u
	  "微博", // xn--9krt00a
	  "淡马锡", // xn--b4w605ferd
	  "ファッション", // xn--bck1b9a5dre4c
	  "орг", // xn--c1avg
	  "नेट", // xn--c2br7g
	  "ストア", // xn--cck2b3b
	  "삼성", // xn--cg4bki
	  "சிங்கப்பூர்", // xn--clchc0ea0b2g2a9gcd
	  "商标", // xn--czr694b
	  "商店", // xn--czrs0t
	  "商城", // xn--czru2d
	  "дети", // xn--d1acj3b
	  "мкд", // xn--d1alf
	  "ею", // xn--e1a4c
	  "ポイント", // xn--eckvdtc9d
	  "新闻", // xn--efvy88h
	  "工行", // xn--estv75g
	  "家電", // xn--fct429k
	  "كوم", // xn--fhbei
	  "中文网", // xn--fiq228c5hs
	  "中信", // xn--fiq64b
	  "中国", // xn--fiqs8s
	  "中國", // xn--fiqz9s
	  "娱乐", // xn--fjq720a
	  "谷歌", // xn--flw351e
	  "భారత్", // xn--fpcrj9c3d
	  "ලංකා", // xn--fzc2c9e2c
	  "電訊盈科", // xn--fzys8d69uvgm
	  "购物", // xn--g2xx48c
	  "クラウド", // xn--gckr3f0f
	  "ભારત", // xn--gecrj9c
	  "通販", // xn--gk3at1e
	  "भारतम्", // xn--h2breg3eve
	  "भारत", // xn--h2brj9c
	  "भारोत", // xn--h2brj9c8c
	  "网店", // xn--hxt814e
	  "संगठन", // xn--i1b6b1a6a2e
	  "餐厅", // xn--imr513n
	  "网络", // xn--io0a7i
	  "ком", // xn--j1aef
	  "укр", // xn--j1amh
	  "香港", // xn--j6w193g
	  "诺基亚", // xn--jlq61u9w7b
	  "食品", // xn--jvr189m
	  "飞利浦", // xn--kcrx77d1x4a
	  "台湾", // xn--kprw13d
	  "台灣", // xn--kpry57d
	  "手表", // xn--kpu716f
	  "手机", // xn--kput3i
	  "мон", // xn--l1acc
	  "الجزائر", // xn--lgbbat1ad8j
	  "عمان", // xn--mgb9awbf
	  "ارامكو", // xn--mgba3a3ejt
	  "ایران", // xn--mgba3a4f16a
	  "العليان", // xn--mgba7c0bbn0a
	  "اتصالات", // xn--mgbaakc7dvf
	  "امارات", // xn--mgbaam7a8h
	  "بازار", // xn--mgbab2bd
	  "پاکستان", // xn--mgbai9azgqp6j
	  "الاردن", // xn--mgbayh7gpa
	  "موبايلي", // xn--mgbb9fbpob
	  "بارت", // xn--mgbbh1a
	  "بھارت", // xn--mgbbh1a71e
	  "المغرب", // xn--mgbc0a9azcg
	  "ابوظبي", // xn--mgbca7dzdo
	  "السعودية", // xn--mgberp4a5d4ar
	  "ڀارت", // xn--mgbgu82a
	  "كاثوليك", // xn--mgbi4ecexp
	  "سودان", // xn--mgbpl2fh
	  "همراه", // xn--mgbt3dhd
	  "عراق", // xn--mgbtx2b
	  "مليسيا", // xn--mgbx4cd0ab
	  "澳門", // xn--mix891f
	  "닷컴", // xn--mk1bu44c
	  "政府", // xn--mxtq1m
	  "شبكة", // xn--ngbc5azd
	  "بيتك", // xn--ngbe9e0a
	  "عرب", // xn--ngbrx
	  "გე", // xn--node
	  "机构", // xn--nqv7f
	  "组织机构", // xn--nqv7fs00ema
	  "健康", // xn--nyqy26a
	  "ไทย", // xn--o3cw4h
	  "سورية", // xn--ogbpf8fl
	  "рус", // xn--p1acf
	  "рф", // xn--p1ai
	  "珠宝", // xn--pbt977c
	  "تونس", // xn--pgbs0dh
	  "大拿", // xn--pssy2u
	  "みんな", // xn--q9jyb4c
	  "グーグル", // xn--qcka1pmc
	  "ελ", // xn--qxam
	  "世界", // xn--rhqv96g
	  "書籍", // xn--rovu88b
	  "ഭാരതം", // xn--rvc1e0am3e
	  "ਭਾਰਤ", // xn--s9brj9c
	  "网址", // xn--ses554g
	  "닷넷", // xn--t60b56a
	  "コム", // xn--tckwe
	  "天主教", // xn--tiq49xqyj
	  "游戏", // xn--unup4y
	  "vermögensberater", // xn--vermgensberater-ctb
	  "vermögensberatung", // xn--vermgensberatung-pwb
	  "企业", // xn--vhquv
	  "信息", // xn--vuq861b
	  "嘉里大酒店", // xn--w4r85el8fhu5dnra
	  "嘉里", // xn--w4rs40l
	  "مصر", // xn--wgbh1c
	  "قطر", // xn--wgbl6a
	  "广东", // xn--xhq521b
	  "இலங்கை", // xn--xkc2al3hye2a
	  "இந்தியா", // xn--xkc2dl3a5ee0h
	  "հայ", // xn--y9a3aq
	  "新加坡", // xn--yfro4i67o
	  "فلسطين", // xn--ygbi2ammx
	  "政务", // xn--zfr164b
	  "xperia",
	  "xxx",
	  "xyz",
	  "yachts",
	  "yahoo",
	  "yamaxun",
	  "yandex",
	  "ye",
	  "yodobashi",
	  "yoga",
	  "yokohama",
	  "you",
	  "youtube",
	  "yt",
	  "yun",
	  "za",
	  "zappos",
	  "zara",
	  "zero",
	  "zip",
	  "zippo",
	  "zm",
	  "zone",
	  "zuerich",
	  "zw"
	];


/***/ }),

/***/ 799:
/***/ (function(module, exports) {

	module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

	module.exports=/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E44\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),

/***/ 801:
/***/ (function(module, exports) {

	module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/

/***/ }),

/***/ 802:
/***/ (function(module, exports) {

	module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(18);
	
	var _link = __webpack_require__(54);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _i18n = __webpack_require__(23);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _Icon = __webpack_require__(654);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Dialog = __webpack_require__(194);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _reactHelmet = __webpack_require__(229);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(77);
	
	__webpack_require__(687);
	
	var _all = __webpack_require__(578);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _reactLinkify = __webpack_require__(759);
	
	var _reactLinkify2 = _interopRequireDefault(_reactLinkify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// ----------------------------------------------------------------
	//     レイアウト/トップレベル
	// ----------------------------------------------------------------
	
	/**
	 * タイムテーブルのセッションをクリックしたのかどうかを管理します。
	 * この変数はセッションをクリックしたタイミングで true になり、
	 * その後セッションのダイアログが閉じたタイミングで false になります。
	 *
	 * グローバル変数にしているのは、history の変化を超えて管理できるスコープが他に思いつかなかったためです。
	 * state で管理できるのであればそちらの方が望ましいと思っています。
	 */
	var sessionClicked = false;
	
	exports.default = (0, _reactRouter.withRouter)(function (_React$Component) {
	  _inherits(Proposals, _React$Component);
	
	  function Proposals(props) {
	    _classCallCheck(this, Proposals);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { sessionId: _this.findSessionId(props.location) };
	    return _this;
	  }
	
	  /**
	   * URL からダイアログ表示したいセッションの ID を取得します。
	   */
	
	
	  Proposals.prototype.findSessionId = function findSessionId(location) {
	    var match = /session=(\d+)/.exec(location.search);
	    return match ? match[1] : null;
	  };
	
	  Proposals.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // history を使って ?sessionId が付与された場合、再描画がされたりはしないので
	    // 手動で state を更新します。
	    //
	    // また、ダイアログが閉じている場合には sessionClicked を false にします。
	    this.cleanupHandler = this.props.history.listen(function (location) {
	      var sessionId = _this2.findSessionId(location);
	      if (!sessionId) sessionClicked = false;
	      _this2.setState({ sessionId: sessionId });
	    });
	  };
	
	  Proposals.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.cleanupHandler != null) this.cleanupHandler();
	  };
	
	  Proposals.prototype.onExitDialog = function onExitDialog() {
	    var _props = this.props,
	        history = _props.history,
	        location = _props.location;
	    // タイムテーブルを開きますが、ダイアログの開き方によって少しだけ動作が変わります。
	    //
	    // - タイムテーブルからダイアログが開かれた場合 … ブラウザの履歴を戻ります。
	    // - その他の場合(URL直で開かれた場合など) … 通常の遷移をします。
	
	    if (sessionClicked) {
	      history.goBack();
	    } else {
	      history.push((0, _i18n.withPrefix)((0, _i18n.resolve)(location, '/timetable')));
	    }
	  };
	
	  Proposals.prototype.render = function render() {
	    var _this3 = this;
	
	    var location = this.props.location;
	    var sessionId = this.state.sessionId;
	
	    var ln = (0, _i18n.lang)(location);
	    var rooms1 = new Rooms(_all2.default.rooms);
	    var rooms2 = new Rooms(_all2.default.rooms.filter(function (r) {
	      return r.name !== 'Hall';
	    }));
	    var categories = new Categories(_all2.default.categories, ln);
	    var day1 = [].concat(_all2.default.sessions.filter(function (s) {
	      return s.startsAt.match(/^2018-02-08T.*/);
	    }).map(toSessionInfo), SPECIAL_SESSIONS_DAY1);
	    var day2 = [].concat(_all2.default.sessions.filter(function (s) {
	      return s.startsAt.match(/^2018-02-09T.*/);
	    }).map(toSessionInfo), SPECIAL_SESSIONS_DAY2);
	    var speakers = new Speakers(_all2.default.speakers);
	    var dialogSession = sessionId && _all2.default.sessions.find(function (s) {
	      return s.id === sessionId;
	    }) || {};
	
	    return _react2.default.createElement(
	      'div',
	      { lang: ln, className: 'bg-gray2' },
	      _react2.default.createElement(_i18n.TitleDescription, { texts: {
	          en: {
	            title: 'Timetable'
	          },
	          ja: {
	            title: 'タイムテーブル'
	          }
	        } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'subpage-title-wrapper bg-white' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'text-yellow1' },
	          _react2.default.createElement(Text, { id: 'title' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'timetable-container' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'timetable-day-anchors' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#day1' },
	              'DAY.01'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#day2' },
	              'DAY.02'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'timetable-container2 timetable-column-8' },
	          _react2.default.createElement(
	            'h2',
	            { id: 'day1', className: 'timetable-title', title: '2018/02/08' },
	            'DAY.01 (Feb\xA08th,\xA02018)'
	          ),
	          _react2.default.createElement(Timetable, { sessions: day1, rooms: rooms1, categories: categories, speakers: speakers })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'timetable-container2 timetable-column-7' },
	          _react2.default.createElement(
	            'h2',
	            { id: 'day2', className: 'timetable-title', title: '2018/02/09' },
	            'DAY.02 (Feb\xA09th,\xA02018)'
	          ),
	          _react2.default.createElement(Timetable, { sessions: day2, rooms: rooms2, categories: categories, speakers: speakers })
	        )
	      ),
	      _react2.default.createElement(SessionDetail, {
	        sessionizeSession: dialogSession,
	        rooms: rooms1,
	        categories: categories,
	        speakers: speakers,
	        onExit: function onExit() {
	          return _this3.onExitDialog();
	        }
	      })
	    );
	  };
	
	  return Proposals;
	}(_react2.default.Component));
	
	
	var Text = (0, _i18n2.default)({
	  en: {
	    title: 'Timetable',
	    video: 'Video',
	    slide: 'Slide',
	    error: {
	      fetchProposals: 'Failed to retrieve items.'
	    },
	    level: {
	      beginner: _react2.default.createElement(
	        'span',
	        { className: 'timetable-level-beginner' },
	        'Beginner'
	      ),
	      expert: _react2.default.createElement(
	        'span',
	        { className: 'timetable-level-expert' },
	        'Intermediate/Expert'
	      ),
	      niche: _react2.default.createElement(
	        'span',
	        { className: 'timetable-level-niche' },
	        'Niche Topic'
	      )
	    },
	    session: {
	      welcomeTalk: 'Welcome Talk',
	      party: '🎉 Party 🎉',
	      lunch: '🍱 Lunch 🍱'
	    }
	  },
	  ja: {
	    title: 'タイムテーブル',
	    video: '動画',
	    slide: '資料',
	    error: {
	      fetchProposals: '一覧の取得に失敗しました。'
	    },
	    level: {
	      beginner: _react2.default.createElement(
	        'span',
	        { className: 'timetable-level-beginner' },
	        '\u521D\u5FC3\u8005\u5411\u3051'
	      ),
	      expert: _react2.default.createElement(
	        'span',
	        { className: 'timetable-level-expert' },
	        '\u4E2D\u30FB\u4E0A\u7D1A\u8005\u5411\u3051'
	      ),
	      niche: _react2.default.createElement(
	        'span',
	        { className: 'timetable-level-niche' },
	        '\u30CB\u30C3\u30C1'
	      )
	    },
	    session: {
	      welcomeTalk: 'ウェルカムトーク',
	      party: '🎉 パーティ 🎉',
	      lunch: '🍱 ランチ 🍱'
	    }
	  }
	});
	
	// ----------------------------------------------------------------
	//     レイアウト/タイムテーブル描画
	// ----------------------------------------------------------------
	
	var Timetable = function (_React$Component2) {
	  _inherits(Timetable, _React$Component2);
	
	  function Timetable() {
	    _classCallCheck(this, Timetable);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  Timetable.prototype.render = function render() {
	    var _this5 = this;
	
	    var _props2 = this.props,
	        rooms = _props2.rooms,
	        sessions = _props2.sessions;
	
	    var data = new TimetableData(sessions, rooms);
	
	    return _react2.default.createElement(
	      'table',
	      { className: 'timetable-table' },
	      _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement('th', null),
	          data.rooms.names.map(function (n) {
	            return _react2.default.createElement(
	              'th',
	              { key: n },
	              n
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'tbody',
	        null,
	        data.rows.map(function (_ref) {
	          var time = _ref.time,
	              sessions = _ref.sessions;
	          return _react2.default.createElement(
	            'tr',
	            { key: time },
	            _react2.default.createElement(
	              'th',
	              null,
	              time
	            ),
	            sessions.map(function (c, i) {
	              return _this5.renderSessions(c, i);
	            })
	          );
	        })
	      )
	    );
	  };
	
	  /**
	   * セッション情報を表示します。
	   *
	   * @param {Object} session セッション情報、もしくはセッションがない場合は { key: … }
	   * @param {Object} [session.sessionizeSession] Sessionize 形式のセッション情報
	   * @param {number} [session.span] セルの高さ
	   * @param {number} [session.key] セッションがない場合にタグの key 属性を渡します
	   */
	
	
	  Timetable.prototype.renderSessions = function renderSessions(session, key) {
	    var _this6 = this;
	
	    var _ref2 = session || {},
	        sessionizeSession = _ref2.sessionizeSession,
	        special = _ref2.special,
	        startsAt = _ref2.startsAt,
	        endsAt = _ref2.endsAt,
	        span = _ref2.span;
	
	    switch (special) {
	      case 'welcomeTalk':
	        return _react2.default.createElement(TableItem, {
	          key: key,
	          lang: 'JA',
	          span: 1,
	          height: 'short',
	          title: _react2.default.createElement(Text, { id: 'session.welcomeTalk' }),
	          duration: toDuration(startsAt, endsAt),
	          room: 'Hall' });
	      case 'party':
	        return _react2.default.createElement(TableItem, {
	          key: key,
	          span: 1,
	          height: 'long',
	          title: _react2.default.createElement(Text, { id: 'session.party' }),
	          duration: toDuration(startsAt, endsAt),
	          room: 'Hall' });
	      case 'lunch':
	        return _react2.default.createElement(
	          'td',
	          { key: key, colSpan: this.props.rooms.length, className: 'timetable-cell-break' },
	          _react2.default.createElement(Text, { id: 'session.lunch' }),
	          ' (',
	          toDuration(startsAt, endsAt),
	          'min)'
	        );
	    }
	
	    if (sessionizeSession) {
	      var categories = this.props.categories.of(sessionizeSession.categoryItems);
	      var room = this.props.rooms.name(sessionizeSession.roomId);
	      var speakers = sessionizeSession.speakers.map(function (s) {
	        return _this6.props.speakers.of(s).name;
	      });
	      return _react2.default.createElement(TableItem, {
	        key: sessionizeSession.id,
	        span: span,
	        sessionLang: categories.lang,
	        duration: toDuration(startsAt, endsAt),
	        level: categories.level,
	        room: room,
	        title: sessionizeSession.title,
	        speaker: speakers.join(', '),
	        topic: categories.topic,
	        id: sessionizeSession.id,
	        link: '/timetable?session=' + sessionizeSession.id,
	        message: sessionizeSession.message
	      });
	    }
	
	    return _react2.default.createElement('td', { key: key, className: 'timetable-cell timetable-sm-none' });
	  };
	
	  return Timetable;
	}(_react2.default.Component);
	
	// ----------------------------------------------------------------
	//     レイアウト/タイムテーブルの項目
	// ----------------------------------------------------------------
	
	/**
	 * セッションをテーブルに描画します
	 */
	
	
	var TableItem = (0, _reactRouter.withRouter)(function TableItem(_ref3) {
	  var history = _ref3.history,
	      location = _ref3.location,
	      id = _ref3.id,
	      title = _ref3.title,
	      speaker = _ref3.speaker,
	      duration = _ref3.duration,
	      level = _ref3.level,
	      room = _ref3.room,
	      sessionLang = _ref3.sessionLang,
	      topic = _ref3.topic,
	      span = _ref3.span,
	      height = _ref3.height,
	      link = _ref3.link,
	      message = _ref3.message;
	
	  var heightClass = 'timetable-cell-height-' + (height || span);
	  var content = [_react2.default.createElement(
	    'p',
	    { key: '1', className: 'timetable-session-header' },
	    sessionLang ? _react2.default.createElement(
	      'span',
	      { className: 'timetable-lang-' + sessionLang.toLowerCase() },
	      sessionLang.toUpperCase()
	    ) : [],
	    _react2.default.createElement(
	      'span',
	      { className: 'timetable-session-duration' },
	      room,
	      '\u30FB',
	      duration,
	      'min'
	    )
	  ), _react2.default.createElement(
	    'h3',
	    { key: '2', className: 'timetable-session-title' },
	    title
	  ), _react2.default.createElement(
	    'p',
	    { key: '3', className: 'timetable-session-speaker' },
	    speaker
	  ), _react2.default.createElement(
	    'p',
	    { key: '4', className: 'timetable-session-categories' },
	    level,
	    ' ' /* react は二つの要素の間スペースが消去されるらしい…回避策としてスペースをあえて付与 */,
	    topic ? _react2.default.createElement(
	      'span',
	      { className: 'timetable-category' },
	      topic
	    ) : []
	  )];
	  if (message) {
	    var msg = message[(0, _i18n.lang)(location)];
	    if (msg) {
	      content.push(_react2.default.createElement(
	        'p',
	        { className: 'timetable-session-message' },
	        (0, _i18n.textToElement)(msg, true)
	      ));
	    }
	  }
	  var onClick = function onClick(e) {
	    sessionClicked = true;
	
	    // <Link> を使うとなぜか1秒くらい待たされる現象が起きています。
	    // 回避策として、手動で遷移を行います。
	    // (/timetable/?session=~ の URL は Gatsby で生成していない URL だからかもしれません)
	    //
	    // なお React ではクリックイベントのハンドラで false を返してもイベントが伝搬して
	    // しまうようです。対策として preventDefault() などを手動で呼び出しています。
	    // 参考: https://reactjs.org/docs/handling-events.html
	    history.push((0, _i18n.withPrefix)((0, _i18n.resolve)(location, link)));
	    e.preventDefault();
	    e.stopPropagation();
	  };
	
	  return _react2.default.createElement(
	    'td',
	    { className: 'timetable-cell ' + heightClass, rowSpan: span },
	    _react2.default.createElement(
	      'div',
	      { className: 'timetable-session-card', to: link },
	      link ? _react2.default.createElement(
	        _link2.default,
	        { to: link, className: 'timetable-session-link' },
	        _react2.default.createElement(
	          'div',
	          { onClick: onClick },
	          content
	        )
	      ) : content
	    )
	  );
	});
	
	// ----------------------------------------------------------------
	//     レイアウト/ダイアログ
	// ----------------------------------------------------------------
	
	var SessionDetail = (0, _reactRouter.withRouter)(function (_ref4) {
	  var location = _ref4.location,
	      sessionizeSession = _ref4.sessionizeSession,
	      categories = _ref4.categories,
	      rooms = _ref4.rooms,
	      speakers = _ref4.speakers,
	      onExit = _ref4.onExit;
	
	  if (!sessionizeSession.id) return _react2.default.createElement(_Dialog2.default, null);
	
	  var category = categories.of(sessionizeSession.categoryItems);
	  var room = rooms.name(sessionizeSession.roomId);
	  var title = sessionizeSession.title;
	  var time = timeToLongTextFormat(sessionizeSession.startsAt, sessionizeSession.endsAt);
	  var speakersDetail = sessionizeSession.speakers.map(function (s) {
	    return speakers.of(s);
	  });
	  var msg = sessionizeSession.message ? sessionizeSession.message[(0, _i18n.lang)(location)] : null;
	  var videoUrl = sessionizeSession.videoUrl;
	  var slideUrl = sessionizeSession.slideUrl;
	
	  return _react2.default.createElement(
	    _Dialog2.default,
	    { open: true, maxWidth: 'md', onBackdropClick: onExit },
	    _react2.default.createElement(_reactHelmet2.default, { title: title + ' | DroidKaigi 2018' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'timetable-dialog' },
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: '32px', marginBottom: '32px' } },
	        _react2.default.createElement(
	          'h2',
	          { className: 'timetable-dialog-title' },
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'timetable-dialog-subtitle' },
	          _react2.default.createElement(
	            'span',
	            { className: 'timetable-dialog-lang-' + category.lang },
	            category.lang.toUpperCase()
	          ),
	          ' ' /* react は二つの要素の間スペースが消去されるらしい…回避策としてスペースをあえて付与 */,
	          _react2.default.createElement(
	            'span',
	            null,
	            room
	          ),
	          ' － ',
	          _react2.default.createElement(
	            'span',
	            null,
	            time
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'timetable-dialog-categories' },
	          category.level,
	          _react2.default.createElement(
	            'span',
	            { className: 'timetable-category' },
	            category.topic
	          )
	        ),
	        function () {
	          if (videoUrl || slideUrl) {
	            return _react2.default.createElement(
	              'p',
	              { className: 'timetable-dialog-categories text-gray' },
	              _react2.default.createElement(
	                _Icon2.default,
	                { className: 'timetable-link-icon' },
	                'link'
	              ),
	              videoUrl ? _react2.default.createElement(
	                'a',
	                { className: 'timetable-doc-link', href: videoUrl, target: '_blank' },
	                _react2.default.createElement(
	                  _Icon2.default,
	                  { className: 'timetable-icon' },
	                  'local_movies'
	                ),
	                _react2.default.createElement(Text, { id: 'video' })
	              ) : null,
	              slideUrl ? _react2.default.createElement(
	                'a',
	                { className: 'timetable-doc-link', href: slideUrl, target: '_blank' },
	                _react2.default.createElement(
	                  _Icon2.default,
	                  { className: 'timetable-icon' },
	                  'insert_drive_file'
	                ),
	                _react2.default.createElement(Text, { id: 'slide' })
	              ) : null
	            );
	          }
	        }(),
	        msg ? _react2.default.createElement(
	          'p',
	          { className: 'timetable-dialog-message timetable-session-message' },
	          (0, _i18n.textToElement)(msg, true)
	        ) : null,
	        _react2.default.createElement(
	          'p',
	          { className: 'timetable-dialog-body' },
	          _react2.default.createElement(AutoLink, { text: sessionizeSession.description })
	        ),
	        speakersDetail.map(function (s, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'timetable-dialog-speaker-top' },
	            _react2.default.createElement(
	              'div',
	              { className: 'timetable-dialog-speaker-imagebox' },
	              s.profilePicture ? _react2.default.createElement('img', { style: { width: '100%' }, src: s.profilePicture }) : []
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h3',
	                { className: 'timetable-dialog-top-content' },
	                s.name
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'timetable-dialog-tagline' },
	                s.tagLine
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'timetable-dialog-paragraph text-gray' },
	                s.links.length ? _react2.default.createElement(
	                  _Icon2.default,
	                  { className: 'timetable-link-icon' },
	                  'link'
	                ) : [],
	                s.links.map(function (l) {
	                  return _react2.default.createElement(
	                    'a',
	                    { key: l.url, target: '_blank', href: l.url, className: 'timetable-link-text' },
	                    l.title
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'timetable-dialog-body' },
	                _react2.default.createElement(AutoLink, { text: s.bio })
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	});
	
	function AutoLink(_ref5) {
	  var text = _ref5.text;
	
	  return _react2.default.createElement(
	    _reactLinkify2.default,
	    { properties: { target: '_blank' } },
	    text
	  );
	}
	
	function timeToLongTextFormat(start, end) {
	  var s = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/.exec(start);
	  var e = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/.exec(end);
	  return s[1] + '/' + s[2] + '/' + s[3] + ' ' + s[4] + ':' + s[5] + '-' + e[4] + ':' + e[5];
	}
	
	// ----------------------------------------------------------------
	//     各種表示データ/低レベル情報(部屋、スピーカー、カテゴリ)
	// ----------------------------------------------------------------
	
	var ROOM_ID_HALL = 513;
	var ROOM_ID_SPONSORS = 521;
	
	/**
	 * 使用する部屋の集合を管理します。
	 *
	 * ## データ形式について
	 * 
	 * `this.values` には sessionize で提供された形式でデータが入っています。
	 * このクラスではこの形式を隠蔽し、各メソッドは適宜加工された表現を返します。
	 */
	
	var Rooms = function () {
	  function Rooms(sessionizeRooms) {
	    _classCallCheck(this, Rooms);
	
	    // Sessionize の部屋の一覧は不要なスポンサールームも含まれているので除外します。
	    this.values = sessionizeRooms.filter(function (r) {
	      return r.id !== ROOM_ID_SPONSORS;
	    }).sort(function (r1, r2) {
	      return r1.sort - r2.sort;
	    });
	  }
	
	  Rooms.prototype.name = function name(id) {
	    return this.names[this.indexOf(id)];
	  };
	
	  Rooms.prototype.room = function room(id) {
	    return this.values.find(function (r) {
	      return r.id === id;
	    });
	  };
	
	  Rooms.prototype.indexOf = function indexOf(id) {
	    return this.values.findIndex(function (r) {
	      return r.id === id;
	    });
	  };
	
	  _createClass(Rooms, [{
	    key: 'length',
	    get: function get() {
	      return this.values.length;
	    }
	  }, {
	    key: 'names',
	    get: function get() {
	      // Sessionize のデータは Room 1 A+B のような名前になっているので、A+B を除去
	      // 命名ルールが変わるとこちら側の変更も必須です
	      return this.values.map(function (r) {
	        return r.name.replace(/(Room \d+).*/, '$1');
	      });
	    }
	  }]);
	
	  return Rooms;
	}();
	
	/**
	 * スピーカー情報の集合を管理します。
	 */
	
	
	var Speakers = function () {
	  function Speakers(sessionizeSpeakers) {
	    _classCallCheck(this, Speakers);
	
	    var values = {};
	    for (var _iterator = sessionizeSpeakers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref6;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref6 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref6 = _i.value;
	      }
	
	      var s = _ref6;
	
	      values[s.id] = {
	        name: s.fullName,
	        tagLine: s.tagLine,
	        bio: s.bio,
	        profilePicture: s.profilePicture,
	        links: s.links
	      };
	    }
	
	    this.values = values;
	  }
	
	  Speakers.prototype.of = function of(id) {
	    return this.values[id];
	  };
	
	  return Speakers;
	}();
	
	/**
	 * 時間情報の集合を管理します。
	 * 
	 * ## データ形式について
	 * 
	 * `this.values` には `2018-02-08T10:00:00` のような形式でデータが入っています。
	 * このクラスではこの形式を隠蔽し、各メソッドは適宜加工された表現を返します。
	 */
	
	
	var TimeBlocks = function () {
	  function TimeBlocks(times) {
	    _classCallCheck(this, TimeBlocks);
	
	    var timeSet = {};
	    for (var _iterator2 = times, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	      var _ref7;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref7 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref7 = _i2.value;
	      }
	
	      var s = _ref7;
	
	      timeSet[s] = true;
	    }
	
	    this.values = Object.keys(timeSet).sort();
	  }
	
	  TimeBlocks.prototype.indexOf = function indexOf(time) {
	    return this.values.findIndex(function (t) {
	      return t === time;
	    });
	  };
	
	  TimeBlocks.prototype.indexAfter = function indexAfter(time) {
	    var res = this.values.findIndex(function (t) {
	      return t >= time;
	    });
	    return res === -1 ? this.values.length : res;
	  };
	
	  _createClass(TimeBlocks, [{
	    key: 'times',
	    get: function get() {
	      return this.values.map(function (t) {
	        return t.replace(/^.*T(\d\d:\d\d):.*/, '$1');
	      });
	    }
	  }]);
	
	  return TimeBlocks;
	}();
	
	function toDuration(startsAt, endsAt) {
	  return (new Date(endsAt).getTime() - new Date(startsAt).getTime()) / (60 * 1000);
	}
	
	/**
	 * カテゴリ情報の集合を管理します。
	 *
	 * ## データ形式について
	 * 
	 * sessionize はカテゴリの種類(Language など)と各カテゴリ(Englishなど)
	 * の入れ子構造でデータを渡します。
	 * 
	 * 一方、このクラスは以下のようにタイムライン表示に最適化した形に加工したカテゴリ情報を提供します
	 * (`of` メソッド参照)。
	 * 
	 * ```
	 * {
	 *   lang: 'ja',
	 *   duration: '50',
	 *   topic: '…',
	 *   level: 'niche'
	 * }
	 * ```
	 *
	 * 内部表現は { category: '(カテゴリの種類)', value: '各カテゴリの値' } の配列となっています。
	 */
	
	var Categories = function () {
	  function Categories(sessionizeCategories, lang) {
	    _classCallCheck(this, Categories);
	
	    var items = {};
	    for (var _iterator3 = sessionizeCategories, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	      var _ref8;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref8 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref8 = _i3.value;
	      }
	
	      var c = _ref8;
	
	      for (var _iterator4 = c.items, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	        var _ref10;
	
	        if (_isArray4) {
	          if (_i4 >= _iterator4.length) break;
	          _ref10 = _iterator4[_i4++];
	        } else {
	          _i4 = _iterator4.next();
	          if (_i4.done) break;
	          _ref10 = _i4.value;
	        }
	
	        var _ref9 = _ref10;
	        var id = _ref9.id,
	            name = _ref9.name;
	
	        switch (c.title) {
	          case 'Language':
	            var langId = id === 3482 ? 'en' : id === 3483 ? 'ja' : 'mixed';
	            items[id] = { category: 'lang', value: langId };
	            break;
	          case 'Session format':
	            var minutes = name.replace(/minutes$/, '');
	            items[id] = { category: 'duration', value: minutes };
	            break;
	          case 'トピック / Topic':
	            items[id] = { category: 'topic', value: this.parseJaAndEn(name, lang) };
	            break;
	          case 'Level':
	            var levelId = id === 3542 ? 'niche' : id === 3541 ? 'expert' : 'beginner';
	            items[id] = { category: 'level', value: _react2.default.createElement(Text, { id: 'level.' + levelId }) };
	            break;
	        }
	      }
	    }
	    this.items = items;
	  }
	
	  /**
	   * Sessionize データ形式(`(日本語) / (英語)`) から現在の言語のテキストを抽出します。
	   */
	
	
	  Categories.prototype.parseJaAndEn = function parseJaAndEn(jaAndEn, lang) {
	    var match = /(.+) \/ (.+)/.exec(jaAndEn);
	    if (match) {
	      return lang === 'ja' ? match[1] : match[2];
	    } else {
	      return jaAndEn;
	    }
	  };
	
	  Categories.prototype.of = function of(categoryIds) {
	    var res = {};
	    for (var _iterator5 = categoryIds, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
	      var _ref11;
	
	      if (_isArray5) {
	        if (_i5 >= _iterator5.length) break;
	        _ref11 = _iterator5[_i5++];
	      } else {
	        _i5 = _iterator5.next();
	        if (_i5.done) break;
	        _ref11 = _i5.value;
	      }
	
	      var i = _ref11;
	      var _items$i = this.items[i],
	          category = _items$i.category,
	          value = _items$i.value;
	
	      res[category] = value;
	    }
	    return res;
	  };
	
	  return Categories;
	}();
	
	// ----------------------------------------------------------------
	//     各種表示データ/特別セッション
	// ----------------------------------------------------------------
	
	//
	// ### セッション情報の形式
	//
	// {
	//   startsAt: '(日付形式)',
	//   endsAt: '(日付形式)',
	//   roomId: '(Sessionize で提供している部屋の ID、部屋がない場合は undefined)',
	//   special: '特別セッションを識別するための文字列。講演・ハンズオンの場合は undefined',
	//   sessionizeSession: 'Sessionize から受け取った講演情報。特別セッションの場合は undefined'
	// }
	//
	
	/**
	 * 1日目の特別セッション
	 */
	
	
	var SPECIAL_SESSIONS_DAY1 = [{ special: 'welcomeTalk', startsAt: '2018-02-08T10:00:00', endsAt: '2018-02-08T10:20:00', roomId: ROOM_ID_HALL }, { special: 'lunch', startsAt: '2018-02-08T11:50:00', endsAt: '2018-02-08T12:50:00' }, { special: 'party', startsAt: '2018-02-08T17:40:00', endsAt: '2018-02-08T19:40:00', roomId: ROOM_ID_HALL }];
	
	/**
	 * 2日目の特別セッション
	 */
	var SPECIAL_SESSIONS_DAY2 = [{ special: 'lunch', startsAt: '2018-02-09T11:50:00', endsAt: '2018-02-09T12:50:00' }];
	
	/**
	 * Sessionize 形式の講演・ハンズオン情報を、本モジュールで使う形式でラップします。
	 */
	function toSessionInfo(sessionizeSession) {
	  return {
	    startsAt: sessionizeSession.startsAt,
	    endsAt: sessionizeSession.endsAt,
	    roomId: sessionizeSession.roomId,
	    sessionizeSession: sessionizeSession
	  };
	}
	
	// ----------------------------------------------------------------
	//     各種表示データ/タイムテーブル用データ
	// ----------------------------------------------------------------
	
	/**
	 * タイムテーブル表示で、特に要素を割り当てる必要が無いことを表します。
	 */
	var ALREADY_FILLED = 'ALREADY_FILLED';
	
	/**
	 * タイムテーブル表示に最適化した形でグループ化されたセッション情報です。
	 */
	
	var TimetableData = function () {
	  function TimetableData(sessions, rooms) {
	    _classCallCheck(this, TimetableData);
	
	    var timeBlocks = new TimeBlocks(sessions.map(function (s) {
	      return s.startsAt;
	    }));
	    var res = timeBlocks.times.map(function () {
	      return new Array(rooms.length);
	    });
	    for (var _iterator6 = sessions, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
	      var _ref12;
	
	      if (_isArray6) {
	        if (_i6 >= _iterator6.length) break;
	        _ref12 = _iterator6[_i6++];
	      } else {
	        _i6 = _iterator6.next();
	        if (_i6.done) break;
	        _ref12 = _i6.value;
	      }
	
	      var session = _ref12;
	
	      var room = rooms.indexOf(session.roomId);
	      var start = timeBlocks.indexOf(session.startsAt);
	      var span = timeBlocks.indexAfter(session.endsAt) - start;
	
	      res[start][room] = _extends({}, session, { span: span });
	      if (room === -1) {
	        // 全ての部屋に流れるもの
	        res[start][0] = _extends({}, session, { span: span });
	        for (var i = 1; i < rooms.length; ++i) {
	          res[start][i] = ALREADY_FILLED;
	        }
	      } else {
	        // 特定の部屋に流れるもの
	        for (var _i7 = 1; _i7 < span; ++_i7) {
	          res[start + _i7][room] = ALREADY_FILLED;
	        }
	      }
	    }
	
	    this.rooms = rooms;
	    this.timeBlocks = timeBlocks;
	    this.cells = res;
	  }
	
	  _createClass(TimetableData, [{
	    key: 'rows',
	    get: function get() {
	      var _this7 = this;
	
	      return this.timeBlocks.times.map(function (time, i) {
	        var r = _this7.cells[i];
	        var sessions = _this7.rooms.names.map(function (_, i) {
	          return r[i];
	        }).filter(function (c) {
	          return c !== ALREADY_FILLED;
	        });
	
	        return { time: time, sessions: sessions };
	      });
	    }
	  }]);

	  return TimetableData;
	}();

	module.exports = exports['default'];

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18n = __webpack_require__(23);
	
	var _gatsbyLink = __webpack_require__(93);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRouter = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * リンクを提供します。
	 *
	 * リンク先の URL は現在の言語設定を考慮して切り替わります。
	 */
	exports.default = (0, _reactRouter.withRouter)(function Link(_ref) {
	  var location = _ref.location,
	      to = _ref.to,
	      rest = _objectWithoutProperties(_ref, ['location', 'to']);
	
	  return _react2.default.createElement(_gatsbyLink2.default, _extends({ to: (0, _i18n.resolve)(location, to) }, rest));
	});
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-timetable-js-6c7735a0b8eb84fabd18.js